export default {
    common: {
        response_400: "Bad Request",
        response_401:
            "Your Session Has Expired. Please Login Again to Continue.",
        response_403: "Access Denied, You May Not Have Permission",
        response_404: "Resource Not Found",
        response_405: "Request Method Not Allowed",
        response_408: "Request Timed Out",
        response_429: "Too Many Attempts. Try Again Later.",
        response_500: "Server-Side Errors",
        response_501: "Not Implemented",
        response_502: "Network Error",
        response_503: "Service Unavailable",
        response_504: "Network Timeout",
        response_505: "HTTP Version Not Supported",
        response_59574:
            "Projects containing files that have not been pre-translated are not available for download.",
        response_default: "Connection Error, CODE: {code}",
        network_error: "Processing Failed. Please Check Your Network",
        notice_title: "Notice",
        notice_message_1:
            "Invalid Submission, Please Refresh Your Screen And Try Again.",
        notice_message_2: "The Task Has Timed Out.",
        notice_button_1: "Refresh Page",
        notice_button_2: "Return To Task List",
        notice_button_3: "Confirm",
        exception_message_1: "URL Is Not Imported!",
        country_code_list: [
            {
                name: "Albania",
                code: "355",
            },
            // {name: '阿根廷', code: '54'},
            // {name: '阿拉伯联合酋长国', code: '971'},
            // {name: '阿鲁巴', code: '297'},
            // {name: '爱尔兰', code: '353'},
            {
                name: "Estonia",
                code: "372",
            },
            // {name: '安道尔', code: '376'},
            // {name: '安哥拉', code: '244'},
            // {name: '安圭拉', code: '1264'},
            // {name: '安提瓜和巴布达', code: '1268'},
            // {name: '奥地利', code: '43'},
            {
                name: "Australia",
                code: "61",
            },
            // {name: '巴巴多斯', code: '1246'},
            // {name: '巴布亚新几内亚', code: '675'},
            // {name: '巴哈马', code: '1242'},
            // {name: '巴拉圭', code: '595'},
            // {name: '巴林', code: '973'},
            // {name: '巴拿马', code: '507'},
            // {name: '巴西', code: '55'},
            // {name: '百慕大群岛', code: '1441'},
            {
                name: "Bulgaria",
                code: "359",
            },
            // {name: '比利时', code: '32'},
            // {name: '冰岛', code: '354'},
            // {name: '波多黎各', code: '1787'},
            {
                name: "Poland",
                code: "48",
            },
            // {name: '波斯尼亚和黑塞哥维那', code: '387'},
            // {name: '伯利兹', code: '501'},
            // {name: '博茨瓦纳', code: '267'},
            // {name: '布基纳法索', code: '226'},
            // {name: '布隆迪', code: '257'},
            // {name: '朝鲜', code: '850'},
            // {name: '赤道几内亚', code: '240'},
            {
                name: "Denmark",
                code: "45",
            },
            // {name: '东帝汶', code: '670'},
            // {name: '多哥', code: '228'},
            // {name: '多米尼加共和国', code: '1809'},
            // {name: '多米尼克', code: '1767'},
            // {name: '厄立特里亚', code: '291'},
            {
                name: "France",
                code: "33",
            },
            // {name: '法罗群岛', code: '298'},
            // {name: '斐济', code: '679'},
            {
                name: "Finland",
                code: "358",
            },
            // {name: '佛得角', code: '238'},
            // {name: '冈比亚', code: '220'},
            // {name: '刚果共和国', code: '242'},
            // {name: '刚果民主共和国（扎伊尔）', code: '243'},
            // {name: '哥伦比亚', code: '57'},
            // {name: '哥斯达黎加', code: '506'},
            // {name: '格林纳达', code: '1473'},
            // {name: '格陵兰岛', code: '299'},
            // {name: '古巴', code: '53'},
            // {name: '关岛', code: '1671'},
            // {name: '圭亚那', code: '592'},
            // {name: '哈萨克斯坦', code: '997'},
            // {name: '海地', code: '509'},
            {
                name: "South Korea",
                code: "82",
            },
            {
                name: "Netherlands",
                code: "31",
            },
            // {name: '黑山', code: '382'},
            // {name: '洪都拉斯', code: '504'},
            // {name: '基里巴斯', code: '686'},
            // {name: '吉布提', code: '253'},
            // {name: '几内亚', code: '224'},
            // {name: '几内亚比绍共和国', code: '245'},
            {
                name: "Canada",
                code: "1",
            },
            // {name: '加蓬', code: '241'},
            {
                name: "Czech",
                code: "420",
            },
            // {name: '津巴布韦', code: '263'},
            // {name: '喀麦隆', code: '237'},
            // {name: '卡塔尔', code: '974'},
            // {name: '开曼群岛', code: '1345'},
            // {name: '科摩罗', code: '269'},
            // {name: '科特迪瓦', code: '225'},
            {
                name: "Croatia",
                code: "385",
            },
            // {name: '肯尼亚', code: '254'},
            // {name: '拉脱维亚', code: '371'},
            // {name: '莱索托', code: '266'},
            {
                name: "Laos",
                code: "856",
            },
            {
                name: "Lithuania",
                code: "370",
            },
            // {name: '利比里亚', code: '231'},
            // {name: '列支敦士登', code: '423'},
            // {name: '卢森堡', code: '352'},
            // {name: '卢旺达', code: '250'},
            {
                name: "Romania",
                code: "40",
            },
            // {name: '马达加斯加', code: '261'},
            // {name: '马尔代夫', code: '960'},
            // {name: '马耳他', code: '356'},
            {
                name: "Malaysia",
                code: "60",
            },
            // {name: '马里亚纳群岛', code: '1670'},
            {
                name: "Macedonia",
                code: "389",
            },
            // {name: '马约特', code: '262'},
            // {name: '毛里求斯', code: '230'},
            {
                name: "United States",
                code: "1",
            },
            // {name: '美属萨摩亚', code: '1684'},
            // {name: '美属维尔京群岛', code: '1340'},
            // {name: '蒙特塞拉特岛', code: '1664'},
            // {name: '秘鲁', code: '51'},
            // {name: '密克罗尼西亚', code: '691'},
            // {name: '摩尔多瓦', code: '373'},
            // {name: '摩洛哥', code: '212'},
            // {name: '摩纳哥', code: '377'},
            // {name: '莫桑比克', code: '258'},
            // {name: '墨西哥', code: '52'},
            // {name: '纳米比亚', code: '264'},
            // {name: '南非', code: '27'},
            // {name: '南苏丹', code: '211'},
            // {name: '尼加拉瓜', code: '505'},
            // {name: '尼日尔', code: '227'},
            // {name: '挪威', code: '47'},
            // {name: '诺福克岛', code: '6723'},
            // {name: '帕劳', code: '680'},
            {
                name: "Portugal",
                code: "351",
            },
            {
                name: "Japan",
                code: "81",
            },
            {
                name: "Sweden",
                code: "46",
            },
            // {name: '瑞士', code: '41'},
            // {name: '萨尔瓦多', code: '503'},
            // {name: '萨摩亚', code: '685'},
            // {name: '塞尔维亚', code: '381'},
            {
                name: "Sierra Leone",
                code: "232",
            },
            // {name: '塞浦路斯', code: '357'},
            // {name: '塞舌尔', code: '248'},
            // {name: '沙特阿拉伯', code: '966'},
            // {name: '圣彼埃尔和密克隆岛', code: '508'},
            // {name: '圣多美和普林西比', code: '239'},
            // {name: '圣基茨和尼维斯', code: '1869'},
            // {name: '圣卢西亚', code: '1758'},
            // {name: '圣马丁岛（荷兰部分）', code: '1721'},
            // {name: '圣马力诺', code: '378'},
            // {name: '圣文森特和格林纳丁斯', code: '1784'},
            {
                name: "Slovakia",
                code: "421",
            },
            // {name: '斯洛文尼亚', code: '386'},
            // {name: '斯威士兰', code: '268'},
            // {name: '苏里南', code: '597'},
            // {name: '所罗门群岛', code: '677'},
            {
                name: "Thailand",
                code: "66",
            },
            // {name: '坦桑尼亚', code: '255'},
            // {name: '汤加', code: '676'},
            // {name: '特克斯和凯科斯群岛', code: '1649'},
            // {name: '特立尼达和多巴哥', code: '1868'},
            {
                name: "Turkey",
                code: "90",
            },
            // {name: '瓦努阿图', code: '678'},
            // {name: '危地马拉', code: '502'},
            // {name: '委内瑞拉', code: '58'},
            // {name: '文莱', code: '673'},
            // {name: '乌拉圭', code: '598'},
            {
                name: "Spain",
                code: "34",
            },
            {
                name: "Greece",
                code: "30",
            },
            {
                name: "Singapore",
                code: "65",
            },
            // {name: '新喀里多尼亚', code: '687'},
            {
                name: "Hungary",
                code: "36",
            },
            // {name: '牙买加', code: '1876'},
            {
                name: "Italy",
                code: "39",
            },
            {
                name: "India",
                code: "91",
            },
            {
                name: "United Kingdom",
                code: "44",
            },
            // {name: '英属维尔京群岛', code: '1284'},
            {
                name: "Vietnam",
                code: "84",
            },
            // {name: '赞比亚', code: '260'},
            // {name: '直布罗陀', code: '350'},
            // {name: '智利', code: '56'},
            // {name: '中非共和国', code: '236'},
            {
                name: "Macau (China)",
                code: "853",
            },
            {
                name: "Chinese Mainland",
                code: "86",
            },
            {
                name: "Taiwan (China)",
                code: "886",
            },
            {
                name: "Hong Kong (China)",
                code: "852",
            },
        ],
        notfind_page_btn_1: "Back to homepage",
    },
    component: {
        LanguageSelector_autoLang_result: "Detected {name}",
        LanguageSelector_autoLang_label: "Auto Detect",
        LanguageSelector_button_exchang: "Click to Switch",
        LanguageSelector_source_language_name: "Chinese",
        LanguageSelector_source_language_short_name: "Zh",
        LanguageSelector_target_language_name: "English",
        LanguageSelector_target_language_short_name: "En",
        LanguageSelector_search_input_placeholder: "Search Languages",
        LanguageSelect_button_exchang: "Click to Switch",
        PageHeader_vip_name: "Plan",
        PageHeader_help_item_1: "Help Documentation",
        PageHeader_help_item_2: "User Feedback",
        PageHeader_help_item_3: "User Community",
        PageHeader_help_item_4: "Request for Invoice",
        PageHeader_version_title: "Version Update",
        PageHeader_version_label_new: "New",
        PageHeaderTabs_tab_memory: "Translation Memory",
        PageHeaderTabs_tab_term: "Termbase",
        PageHeaderTabs_tab_polish: "AI Polish",
        PageHeaderTabs_tab_translationScore: "AI Translation Rating",
        PageHeaderTabs_tab_align: "Alignment",
        PageHeaderTabs_tab_termExtraction: "Terminology Extraction",
        PageHeaderTabs_tab_qa: "QA Check",
        PageHeaderTabs_tab_detector: "Machine Translation Detection",
        PageHeaderTabs_tab_videoTranslate: "AI Video Translation",
        PageHeaderTabs_tab_gptTranslate: "Document Intelligent Agent",
        PageHeaderTabs_tab_ragCreate: "Custom RAG MT Model",
        PageHeaderTabs_tab_engineCreate: "Deep Training",
        PageHeaderTabs_tab_myTasks: "My Task",
        PageHeaderTabs_tab_taskStatistics: "Total Tasks",
        PageHeaderTabs_tab_projectIndex: "My project",
        PageHeaderTabs_tab_projectTemplate: "Project template",
        DownloadNotices_drag_tips: "Tap to Move",
        DownloadNotices_status_name_1:
            "Export is in progress, please be patient",
        DownloadNotices_status_name_2: "Export Successful",
        DownloadNotices_status_name_3: "Export Failed",
        DownloadNotices_button_download: "Download",
        DownloadNotices_download_link_fail_message:
            "Failed to get download address, please try again",
        DownloadNotices_download_delete_remote_file_success:
            "Delete Remote Download File Successfully",
        DragDialog_title: "Note",
        MessageCenter_title: "Notification Center",
        MessageCenter_button_read_all: "Read All",
        MessageCenter_tab_label_all: "All",
        MessageCenter_tab_label_unread: "Unread",
        MessageCenter_tab_label_read: "Read",
        MessageCenter_message_createTime_format: "MM-DD-YYYY HH:mm",
        MessageCenter_button_join: "Join",
        MessageCenter_button_go_review: "Go to Review",
        MessageCenter_no_message_tips: "No messages yet",
        UserAvatarMenu_expireTime_format: "YYYY-MM-DD",
        UserAvatarMenu_expireTime_label: "Expire",
        UserAvatarMenu_expireTime_label_expired: "Expired",
        UserAvatarMenu_upgrade_to_pro: "Upgrade PRO",
        UserAvatarMenu_info_label_1: "Members:",
        UserAvatarMenu_info_label_2: "Total Character:",
        UserAvatarMenu_info_label_3: "Token: ",
        UserAvatarMenu_button_switch_org:
            "Switch to Enterprise/Education Version",
        UserAvatarMenu_button_user_center: "User Center",
        UserAvatarMenu_button_org_center: "Organization Center",
        UserAvatarMenu_button_logout: "Log Out",
        UserAvatarMenu_message_switching_org: "Switching",
        LeftAside_slogan: "New Generation of AI Translation Platform",
        LeftAside_menu_item_help: "Help",
        LeftAside_menu_item_help_child_1: "Help Documentation",
        LeftAside_menu_item_help_child_2: "User Feedback",
        LeftAside_menu_item_help_child_3: "User Community",
        LeftAside_menu_item_help_child_4: "Request for Invoice",
        LeftAside_menu_item_engine: "Model",
        LeftAside_menu_item_project: "Project",
        LeftAside_menu_item_task: "Task",
        LeftAside_menu_item_asset: "Asset",
        LeftAside_menu_item_tools: "Toolkit",
        LeftAside_menu_item_agent: "Agent",
        LeftAside_menu_item_team: "Team",
        AlertDialog_title: "Note",
        AlertDialog_button_confirm: "Confirm",
        AlertDialog_button_cancel: "Cancel",
        BindWechat_title: "Bind WeChat",
        BindWechat_scan_qrcode_title: "Scan the QR code on WeChat",
        BindWechat_button_refresh: "Refresh",
        BindWechat_qrcode_overdue_tips: "QR Code Expired",
        BindWechat_tips_1:
            "Scan the code and follow the official account of LanguageX. ",
        BindWechat_tips_2:
            "Our message will not be much, but it is important for you!",
        BindWechat_bind_success_message: "Account Bound Successfully!",
        FullLoading_title: "Searching...",
        JargonDialog_title: "Terminology Customization (Project Glossary)",
        JargonDialog_tips:
            "Your uploaded or selected terminology is in effect. New terms added here will be saved to the project's specified terminology base",
        JargonDialog_tooltip_content: "Support xlsx/xls/tbx format",
        JargonDialog_button_upload_title: "Upload Glossary",
        JargonDialog_button_download_template: "Download Template",
        JargonDialog_input_search_placeholder: "Search Term",
        JargonDialog_table_column_index_label: "No.",
        JargonDialog_table_column_source_label: "Original",
        JargonDialog_table_column_target_label: "Translation",
        JargonDialog_table_column_remark_label: "Note",
        JargonDialog_table_column_action_label: "Setting",
        JargonDialog_input_source_placeholder: "Enter the original term",
        JargonDialog_input_target_placeholder:
            "Enter a translation of the term",
        JargonDialog_input_remark_placeholder: "Add Note",
        JargonDialog_button_save: "Save",
        JargonDialog_button_cancel: "Cancel",
        JargonDialog_button_edit: "Edit",
        JargonDialog_button_delete: "Delete",
        JargonDialog_button_reTranslate: "Retranslate",
        JargonDialog_button_delete_confirm_title:
            "Are you sure you want to delete it？",
        JargonDialog_downloading_template_message: "Downloading",
        JargonDialog_download_fail_message: "Failed to get download address",
        JargonDialog_term_upload_verification_message:
            "Please make sure the file has been uploaded successfully",
        JargonDialog_term_upload_success_message: "Upload Successful",
        JargonDialog_term_source_verification_message:
            "The original term cannot be empty",
        JargonDialog_term_target_verification_message:
            "The translation of term cannot be empty",
        JargonDialog_save_success_message: "Saved successfully",
        JargonDialog_delete_success_message: "Deleted",
        NextCollapse_title: "Title",
        NextDrawer_button_close: "Close",
        NextDrawer_button_confirm: "Confirm",
        PageTitle_input_title_placeholder: "Enter the Title, Enter to Save",
        PageTitle_edit_title_tooltip_content: "Click to Edit, Enter to Save",
        PageTitle_save_title_verification_message: "The name cannot be empty",
        PayErpDialog_title: "Subscribe to Enterprise Version",
        PayErpDialog_success_message_1: "Subscription Successful",
        PayErpDialog_success_message_2:
            "Thank you for your trust and welcome to join the user group!",
        PayErpDialog_success_message_3:
            "Scan the QR code to join the official user group",
        PayErpDialog_button_apply_invoice: "Request for Invoice",
        PayErpDialog_form_startTime_label: "Service Start Time",
        PayErpDialog_form_startTime_placeholder: "Select Service Start Time",
        PayErpDialog_form_endTime_label: "Service End Time",
        PayErpDialog_form_endTime_placeholder: "Select Service End Time",
        PayErpDialog_form_orgName_label: "Full name of enterprise",
        PayErpDialog_form_orgName_placeholder:
            "Full name of your enterprise required",
        PayErpDialog_form_button_cofirm: "Confirm and Generate Agreement",
        PayErpDialog_form_orgName_tips_1:
            "If the full name of the company is displayed as starting with LXO, ",
        PayErpDialog_form_orgName_tips_2: "please modify",
        PayErpDialog_form_orderNo_label: "Order Number",
        PayErpDialog_form_amount_label: "Payment Amount",
        PayErpDialog_form_scan_label: "Scan to pay",
        PayErpDialog_form_scan_platform_wechat: "WeChat",
        PayErpDialog_currency_symbol: "￥",
        PayErpDialog_form_org_benefits_tips:
            "Learn more about Enterprise/Education Version",
        PayErpDialog_form_cofirm_tips_1:
            'Click "Confirm and Generate Agreement" button',
        PayErpDialog_form_cofirm_tips_2:
            "Confirm your contract on the new page and return to this page to make payment",
        PayErpDialog_bottom_tips_1:
            "By subscribing to the LanguageX service you agree to our",
        PayErpDialog_bottom_tips_2: " Service Agreement",
        PayErpDialog_bottom_tips_3: " and",
        PayErpDialog_bottom_tips_4: " Privacy Policy",
        PayErpDialog_pay_fail_message: "Payment Failed",
        PayErpDialog_orgName_verification_message:
            "Please fill in the full name of your Organization!",
        PayErpDialog_orgName_LOX_verification_message:
            "Please contact the current enterprise/education version administrator to modify the name and try again",
        PayProDialog_title: "Subscribe to PRO Version",
        PayProDialog_success_message_1: "Subscription Successful",
        PayProDialog_success_message_2:
            "Thank you for your trust and welcome to join the user group!",
        PayProDialog_success_message_3:
            "Scan the QR code to join the official user group",
        PayProDialog_button_apply_invoice: "Request for Invoice",
        PayProDialog_currency_symbol: "￥",
        PayProDialog_label_time_limit: "Buy 1 Get 1 Free (Time-Limited)",
        PayProDialog_form_orderNo_label: "Order Number",
        PayProDialog_form_amount_label: "Payment Amount",
        PayProDialog_form_scan_label: "Scan to pay",
        PayProDialog_form_scan_platform_wechat: "WeChat",
        PayProDialog_form_org_benefits_tips: "Learn more about PRO Version",
        PayProDialog_bottom_tips_1:
            "By subscribing to the LanguageX service you agree to our",
        PayProDialog_bottom_tips_2: " Service Agreement",
        PayProDialog_bottom_tips_3: " and",
        PayProDialog_bottom_tips_4: " Privacy Policy",
        PayProDialog_pay_fail_message: "Payment Failed",
        QaSetting_title: "QA Settings",
        QaSetting_type_title_1: "Rule-based QA",
        QaSetting_type_title_2: "Intelligent QA",
        QaSetting_type_title_3: "QA Process Settings",
        QaSetting_tips_1: "Submission allowed only after QA",
        QaSetting_tips_2:
            "To modify the QA check configuration, please go to Project Details > QA Settings",
        QaSetting_support_tooltip_content:
            "Upgrade to a higher version with Intelligent QA",
        QaSetting_fluency_tips:
            "Fluency in English (including word choice, verb tense, singular/plural, capitalization, pronouns/articles, English fluency check)",
        QaSetting_button_cancel: "Cancel",
        QaSetting_button_submit: "Confirm",
        QaSetting_success_message: "QA settings have been updated",
        UpgradePro_message_1: "Please complete the account upgrade first",
        UpgradePro_pro_limited_label: "Expired",
        UpgradePro_message_2:
            "This feature is not available for the version currently in use. Upgrade your account to unlock more advanced features.",
        UpgradePro_button_upgrade: "Upgrade to PRO",
        UploadFiles_file_upload_status_fail: "Failed",
        UploadFiles_file_upload_status_success: "Success",
        UploadFiles_file_accept_message: "Support files in {accept} formats",
        UploadFiles_file_limit_message:
            "You can only upload up to {limit} files",
        UploadFiles_file_size_message: "{name} larger than {size}MB.",
        UploadFiles_file_exist_message: "{name} already exists",
        UploadFiles_login_expired_message:
            "Your Session Has Expired. Please Login Again to Continue.",
        UploadFiles_file_upload_fail_message:
            "{name} upload failed, please try again",
        UploadOss_title: "Upload File",
        UploadOss_file_accept_message: "Support files in {accept} formats",
        UploadOss_file_limit_message: "You can only upload up to {limit} files",
        UploadOss_file_empty_message: "Uploading empty files is not supported",
        UploadOss_file_size_message: "{name} larger than {size}MB.",
        UploadOss_file_exist_message: "{name} already exists",
        UploadOss_file_upload_fail_message:
            "File upload failed, please try again",
        UserSelect_select_placeholder: "Select",
        UserSelector_search_input_placeholder: "Enter keyword to search",
        UserSelector_empty_description: "No content available",
        UserSelectorDialog_title: "Assign Translators",
        UserSelectorDialog_form_name_label: "Translator Name",
        UserSelectorDialog_form_name_placeholder: "Select",
        UserSelectorDialog_button_cancel: "Cancel",
        UserSelectorDialog_button_submit: "Confirm",
        PayCharsDialog_title: "Characters",
        PayCharsDialog_tips_1: "Purchase Successful",
        PayCharsDialog_tips_2:
            "Thank you for your trust and welcome to join the user group!",
        PayCharsDialog_tips_3:
            "Scan the QR code to join the official user group",
        PayCharsDialog_tips_4: "{number}00K Characters",
        PayCharsDialog_tips_5: "￥{price}/00K Characters",
        PayCharsDialog_tips_6: "￥{price}",
        PayCharsDialog_tips_7: "Order Number",
        PayCharsDialog_tips_8: "Payment Amount",
        PayCharsDialog_tips_9: "Scan to pay",
        PayCharsDialog_tips_10: "Learn more about PRO Version",
        PayCharsDialog_tips_11:
            "By subscribing to the LanguageX service you agree to our",
        PayCharsDialog_tips_12: "Terms of Service",
        PayCharsDialog_tips_13: "and",
        PayCharsDialog_tips_14: "Privacy Policy",
        PayCharsDialog_tips_15: "WeChat",
        PayCharsDialog_method_pollingOrderStatus_message_1: "Payment Failed!",
        PayTokenDialog_title: "Agent Token",
        PayTokenDialog_tips_1: "Purchase Successful",
        PayTokenDialog_tips_2:
            "Thank you for your trust. Welcome to follow our official accounts and stay in touch with us!",
        PayTokenDialog_tips_3:
            "Scan the QR code to follow our official accounts",
        PayTokenDialog_tips_4: "WeChat",
        PayTokenDialog_tips_6: "￥{price}",
        PayTokenDialog_tips_7: "Order Number",
        PayTokenDialog_tips_8: "Payment Amount",
        PayTokenDialog_tips_9: "Scan to pay",
        PayTokenDialog_tips_10:
            "By subscribing to the LanguageX service you agree to our",
        PayTokenDialog_tips_11: "Terms of Service",
        PayTokenDialog_tips_12: "and",
        PayTokenDialog_tips_13: "Privacy Policy",
        PayTokenDialog_method_pollingOrderStatus_message_1: "Payment Failed!",
    },
    engine: {
        config_page_title: "Translation Model",
        config_page_button_term_setting: "Terminology Customization",
        config_page_source_input_placeholder:
            "Paste a paragraph and compare translations across different engines quickly. Max 5,000 chars",
        config_page_button_change: "Switch",
        config_page_button_try: "Try the sample",
        config_page_button_upload: "Upload File",
        config_page_tooltip_engine_detail: "View Model Details",
        config_page_tooltip_engine_create: "Create New Model",
        config_page_message_1: "In addition to general model, you can also",
        config_page_message_2: "train your personalized models",
        config_page_message_3:
            "There is no personalized model for the current language direction, try creating one yourself",
        config_page_message_4:
            "Your PRO account has expired and the personalized model you created has been suspended. Service will be resumed upon renewal,",
        config_page_message_5: "Go to Renewal Page",
        config_page_message_6: "Translation in progress. Please wait.",
        config_page_message_7:
            "Personalized model has been taken down due to expiration of membership, service will be restored after renewal.",
        config_page_message_8:
            "Exclusive feature of Pro version, upgrade to Pro to use.",
        config_page_message_9: "Upgrade",
        config_page_message_10: "Copied to clipboard",
        config_page_message_11: "Copy to clipboard failed. Please try again.",
        config_page_message_12: "Select Source Language",
        config_page_message_13: "Terminology customization is on",
        config_page_message_14: "Terminology customization is off",
        config_page_message_15:
            "This term is not available in the current language",
        config_page_message_16: "Original text:",
        config_page_message_17: "Polish up to {count} times",
        config_page_message_18: "",
        config_page_button_copy: "Copy",
        config_page_button_edit: "Edit",
        config_page_button_show_difference: "Show differences",
        config_page_button_clear_history: "Clear History",
        config_page_button_polish: "Polish",
        config_page_button_polish_again: "Polish Again",
        config_page_term_title: "Terminology Customization",
        config_page_term_descoption:
            "Try adding terms, up to 20 per language. To add terms and translation files in bulk, click Upload Files to create a new project.",
        config_page_term_table_label_1: "No.",
        config_page_term_table_label_2: "Original text ({name})",
        config_page_term_table_label_3: "Translation ({name})",
        config_page_term_table_label_4: "Setting",
        config_page_term_table_input_1: "Enter the original term",
        config_page_term_table_input_2: "Enter a translation of the term",
        config_page_term_table_button_1: "Save (Enter)",
        config_page_term_table_button_2: "Delete",
        config_page_term_table_button_3: "Edit",
        config_page_term_verification_message_1:
            "The original term cannot be empty",
        config_page_term_verification_message_2:
            "The translation of term cannot be empty",
        config_page_term_message_1: "Saved Successfully",
        config_page_term_message_2: "Term Deleted",
        ragCreate_page_title: "Custom RAG MT Model",
        ragCreate_page_alert_1_part1:
            "{type} can create up to {size} personalized engines, and your account has reached the limit,",
        ragCreate_page_alert_1_part2:
            "If you want to create a new personalized engine, please contact us.",
        ragCreate_page_alert_2:
            "Retrieval-Augmented Generation (RAG) allows large language models to combine translation memory/glossary and specific requirements to translate vertical domain content more professionally.",
        ragCreate_page_form_model_label: "Model Name",
        ragCreate_page_form_model_placeholder:
            "Name your model, within 10 characters",
        ragCreate_page_form_language_label: "Language Direction",
        ragCreate_page_form_language_source_placeholder: "Source",
        ragCreate_page_form_language_target_placeholder: "Target",
        ragCreate_page_form_term_label: "Specify Terminology Translation",
        ragCreate_page_form_term_tips:
            "Specify some project-specific core terms without uploading a glossary (Please upload the glossary if there are many terms)",
        ragCreate_page_form_term_source_placeholder: "Enter the original term",
        ragCreate_page_form_term_target_placeholder:
            "Enter a translation of the term",
        ragCreate_page_form_demand_label: "Other Requirements",
        ragCreate_page_form_demand_tooltip_content:
            'Please use short and concise language to describe specific requirements, here are some examples:<br>1. Use % for percent sign, no need to translate to percent. <br>2. Do not translate company names that appear in the text, keep the original names. <br>3. If the text contains serial numbers, translate "No. 1" as "I.".',
        ragCreate_page_form_demand_placeholder:
            'Please use short and concise language to describe specific requirements, here are some examples: 1. Use % for percent sign, no need to translate to percent. 2. Do not translate company names that appear in the text, keep the original names. 3. If the text contains serial numbers, translate "No. 1" as "I.".',
        ragCreate_page_form_description_label: "Model Introduction",
        ragCreate_page_form_description_placeholder:
            "Please provide a brief introduction, within 100 words. For example: The international engineering field, with the language data mainly from engineering technical documents.",
        ragCreate_page_form_memoryFile_label: "Upload Translation Memory",
        ragCreate_page_form_memoryFile_tips:
            "The language direction should be the same as the model's language direction",
        ragCreate_page_form_memoryFile_message:
            "Upload translation memory in xlsx/xls/tmx format.<br>Up to 50 files per batch, with a maximum size of {size}MB per file.",
        ragCreate_page_form_termFile_label: "Upload Glossary",
        ragCreate_page_form_termFile_tips:
            "The language direction should be the same as the model's language direction",
        ragCreate_page_form_termFile_message:
            "Upload glossary in xlsx/xls/tbx format.<br>Up to 50 files per batch, with a maximum size of {size}MB per file.",
        ragCreate_page_button_submit: "Generate Model",
        ragCreate_page_button_submit_message: "Expected within 1 minute",
        ragCreate_page_success_dialog_title: "Generation Completed",
        ragCreate_page_success_dialog_content_1:
            "The {name} model has been successfully generated,",
        ragCreate_page_success_dialog_content_2:
            "Can be used under the Model > Personalized Model",
        ragCreate_page_success_dialog_content_3:
            "Please select the correct language direction before use.",
        ragCreate_page_success_dialog_button: "Try it Out",
        ragCreate_page_language_zh_name: "Chinese",
        ragCreate_page_language_zh_shortName: "Zh",
        ragCreate_page_language_en_name: "English",
        ragCreate_page_language_en_shortName: "En",
        ragCreate_page_language_ko_name: "Korean",
        ragCreate_page_language_ko_shortName: "Ko",
        ragCreate_page_form_verification_message_1: "Please Enter Model Name",
        ragCreate_page_form_verification_message_2: "Upload Translation Memory",
        ragCreate_page_form_verification_message_3: "Add up to 20 terms",
        create_page_title: "Deep Training",
        create_page_tips_1:
            "{type} can create up to {count} personalized models, and your account has reached the limit, to create more,",
        create_page_tips_2: "Please contact us",
        create_page_tips_3:
            "Upload 5,000-100,000 sentences for deep training. Suitable for long-term, domain-specific use. Training takes 1-2 working days. The model will be shared by default after training.",
        Detail_page_tips_1: "Quick Training",
        Detail_page_tips_2: "Deep Training",
        Detail_page_tips_3: "Delete Model",
        Detail_page_tips_4: "No Description",
        Detail_page_tips_5: "Share",
        Detail_page_tips_6:
            "After sharing is turned off, only you can access the model. Others cannot train or download the test sets.",
        Detail_page_tips_7: "On",
        Detail_page_tips_8:
            "People who get the link have authorities to use and view the model, participate in joint training, download test sets. It is recommended to send the link and password privately, not in group chats",
        Detail_page_tips_9: "Language Pair",
        Detail_page_tips_10: "Model Tags",
        Detail_page_tips_11: "Training Corpus",
        Detail_page_tips_12: "Entries",
        Detail_page_tips_13: "Bleu Score",
        Detail_page_tips_14:
            "Bleu score is an automatic evaluation of machine translation quality and is for reference only",
        Detail_page_tips_15: "Featured Example",
        Detail_page_tips_16:
            "Add selected memory samples to represent the desired translation domain and style, within 4,000 characters",
        Detail_page_tips_17: "View Sample Format",
        Detail_page_tips_18: "Training Records",
        Detail_page_tips_19: "Participate in joint training",
        Detail_page_tips_20:
            "Just two steps: 1. Upload Corpus (in .xlsx, .xls, or .tmx format), 2. Automatically corpus cleaning and training",
        Detail_page_tips_21: "Upload Corpus",
        Detail_page_tips_22:
            "The domain and language direction of the uploaded corpus must match the model",
        Detail_page_tips_23:
            "Retraining will temporarily take the model offline and is expected to complete in 2-3 minutes",
        Detail_page_btn_1: "Edit",
        Detail_page_btn_2: "Copy Links and Password",
        Detail_page_btn_3: "Share",
        Detail_page_btn_4: "Download Test Set",
        Detail_page_btn_5: "Re-training",
        Detail_page_btn_6: "Submit Corpus",
        Detail_page_placeholder_1: "Please enter content",
        Detail_page_placeholder_2: "Select Style Type",
        Detail_page_placeholder_3: "Select Translation Type",
        Detail_page_placeholder_4:
            'Custom style description, such as "More long sentences"',
        Detail_page_placeholder_5:
            "Paste aligned examples here with source on top and translation below for each segment, or copy source and translation columns directly from Excel",
        Detail_page_form_item_1: "Translation Style",
        Detail_page_table_column_1: "Contributor",
        Detail_page_table_column_2: "Status",
        Detail_page_table_column_3: "New Data Volume",
        Detail_page_table_column_4: "Bleu Score",
        Detail_page_table_column_5: "Participation time",
        Detail_page_descriptions_column_1: "Uploaded Segments",
        Detail_page_descriptions_column_2: "Suspected Low-Quality Segments",
        Detail_page_descriptions_column_3: "Reduplicated Segments",
        Detail_page_descriptions_column_4: "Cleaned Segments",
        Detail_page_dialog_1_title: "Modify Model Information",
        Detail_page_dialog_1_form_item_label_1: "Model Name",
        Detail_page_dialog_1_form_item_label_2: "Model Description",
        Detail_page_dialog_1_placeholder_1:
            "Name your model, within 10 characters",
        Detail_page_dialog_1_placeholder_2:
            "Enter description, within 100 words.\nExample: international engineering field, mainly from engineering technical documents, construction documents, contracts, etc.",
        Detail_page_dialog_1_tips_1: "Model Tags",
        Detail_page_dialog_1_tips_2: "Select 1-3 Tags",
        Detail_page_dialog_1_btn_1: "Cancel",
        Detail_page_dialog_1_btn_2: "Confirm",
        Detail_page_created_alertInfo_message:
            "Are you sure you want to delete model? Delete cannot be restored",
        Detail_page_created_alertInfo_buttonName: "Confirm Deletion",
        Detail_page_method_initPage_message_1: "Password:",
        Detail_page_method_initPage_message_2:
            "In training, please refresh the page later to view.",
        Detail_page_method_submitBtnEvent_message_1: "Please upload the corpus",
        Detail_page_method_submitRetrainGpt_message_1:
            "In training, please refresh the page later to view.",
        Detail_page_method_getTaskStatus_message_1:
            "Less than {number} sentence segments. Please upload more data",
        Detail_page_method_deleteEngineEvent_message_1: "Model Deleted",
        Detail_page_method_saveEditBtnEvent_message_1:
            "Please enter model name",
        Detail_page_method_saveEditBtnEvent_message_2:
            "Please select model tag",
        Detail_page_method_saveEditBtnEvent_message_3:
            "Please enter model description",
        Detail_page_method_saveEditBtnEvent_message_4: "Update Successful",
        Detail_page_method_downloadTestSetBtnEvent_message_1: "Downloading...",
        Detail_page_method_downloadTestSetBtnEvent_message_2: "Test Sets",
        Detail_page_method_shareSettingEvent_message_1: "Model Sharing Enabled",
        Detail_page_method_shareSettingEvent_message_2:
            "Model Sharing Disabled",
        Detail_page_method_copyShareLink_message_1:
            "{name} invites you to use his/her personalized model {engine}, accept the invitation, and it will appear in your translation model array.\n{link}",
        Detail_page_method_copyShareLink_message_2: "Copied to clipboard",
        Detail_page_method_copyShareLink_message_3:
            "Failed to copy to clipboard, please try again",
        QuickCreate_page_tips_1:
            "{type} can create up to {count} personalized models, and your account has reached the limit, to create more,",
        QuickCreate_page_tips_2: "please contact us",
        QuickCreate_page_tips_3:
            "Only a few typical samples are required to customize your personalized model, available instantly",
        QuickCreate_page_tips_4: "Select 1-3 Tags",
        QuickCreate_page_tips_5:
            "Add selected memory samples to represent the desired translation domain and style, within 4,000 characters",
        QuickCreate_page_tips_6: "View Sample Format",
        QuickCreate_page_tips_7:
            "Featured sample translation order should match language directions",
        QuickCreate_page_form_item_label_1: "Model Name",
        QuickCreate_page_form_item_label_2: "Lang Direction",
        QuickCreate_page_form_item_label_3: "Model Tags",
        QuickCreate_page_form_item_label_4: "Model Description",
        QuickCreate_page_form_item_label_5: "Translation Style",
        QuickCreate_page_form_item_label_6: "Featured Example",
        QuickCreate_page_placeholder_1: "Name your model, within 10 characters",
        QuickCreate_page_placeholder_2:
            "Personalized model based on Language X Quick Training, Amazing!",
        QuickCreate_page_placeholder_3: "Select Style",
        QuickCreate_page_placeholder_4: "Select Translation Type",
        QuickCreate_page_placeholder_5:
            'Custom style description, such as "More long sentences"',
        QuickCreate_page_placeholder_6:
            "Paste aligned examples here with source on top and translation below for each segment, or copy source and translation columns directly from Excel",
        QuickCreate_page_btn_1: "Start Training",
        QuickCreate_page_dialog_1_title: "Created Successfully",
        QuickCreate_page_dialog_1_tips_1:
            "{name} model is created successfully",
        QuickCreate_page_dialog_1_tips_2: "Can be used directly in model list",
        QuickCreate_page_dialog_1_btn_1: "Try it Out",
        QuickCreate_page_data_languageList_name_1: "Chinese",
        QuickCreate_page_data_languageList_shortName_1: "Zh",
        QuickCreate_page_data_languageList_name_2: "English",
        QuickCreate_page_data_languageList_shortName_2: "En",
        QuickCreate_page_method_submitEvent_message_1:
            "Please enter model name",
        QuickCreate_page_method_submitEvent_message_2: "Please select 1-3 tags",
        QuickCreate_page_method_submitEvent_message_3:
            "Please add featured cases",
        Share_page_tips_1:
            "{name} invites you to be a collaborator on the model",
        Share_page_tips_2: "Please enter the password to access the model",
        Share_page_tips_3: "No Description",
        Share_page_placeholder_1: "Please enter the password",
        Share_page_btn_1: "Confirm",
        Share_page_method_submitJoinEvent_message_1:
            "Please enter the password",
        Share_page_method_submitJoinEvent_message_2: "Successfully added model",
    },
    project: {
        project_index_page_btn_1: "Create New Project",
        project_index_page_btn_2: "Refresh",
        project_index_page_btn_3: "Project Task Stats",
        project_index_page_search_input_placeholder: "Enter project name",
        project_index_page_search_select_placeholder_1: "Source",
        project_index_page_search_select_placeholder_2: "Target",
        project_index_page_search_select_placeholder_3: "Team Owner",
        project_index_page_search_select_placeholder_4: "Project Status",
        project_index_page_search_select_placeholder_5: "Project Creator",
        project_index_page_search_select_placeholder_6: "Project Template",
        project_index_page_search_select_placeholder_7: "Project Process",
        project_index_page_search_dropdown_item_1: "Download Target Text",
        project_index_page_search_dropdown_item_2: "Bilingual (Source First)",
        project_index_page_search_dropdown_item_3: "Download Source Text",
        project_index_page_search_dropdown_item_4: "Download TMX",
        project_index_page_search_dropdown_item_5: "Bilingual (Target First)",
        project_index_page_search_tips_1: "Batch Delete",
        project_index_page_search_changeView_tips_1: "Toggle",
        project_index_page_search_changeView_tips_2: "Card",
        project_index_page_search_changeView_tips_3: " List",
        project_index_page_search_changeView_tips_4: " View",
        project_index_page_empty_tips_1: "No projects found! Tran",
        project_index_page_empty_tips_2:
            "There are no projects yet. Go to create a new one!",
        project_index_page_dialog_1_title: "Accept/Archive Project",
        project_index_page_dialog_1_message:
            "Are you sure the project has been completed and send task information to Zhiyun TMS?",
        project_index_page_dialog_1_message_1:
            "Please confirm if the project has been completed.",
        project_index_page_dialog_1_btn_1: "Cancel",
        project_index_page_dialog_1_btn_2: "Confirm",
        project_index_page_data_alertInfo_message:
            "Are you sure to delete items?",
        project_index_page_data_alertInfo_buttonName: "Confirm Deletion",
        project_index_page_data_statusOptions_1_text: "Active",
        project_index_page_data_statusOptions_2_text: "Accepted/Archived",
        project_index_page_data_orderOptions_1_text: "Sort by project name",
        project_index_page_data_orderOptions_2_text: "Sort by created date",
        project_index_page_methods_batchDownloadBtnEvent_message_1:
            "Please select projects to download first",
        project_index_page_methods_batchDownloadBtnEvent_message_2:
            "Exporting {size} projects.",
        project_index_page_methods_batchDeleteBtnEvent_message_1:
            "Please select projects to delete first.",
        project_index_page_methods_deleteProject_message_1:
            "Project deleted successfully",
        project_index_page_methods_retryTask_message_1: "Retry successfully",
        project_index_page_methods_confirmCheck_message_1:
            "Acceptance successful, please go to Zhiyun TMS to check the task information.",
        project_index_page_methods_confirmCheck_message_2:
            "Acceptance/Archivin Successful",
        project_index_page_methods_executeAction_message_1: "No permission",
        project_index_page_methods_saveSetting2Template_message_1:
            "Template saved successfully",
        task_page_tab_label_1: "All",
        task_page_tab_label_2: "Pending",
        task_page_tab_label_3: "Active",
        task_page_tab_label_4: "Submitted",
        task_page_tab_label_5: "Expired",
        task_page_search_kw_placeholder: "Enter task name",
        task_page_search_source_placeholder: "Source",
        task_page_search_target_placeholder: "Target",
        task_page_search_taskType_placeholder: "Task Type",
        task_page_search_order_placeholder: "Sort By",
        task_page_search_button_text_1: "Batch Accept",
        task_page_search_button_text_2: "Batch Reject",
        task_page_search_button_text_3: "Refresh",
        task_page_search_button_text_4: "Batch submission",
        task_page_search_button_text_5: "Batch Export Offline Packs",
        task_page_search_switch_button_text_1: "Toggle",
        task_page_search_switch_button_text_2: " List",
        task_page_search_switch_button_text_3: " Card",
        task_page_search_switch_button_text_4: " View",
        task_page_card_item_label_1: "File Name: ",
        task_page_card_item_label_2: "Start: ",
        task_page_card_item_label_3: "Words",
        task_page_card_item_label_4: "Deadline: ",
        task_page_card_item_label_5: "Reject",
        task_page_card_item_label_6: "Accept",
        task_page_card_item_label_7: "%",
        task_page_card_item_label_8: "Export",
        task_page_card_item_label_9: "Import",
        task_page_card_item_dropdown_item_1: "Import",
        task_page_card_item_dropdown_item_2: "Export",
        task_page_card_item_dropdown_item_3: "View Quote",
        task_page_table_colum_label_1: "Task Name",
        task_page_table_colum_label_2: "Task Type",
        task_page_table_colum_label_3: "Segments",
        task_page_table_colum_label_4: "Project Name",
        task_page_table_colum_label_5: "Lang Direction",
        task_page_table_colum_label_6: "Billable Word Count",
        task_page_table_colum_label_7: "Deadline",
        task_page_table_colum_label_8: "Action",
        task_page_table_colum_label_9: "Unit Price",
        task_page_table_colum_label_10: "Total Price",
        task_page_table_colum_label_11: "Status",
        task_page_table_colum_label_12: "View Quote",
        task_page_table_colum_tips_1: "View Quote",
        task_page_table_colum_tips_2: "Return",
        task_page_table_colum_tips_3: "Import failed: ",
        task_page_empty_label_1: "There are no tasks ~",
        task_page_dialog_title_1: "Accept Task",
        task_page_dialog_message_1: "Confirm to accept {count} selected tasks?",
        task_page_dialog_btn_label_1: "Cancel",
        task_page_dialog_btn_label_2: "Confirm",
        task_page_dialog_title_2: "Reject Task",
        task_page_dialog_message_2: "Confirm to reject {count} selected tasks?",
        task_page_dialog_input_placeholder_1:
            "Please provide a reason for rejection (required)",
        task_page_dialog_title_3: "Import Translation",
        task_page_dialog_message_3:
            "Are you sure you want to import the translation of the following tasks?",
        task_page_dialog_title_4: "Task Quote",
        task_page_dialog_4_label_1: "Total: ",
        task_page_dialog_4_label_2: "Total Word Count: ",
        task_page_dialog_4_label_3: "Billable Word Count",
        task_page_dialog_4_label_4: "Unit Price: ",
        task_page_dialog_4_label_5: "Additional Costs: ",
        task_page_dialog_4_label_6: "Billing Unit: ",
        task_page_dialog_4_label_7: "Affiliated Project: ",
        task_page_dialog_4_label_8: "Analysis: ",
        task_page_dialog_4_label_9: "Currency: ",
        task_page_dialog_4_table_label_1: "Non-translated elements",
        task_page_dialog_4_table_label_2: "Cross-file Re",
        task_page_dialog_4_table_label_3: "Repetitions",
        task_page_dialog_4_table_label_4: "102%",
        task_page_dialog_4_table_label_5: "101%",
        task_page_dialog_4_table_label_6: "100%",
        task_page_dialog_4_table_label_7: "95%-99%",
        task_page_dialog_4_table_label_8: "85%-94%",
        task_page_dialog_4_table_label_9: "75%-84%",
        task_page_dialog_4_table_label_10: "50%-74%",
        task_page_dialog_4_table_label_11: "New",
        task_page_dialog_4_table_label_12: "Billable Word Count",
        task_page_dialog_4_table_label_13: "Total Price",
        task_page_dialog_4_table_btn_1: "Close",
        task_page_dialog_4_table_btn_2: "Download Quote",
        task_page_dialog_title_5: "Batch submission",
        task_page_dialog_5_tips_1: "Confirm to submit  {count} selected tasks?",
        task_page_dialog_5_tips_2:
            "The following reason may cause the submission to fail: ",
        task_page_dialog_5_tips_3: "1. QA unprocessed",
        task_page_dialog_5_btn_1: "Cancel",
        task_page_dialog_5_btn_2: "Confirm",
        task_page_orderOptions_item_1: "Sort by file name ascending",
        task_page_orderOptions_item_2: "Sort by file name descending",
        task_page_orderOptions_item_3: "Sort by start time ascending",
        task_page_orderOptions_item_4: "Sort by start time descending",
        task_page_orderOptions_item_5: "Sort by deadline ascending",
        task_page_orderOptions_item_6: "Sort by deadline descending",
        task_page_validation_message_1: "Please select a task first",
        task_page_validation_message_2: "Task has been rejected",
        task_page_validation_message_3: "Please select a task first",
        task_page_validation_message_4: "Task has been accepted",
        task_page_validation_message_5:
            "Please confirm file upload is complete and successful",
        task_page_validation_message_6:
            "Import successful. Please refresh in 2-5 minutes to check.",
        task_page_validation_message_7: "Task submitted successfully",
        task_page_validation_message_8:
            "This is a returned task, and will only be billed once in the final settlement. Please close it manually.",
        task_page_downloadOfferEvent_title: "{name}-Quotation",
        task_page_batchExportBtnEvent_title: "Offline Packs Export {time}",
        task_statistics_page_tab_label_1: "All",
        task_statistics_page_tab_label_2: "Pending",
        task_statistics_page_tab_label_3: "Active",
        task_statistics_page_tab_label_4: "Submitted",
        task_statistics_page_tab_label_5: "Expired",
        task_statistics_page_search_input_placeholder: "Enter task name",
        task_statistics_page_search_select_placeholder_1: "Source",
        task_statistics_page_search_select_placeholder_2: "Target",
        task_statistics_page_search_select_placeholder_3: "Task Type",
        task_statistics_page_search_select_placeholder_4: "Status",
        task_statistics_page_search_select_placeholder_5: "Sort By",
        task_statistics_page_search_select_placeholder_6: "Start Date",
        task_statistics_page_search_select_placeholder_7: "End Date",
        task_statistics_page_search_button_text_1: "Refresh",
        task_statistics_page_search_button_text_2: "Download",
        task_statistics_page_orderOptions_item_1: "Sort by file name ascending",
        task_statistics_page_orderOptions_item_2:
            "Sort by file name descending",
        task_statistics_page_orderOptions_item_3:
            "Sort by start time ascending",
        task_statistics_page_orderOptions_item_4:
            "Sort by start time descending",
        task_statistics_page_orderOptions_item_5: "Sort by deadline ascending",
        task_statistics_page_orderOptions_item_6: "Sort by deadline descending",
        task_statistics_page_statusOptions_item_1: "Pending",
        task_statistics_page_statusOptions_item_2: "Rejected",
        task_statistics_page_statusOptions_item_3: "Active",
        task_statistics_page_statusOptions_item_4: "Pending Submission",
        task_statistics_page_statusOptions_item_5: "Submitted",
        task_statistics_page_table_column_lable_1: "No.",
        task_statistics_page_table_column_lable_2: "Task Name",
        task_statistics_page_table_column_lable_3: "Task Type",
        task_statistics_page_table_column_lable_4: "Project Name",
        task_statistics_page_table_column_lable_5: "Lang Direction",
        task_statistics_page_table_column_lable_6: "Task Period",
        task_statistics_page_table_column_lable_7: "Status",
        task_statistics_page_table_column_lable_8: "Task Progress",
        task_statistics_page_table_column_lable_9: "Original Word Count",
        task_statistics_page_table_column_lable_10: "Billable Word Count",
        task_statistics_page_table_column_lable_11: "Unit Price",
        task_statistics_page_table_column_lable_12: "Total Price",
        task_statistics_page_table_column_lable_13: "Currency",
        task_statistics_page_table_column_tips_label_1: "File Name: ",
        task_statistics_page_table_column_tips_label_2: "Start: ",
        task_statistics_page_table_column_tips_label_3:
            "No task start time yet",
        task_statistics_page_table_column_tips_label_4: "No task end time yet",
        task_statistics_page_table_column_tips_label_5: "%",
        task_statistics_methods_downloadBtnEvent_message_1:
            "No downloadable tasks for the current list",
        component_ProjectCardList_popover_label_1: "Project Name: ",
        component_ProjectCardList_popover_label_2: "Team Owner: ",
        component_ProjectCardList_popover_label_3: "Creator: ",
        component_ProjectCardList_card_label_1: "File",
        component_ProjectCardList_card_label_2: "Words",
        component_ProjectCardList_card_label_3: "Accepted",
        component_ProjectCardList_card_label_4: "View",
        component_ProjectCardList_card_label_5: "%",
        component_ProjectCardList_card_label_6: "Project Progress",
        component_ProjectCardList_card_dropdown_item_1: "View",
        component_ProjectCardList_card_dropdown_item_2: "Accept Project",
        component_ProjectCardList_card_dropdown_item_3: "Download Target Text",
        component_ProjectCardList_card_dropdown_item_4:
            "Bilingual (Source First)",
        component_ProjectCardList_card_dropdown_item_5: "Download Source Text",
        component_ProjectCardList_card_dropdown_item_6: "Download TMX",
        component_ProjectCardList_card_dropdown_item_7: "Delete",
        component_ProjectCardList_card_dropdown_item_8: "Save as template",
        component_ProjectCardList_card_dropdown_item_9:
            "Bilingual (Target First)",
        component_ProjectCardList_card_cover_message_1:
            "Task failed: Insufficient traffic detected",
        component_ProjectCardList_card_cover_message_2:
            "Click retry on this page after a successful purchase",
        component_ProjectCardList_card_cover_btn_1: "Purchase Character Pack",
        component_ProjectCardList_card_cover_btn_2: "Retry",
        component_ProjectCardList_card_cover_btn_3: "Delete",
        component_ProjectTableList_table_column_lable_1: "Project Name",
        component_ProjectTableList_table_column_lable_2: "Lang Direction",
        component_ProjectTableList_table_column_lable_3: "File",
        component_ProjectTableList_table_column_lable_4: "Word Count",
        component_ProjectTableList_table_column_lable_5: "Character Count",
        component_ProjectTableList_table_column_lable_6: "Progress",
        component_ProjectTableList_table_column_lable_7: "Model",
        component_ProjectTableList_table_column_lable_8: "Created: ",
        component_ProjectTableList_table_column_lable_9: "Action",
        component_ProjectTableList_table_column_lable_10: "Creator",
        component_ProjectTableList_table_column_lable_11: "Status",
        component_ProjectTableList_table_column_dropdown_item_1: "View",
        component_ProjectTableList_table_column_dropdown_item_2:
            "Accept/Archive Project",
        component_ProjectTableList_table_column_dropdown_item_3:
            "Download Target Text",
        component_ProjectTableList_table_column_dropdown_item_4:
            "Bilingual (Source First)",
        component_ProjectTableList_table_column_dropdown_item_5:
            "Download Source Text",
        component_ProjectTableList_table_column_dropdown_item_6: "Download TMX",
        component_ProjectTableList_table_column_dropdown_item_7: "Delete",
        component_ProjectTableList_table_column_dropdown_item_8:
            "Save as template",
        component_ProjectTableList_table_column_dropdown_item_9:
            "Bilingual (Target First)",
        component_ProjectTableList_table_column_tooltip_label_1:
            "Project Name: ",
        component_ProjectTableList_table_column_tooltip_label_2: "Team Owner: ",
        component_ProjectTableList_table_column_tooltip_label_3: "Creator: ",
        component_ProjectTableList_table_column_label_1:
            "Character traffic insufficient",
        component_ProjectTableList_table_column_tooltip_1:
            "Click retry on this page after a successful purchase",
        component_ProjectTableList_table_column_btn_1:
            "Purchase Character Pack",
        component_ProjectTableList_table_column_btn_2: "Retry",
        project_create_page_btn_text_1: "Next",
        project_create_page_btn_text_2: "Create new",
        project_create_page_btn_text_3: "Refresh",
        project_create_page_btn_text_4: "Create new",
        project_create_page_btn_text_5: "Refresh",
        project_create_page_btn_text_6: "Add files",
        project_create_page_btn_text_7: "Back",
        project_create_page_btn_text_8: "Start translating",
        project_create_page_form_label_1: "Project Name",
        project_create_page_form_placeholder_1: "Enter project name",
        project_create_page_form_label_2: "Workflow",
        project_create_page_form_placeholder_2: "Select workflow",
        project_create_page_form_label_3: "Team Owner",
        project_create_page_form_placeholder_3: "Select Team",
        project_create_page_form_label_4: "Deadline",
        project_create_page_form_placeholder_4: "Select Due Date",
        project_create_page_form_label_5: "Source",
        project_create_page_form_placeholder_5: "Source Language",
        project_create_page_form_label_6: "Target",
        project_create_page_form_placeholder_6: "Target Language",
        project_create_page_form_placeholder_7: "Select Pre-Translation Model",
        project_create_page_form_label_8: "Match Rate",
        project_create_page_form_placeholder_8: "Match Rate",
        project_create_page_form_label_9: "Select All",
        project_create_page_form_label_10: "Rule-based QA",
        project_create_page_form_label_11: "Intelligent QA",
        project_create_page_form_label_12: "QA Process Settings",
        project_create_page_form_label_13: "Submission allowed only after QA",
        project_create_page_form_placeholder_12: "Select Reference Model",
        project_create_page_form_placeholder_13:
            "Enter project notes, within 500 characters.",
        project_create_page_form_label_14: "Project template",
        project_create_page_form_placeholder_14: "Project Template",
        project_create_page_form_label_15:
            "Set columns as source/target languages",
        project_create_page_select_option_label_1: "Manual translation",
        project_create_page_tips_1: "Comparison Model",
        project_create_page_tips_2:
            "For language pairs without a translation memory, the system will automatically create a default memory and save newly generated translation units to it",
        project_create_page_tips_3:
            "Project terminology will be suggested in the editor, but the current version does not support terminology intervention.",
        project_create_page_tips_4: "Upgrade to PRO to try this feature",
        project_create_page_tips_5: "Terminology intervention supported",
        project_create_page_tips_6:
            "For language pairs without a terminology base, the system will automatically create a default one and save newly added terms to it",
        project_create_page_tips_7:
            "You can optionally enable a reference translation model in the editor",
        project_create_page_tips_8: "Preview",
        project_create_page_tips_9: "Project Template List",
        project_create_page_memoryTable_column_label_1: "Write",
        project_create_page_memoryTable_column_label_2: "Name",
        project_create_page_memoryTable_column_label_3: "Lang Direction",
        project_create_page_memoryTable_column_label_4: "Entries",
        project_create_page_memoryTable_column_4_label_1: "Entries",
        project_create_page_memoryTable_column_label_5: "Penalty",
        project_create_page_memoryTable_column_label_6: "Created: ",
        project_create_page_termsTable_column_label_1: "Write",
        project_create_page_termsTable_column_label_2: "Name",
        project_create_page_termsTable_column_label_3: "Lang Direction",
        project_create_page_termsTable_column_label_4: "Entries",
        project_create_page_termsTable_column_4_label_1: "Entries",
        project_create_page_termsTable_column_label_6: "Created: ",
        project_create_page_remarkFileTable_column_label_1: "No.",
        project_create_page_remarkFileTable_column_label_2: "File name",
        project_create_page_remarkFileTable_column_label_3: "Created: ",
        project_create_page_remarkFileTable_column_label_4: "Action",
        project_create_page_dialog_1_title: "Upload Style Guide File",
        project_create_page_dialog_1_tips_1:
            "Maximum number of current items to upload",
        project_create_page_dialog_1_tips_2: "10",
        project_create_page_dialog_1_tips_3:
            "files. If you have multiple files, it's recommended to upload a zip file.",
        project_create_page_dialog_1_btn_1: "Cancel",
        project_create_page_dialog_1_btn_2: "Confirm",
        project_create_page_data_steps_1: "Upload File",
        project_create_page_data_steps_2: "Project settings",
        project_create_page_data_tabData_tabs_1: "Translation Memory",
        project_create_page_data_tabData_tabs_2: "Termbase",
        project_create_page_data_tabData_tabs_3: "Document settings",
        project_create_page_data_tabData_tabs_4: "QA Settings",
        project_create_page_data_tabData_tabs_5: "Reference Model",
        project_create_page_data_tabData_tabs_6: "Style Guide",
        project_create_page_data_tabData_tabs_7: "Advanced Settings",
        project_create_page_data_tabData_tabs_8: "Auto-scored",
        project_create_page_data_alertInfo_message_1:
            "There are files uploading or failed in the list. Continue?",
        project_create_page_data_alertInfo_submessage_1:
            "Clicking 'Continue' will exclude files that are uploading or failed from the next step.",
        project_create_page_data_alertInfo_buttonName_1: "Continue",
        project_create_page_method_nextBtnEvent_message_1:
            "Please check if the file was uploaded successfully.",
        project_create_page_method_nextBtnEvent_message_2: "Please upload file",
        project_create_page_method_nextBtnEvent_message_3:
            "Please select a model",
        project_create_page_method_confirmNextEvent_message_1:
            "Please check if the file has been uploaded successfully.",
        project_create_page_method_confirmNextEvent_message_2:
            "Please upload file",
        project_create_page_method_startTransitionBtnEvent_message_1:
            "Please enter project name",
        project_create_page_method_startTransitionBtnEvent_message_2:
            "Please select a due date",
        project_create_page_method_startTransitionBtnEvent_message_3:
            "Please select target language",
        project_create_page_method_startTransitionBtnEvent_message_4:
            "Please set the pre-translation model for the chosen language direction",
        project_create_page_method_gotoTermPage_message_1:
            "Please select target language",
        project_create_page_method_gotoMemoryPage_message_2:
            "Please select target language",
        project_create_page_method_beforeRouteLeave_message_1:
            "Are you sure you want to leave? Leaving will clear the current configuration.",
        project_create_page_method_beforeRouteLeave_message_2: "Prompt",
        project_create_page_method_beforeRouteLeave_btn_1: "Cancel",
        project_create_page_method_beforeRouteLeave_btn_2: "Confirm",
        project_create_page_method_showMultiColumnExcelParseDialogEvent_message_1:
            "Choose target language(s)",
        project_create_page_method_validateMultiColumnSettings_message_1:
            "Configure Excel multi-column parsing rules",
        project_create_page_method_validateMultiColumnSettings_message_2:
            "Assign columns to all languages",
        project_new_page_btn_text_1: "Next",
        project_new_page_btn_text_2: "Back",
        project_new_page_btn_text_3: "Create new",
        project_new_page_btn_text_4: "Refresh",
        project_new_page_btn_text_5: "Create new",
        project_new_page_btn_text_6: "Refresh",
        project_new_page_btn_text_7: "Start translating",
        project_new_page_form_placeholder_1:
            "Paste a paragraph and compare translations across different engines quickly. Max 5,000 chars",
        project_new_page_form_label_2: "Project Name",
        project_new_page_form_placeholder_2: "Enter project name",
        project_new_page_form_label_3: "Machine Translation Model",
        project_new_page_form_label_4: "Lang Direction",
        project_new_page_form_label_5: "Match Rate",
        project_new_page_form_placeholder_5: "Match Rate",
        project_new_page_form_label_6: "Select All",
        project_new_page_form_label_7: "Rule-based QA",
        project_new_page_form_label_8: "Intelligent QA",
        project_new_page_form_label_9: "Auto-scored",
        project_new_page_form_label_10: "Rating Threshold",
        project_new_page_tips_1: "View Model Details",
        project_new_page_tips_2: "Create New Model",
        project_new_page_tips_3:
            "Some large models are slower. For document translation, we recommend using LanguageX or ChatGPT first.",
        project_new_page_tips_4:
            "For language pairs without a translation memory, the system will automatically create a default memory and save newly generated translation units to it",
        project_new_page_tips_5:
            "Project terminology will be suggested in the editor, but the current version does not support terminology intervention.",
        project_new_page_tips_6: "Upgrade to PRO to try this feature",
        project_new_page_tips_7: "Terminology intervention supported",
        project_new_page_tips_8:
            "For language pairs without a terminology base, the system will automatically create a default one and save newly added terms to it",
        project_new_page_tips_9: "Select Reference Model in Editor",
        project_new_page_tips_10: "Preview",
        project_new_page_tips_11: "Switch",
        project_new_page_tips_12: "Try the sample",
        project_new_page_tips_13: "Lock settings",
        project_new_page_tips_14: "Billable Word Count",
        project_new_page_tips_15: "Auto-replace",
        project_new_page_tips_16: "AI rates pre-translation",
        project_new_page_tips_17:
            "Mark translations with a score below this as high-risk segments",
        project_new_page_memoryTable_column_label_1: "Write",
        project_new_page_memoryTable_column_label_2: "Name",
        project_new_page_memoryTable_column_label_3: "Lang Direction",
        project_new_page_memoryTable_column_label_4: "Entries",
        project_new_page_memoryTable_column_4_label_1: "Entries",
        project_new_page_memoryTable_column_label_5: "Created: ",
        project_new_page_termsTable_column_label_1: "Write",
        project_new_page_termsTable_column_label_2: "Name",
        project_new_page_termsTable_column_label_3: "Lang Direction",
        project_new_page_termsTable_column_label_4: "Entries",
        project_new_page_termsTable_column_4_label_1: "Entries",
        project_new_page_termsTable_column_label_5: "Created: ",
        project_new_page_data_steps_1: "Upload File",
        project_new_page_data_steps_2: "Select Machine Translation Model",
        project_new_page_data_steps_3: "Project settings",
        project_new_page_data_tabData_tabs_1: "Translation Memory",
        project_new_page_data_tabData_tabs_2: "Termbase",
        project_new_page_data_tabData_tabs_3: "Document settings",
        project_new_page_data_tabData_tabs_4: "QA Settings",
        project_new_page_data_tabData_tabs_5: "Reference Model",
        project_new_page_data_alertInfo_message_1:
            "There are files uploading or failed in the list. Continue?",
        project_new_page_data_alertInfo_submessage_1:
            "Clicking 'Continue' will exclude files that are uploading or failed from the next step.",
        project_new_page_data_alertInfo_buttonName_1: "Continue",
        project_new_page_method_nextBtnEvent_message_1:
            "Please check if the file was uploaded successfully.",
        project_new_page_method_nextBtnEvent_message_2: "Please upload file",
        project_new_page_method_nextBtnEvent_message_3: "Please select a model",
        project_new_page_method_confirmNextEvent_message_1:
            "Please check if the file was uploaded successfully.",
        project_new_page_method_confirmNextEvent_message_2:
            "Please upload file",
        project_new_page_method_changeEngineEvent_message_1:
            "Exclusive feature of Pro version, upgrade to Pro to use.",
        project_new_page_method_changeEngineEvent_message_2: "Upgrade now",
        project_new_page_method_changeEngineEvent_message_3: "",
        project_new_page_method_beforeRouteLeave_message_1:
            "Are you sure you want to leave? Leaving will clear the current configuration.",
        project_new_page_method_beforeRouteLeave_message_2: "Prompt",
        project_new_page_method_beforeRouteLeave_btn_1: "Cancel",
        project_new_page_method_beforeRouteLeave_btn_2: "Confirm",
        component_CreateUpload_tips_1:
            "You can upload up to {count} files (max {size}MB per file)",
        component_CreateUpload_tips_2:
            "Please remove encryption (if any) before upload.",
        component_CreateUpload_tips_3:
            "{count1} files succeeded, {count2} files failed.",
        component_CreateUpload_tips_4: "Continue uploading file",
        component_CreateUpload_data_uploadFileMessage:
            "Support files in {types} formats",
        component_CreateUpload_method_beforeUploadEvent_message_1:
            "You can only upload up to {count} files",
        component_CreateUpload_method_beforeUploadEvent_message_2:
            "Uploading empty files is not supported",
        component_CreateUpload_method_beforeUploadEvent_message_3:
            "{fileName} exceeds {size}MB.",
        component_CreateUpload_method_beforeUploadEvent_message_4:
            "{fileName} already exists",
        component_CreateUpload_method_beforeUploadEvent_message_5:
            "Your session has expired. Please login again to continue.",
        component_CreateUpload_method_beforeUploadEvent_message_6:
            " Upload failed, please try again",
        component_CreateMemoryMultiLanguage_dialog_title:
            "Create Translation Memory",
        component_CreateMemoryMultiLanguage_dialog_form_item_label_1: "Name",
        component_CreateMemoryMultiLanguage_dialog_form_item_placeholder_1:
            "Enter translation memory name",
        component_CreateMemoryMultiLanguage_dialog_form_item_label_2:
            "Team Owner",
        component_CreateMemoryMultiLanguage_dialog_form_item_placeholder_2:
            "Select Team",
        component_CreateMemoryMultiLanguage_dialog_form_item_label_3:
            "Upload Translation Memory",
        component_CreateMemoryMultiLanguage_tips_5:
            "Support {types}, up to {size}M. Download template",
        component_CreateMemoryMultiLanguage_tips_6: "Select File to Upload",
        component_CreateMemoryMultiLanguage_btn_1: "Cancel",
        component_CreateMemoryMultiLanguage_btn_2: "Save",
        component_CreateMemoryMultiLanguage_method_downloadTemplateEvent_message_1:
            "Downloading...",
        component_CreateMemoryMultiLanguage_method_downloadTemplateEvent_message_2:
            "Failed to get download address",
        component_CreateMemoryMultiLanguage_method_saveBtnEvent_message_1:
            "Translation memory name is required",
        component_CreateMemoryMultiLanguage_method_saveBtnEvent_message_2:
            "Please upload at least one memory file for a language pair",
        component_CreateMemoryMultiLanguage_method_saveBtnEvent_message_3:
            "Translation memory created successfully",
        component_CreateTermMultiLanguage_dialog_title: "Create Termbase",
        component_CreateTermMultiLanguage_dialog_form_item_label_1: "Name",
        component_CreateTermMultiLanguage_dialog_form_item_placeholder_1:
            "Enter termbase name",
        component_CreateTermMultiLanguage_dialog_form_item_label_2:
            "Team Owner",
        component_CreateTermMultiLanguage_dialog_form_item_placeholder_2:
            "Select Team",
        component_CreateTermMultiLanguage_dialog_form_item_label_3:
            "Upload Terms",
        component_CreateTermMultiLanguage_tips_5:
            "Support {types}, up to {size}M. Download template",
        component_CreateTermMultiLanguage_tips_6: "Select File to Upload",
        component_CreateTermMultiLanguage_btn_1: "Cancel",
        component_CreateTermMultiLanguage_btn_2: "Save",
        component_CreateTermMultiLanguage_method_downloadTemplateEvent_message_1:
            "Downloading...",
        component_CreateTermMultiLanguage_method_downloadTemplateEvent_message_2:
            "Failed to get download address",
        component_CreateTermMultiLanguage_method_saveBtnEvent_message_1:
            "Termbase name is required",
        component_CreateTermMultiLanguage_method_saveBtnEvent_message_2:
            "Please upload at least one terminology file for a language pair.",
        component_CreateTermMultiLanguage_method_saveBtnEvent_message_3:
            "Termbase created successfully",
        component_MultiColumnExcelParseDialog_dialog_title:
            "Configure column settings",
        component_MultiColumnExcelParseDialog_dialog_tips_1:
            "Exclude first row",
        component_MultiColumnExcelParseDialog_dialog_tips_2: "Source language",
        component_MultiColumnExcelParseDialog_dialog_tips_3: "Target language",
        component_MultiColumnExcelParseDialog_dialog_tips_4: "Column",
        component_MultiColumnExcelParseDialog_dialog_tips_5:
            "Enter column letter in uppercase",
        component_MultiColumnExcelParseDialog_dialog_tips_10:
            "Translation notes",
        component_MultiColumnExcelParseDialog_dialog_tips_11: "Character limit",
        component_MultiColumnExcelParseDialog_dialog_tips_6:
            "Please confirm your Excel file meets these criteria:",
        component_MultiColumnExcelParseDialog_dialog_tips_7:
            " ①There is only one table header row, and if it contains multiple sheets, the source language column, target language column, translation comment column, character limit column, and the position of the columns between each sheet are all consistent;",
        component_MultiColumnExcelParseDialog_dialog_tips_8:
            " ②Is the sole document for this project. (Create a new project for additional files.)",
        component_MultiColumnExcelParseDialog_dialog_tips_9: "Example template",
        component_MultiColumnExcelParseDialog_dialog_btn_1: "Cancel",
        component_MultiColumnExcelParseDialog_dialog_btn_2: "Save",
        component_MultiColumnExcelParseDialog_method_saveBtnEvent_message_1:
            "Assign columns to all languages",
        project_list_page_tabPane_1_label: "Project File",
        project_list_page_tabPane_1_btn_1: "Add File",
        project_list_page_tabPane_1_btn_2: "Refresh",
        project_list_page_tabPane_1_tips_1:
            "Total {total} items, {size} selected.",
        project_list_page_tabPane_1_tips_2: "Batch Delete",
        project_list_page_tabPane_1_input_placeholder_1:
            "Enter the name of the document",
        project_list_page_tabPane_1_dropdownItem_1: "Download Target Text",
        project_list_page_tabPane_1_dropdownItem_2: "Bilingual (Source First)",
        project_list_page_tabPane_1_dropdownItem_3: "Download Source Text",
        project_list_page_tabPane_1_dropdownItem_4: "Download TMX",
        project_list_page_tabPane_1_dropdownItem_5: "Download Edit History",
        project_list_page_tabPane_1_dropdownItem_6: "Download Merged Quote",
        project_list_page_tabPane_1_dropdownItem_7: "Bilingual (Target First)",
        component_FileListInside_table_column_1: "File Name",
        component_FileListInside_table_column_2: "Lang Direction",
        component_FileListInside_table_column_3: "Words / Chars",
        component_FileListInside_table_column_4: "Progress",
        component_FileListInside_table_column_5: "Owner",
        component_FileListInside_table_column_6: "Time",
        component_FileListInside_table_column_7: "Action",
        component_FileListInside_tips_1: "Segment",
        component_FileListInside_tips_2: "Words",
        component_FileListInside_tips_3: "Reject Reason：",
        component_FileListInside_tips_4: "Return",
        component_FileListInside_tips_5: "(Return)",
        component_FileListInside_tips_6: "Change Assigned To",
        component_FileListInside_tips_7: "Assign Assigned User",
        component_FileListInside_tips_8: "About {size} people",
        component_FileListInside_tips_9: "Unassigned",
        component_FileListInside_tips_10: "Not set",
        component_FileListInside_tips_11: "View Contact",
        component_FileListInside_tips_12: "Return to this stage",
        component_FileListInside_tips_13: "View Quote",
        component_FileListInside_tips_14: "Words",
        component_FileListInside_tips_15: "Characters",
        component_FileListInside_tips_16: "Character traffic insufficient",
        component_FileListInside_tips_17:
            "Click retry on this page after a successful purchase",
        component_FileListInside_tips_18: "Split",
        component_FileListInside_tips_19: "View",
        component_FileListInside_tips_20: "Download",
        component_FileListInside_tips_21: "Modify process",
        component_FileListInside_tips_22: "View History",
        component_FileListInside_tips_23: "Delete File",
        component_FileListInside_input_placeholder_1: "Select Due Date",
        component_FileListInside_btn_1: "Purchase Character Pack",
        component_FileListInside_btn_2: "Retranslate",
        component_FileListInside_dropdownItem_1: "Download Target Text",
        component_FileListInside_dropdownItem_2: "Bilingual (Source First)",
        component_FileListInside_dropdownItem_3: "Download Source Text",
        component_FileListInside_dropdownItem_4: "Download TMX",
        component_FileListInside_dropdownItem_5: "Download Edit History",
        component_FileListInside_dropdownItem_6: "Bilingual (Target First)",
        component_FileListInside_dialog_1_title: "Contacts",
        component_FileListInside_dialog_2_title: "Return Task",
        component_FileListInside_dialog_2_tips_1:
            "The task will be returned to",
        component_FileListInside_dialog_2_tips_2: "stage",
        component_FileListInside_dialog_2_formItem_label_1: "Reason for Return",
        component_FileListInside_dialog_2_formItem_input_placeholder_1:
            "Please fill in the reason for return",
        component_FileListInside_dialog_2_btn_1: "Cancel",
        component_FileListInside_dialog_2_btn_2: "Confirm",
        component_FileListInside_dialog_3_title: "History",
        component_FileListInside_dialog_4_title: "Split",
        component_FileListInside_dialog_4_tips_1: "Split into",
        component_FileListInside_dialog_4_tips_2: "parts",
        component_FileListInside_dialog_4_tips_3:
            "Split the selected into one part",
        component_FileListInside_dialog_4_tips_4:
            "Use the rest as the other part",
        component_FileListInside_dialog_4_tips_5:
            "Part {size1}, Paragraph [{range}], total {size2} paragraph and {size3} sentences",
        component_FileListInside_dialog_4_table_column_1: "Paragraph ID",
        component_FileListInside_dialog_4_table_column_2: "Source",
        component_FileListInside_dialog_4_table_column_3: "Target",
        component_FileListInside_dialog_4_table_column_4: "Number of Parts",
        component_FileListInside_dialog_4_btn_1: "Cancel",
        component_FileListInside_dialog_4_btn_2: "Confirm",
        component_FileListInside_dialog_4_btn_3: "Split into One Part",
        component_FileListInside_dialog_5_title: "Task Quote",
        component_FileListInside_dialog_5_tips_1: "Total: ",
        component_FileListInside_dialog_5_tips_2: "Total Word Count: ",
        component_FileListInside_dialog_5_tips_3: "Billable Word Count",
        component_FileListInside_dialog_5_tips_4: "Unit Price: ",
        component_FileListInside_dialog_5_tips_5: "Currency: ",
        component_FileListInside_dialog_5_tips_6: "Additional Costs: ",
        component_FileListInside_dialog_5_tips_7: "Billing Unit: ",
        component_FileListInside_dialog_5_tips_8: "Affiliated Project: ",
        component_FileListInside_dialog_5_tips_9: "Analysis: ",
        component_FileListInside_dialog_5_table_column_1:
            "Untranslated elements",
        component_FileListInside_dialog_5_table_column_2:
            "Cross-file repetitions",
        component_FileListInside_dialog_5_table_column_3: "Repetitions",
        component_FileListInside_dialog_5_table_column_4: "102%",
        component_FileListInside_dialog_5_table_column_5: "101%",
        component_FileListInside_dialog_5_table_column_6: "100%",
        component_FileListInside_dialog_5_table_column_7: "95%-99%",
        component_FileListInside_dialog_5_table_column_8: "85%-94%",
        component_FileListInside_dialog_5_table_column_9: "75%-84%",
        component_FileListInside_dialog_5_table_column_10: "50%-74%",
        component_FileListInside_dialog_5_table_column_11: "New",
        component_FileListInside_dialog_5_table_column_12:
            "Billable Word Count",
        component_FileListInside_dialog_5_table_column_13: "Total Price",
        component_FileListInside_dialog_5_btn_1: "Close",
        component_FileListInside_dialog_5_btn_2: "Download Quote",
        component_FileListInside_data_typeRadioOptions_name_1:
            "Manual Splitting",
        component_FileListInside_data_typeRadioOptions_name_2: "Auto Splitting",
        component_FileListInside_method_showAssignDialog_message_1:
            "Current task {status}, cannot be assigned.",
        component_FileListInside_method_setDeadLineTime_message_1:
            "Deadline must be after the upload date",
        component_FileListInside_method_submitRejectEvent_message_1:
            "Please fill in the reason for return",
        component_FileListInside_method_copyText_message_1:
            "Copied to clipboard",
        component_FileListInside_method_copyText_message_2:
            "Failed to copy to clipboard, please try again",
        component_FileListInside_method_submitSplitEvent_message_1:
            "Document split successfully",
        component_FileListInside_method_submitSplitEvent_message_2:
            "There are unsplit segments {range}. Please complete the splitting before submitting",
        component_FileListInside_method_downloadOfferEvent_message_1: "Quote",
        component_FileListInside_method_splitBtnEvent_message_1:
            "All paragraphs are split",
        component_FileListInside_method_splitBtnEvent_message_2:
            "Please select the paragraph to split",
        component_FileListInside_method_setSplitList_message_1:
            "Remaining paragraphs",
        component_FileListInside_method_setSplitList_message_2:
            "Split failed, please select consecutive paragraph,  selected paragraph: {range}, missing paragraph: [{numbers}]",
        component_FileListInside_method_splitDialogTableIndexMethod_message_1:
            "Paragraph {number}",
        component_FileList_table_column_1: "File Name",
        component_FileList_table_column_2: "MT Status",
        component_FileList_table_column_3: "Post-editing Progress",
        component_FileList_table_column_4: "Words / Chars",
        component_FileList_table_column_5: "Uploaded time",
        component_FileList_table_column_6: "Action",
        component_FileList_tips_1: "LIMITED",
        component_FileList_tips_2:
            "Click retry on this page after a successful purchase",
        component_FileList_tips_3:
            "After editing the translation on the post-editing page, click the ‘Confirm’ button on the right to update the progress of the post-editing",
        component_FileList_tips_4: "Post-editing Progress",
        component_FileList_tips_5: "WORD",
        component_FileList_tips_6: "Characters",
        component_FileList_tips_7: "Delete File",
        component_FileList_btn_1: "Purchase Character Pack",
        component_FileList_btn_2: "Retranslate",
        component_FileList_dropdown_item_1: "Download Target Text",
        component_FileList_dropdown_item_2: "Bilingual (Source First)",
        component_FileList_dropdown_item_3: "Download Source Text",
        component_FileList_dropdown_item_4: "Download TMX",
        component_FileList_dropdown_item_5: "Bilingual (Target First)",
        project_list_page_tabPane_2_label: "Task Planning",
        component_TaskPlanList_btn_1: "Refresh",
        component_TaskPlanList_btn_2: "Assign",
        component_TaskPlanList_btn_3: "Time",
        component_TaskPlanList_select_placeholder_1: "File",
        component_TaskPlanList_select_placeholder_2: "Task Type",
        component_TaskPlanList_select_placeholder_3: "Target",
        component_TaskPlanList_select_placeholder_4: "Owner",
        component_TaskPlanList_select_placeholder_5: "Status",
        component_TaskPlanList_input_placeholder_1: "Select Due Date",
        component_TaskPlanList_tips_1:
            "Task planning page only shows unaccepted tasks, allowing for batch assignment and timed scheduling",
        component_TaskPlanList_tips_2: "(Return)",
        component_TaskPlanList_tips_3: "Segment",
        component_TaskPlanList_tips_4: "Not started",
        component_TaskPlanList_tips_5: "Not set",
        component_TaskPlanList_tips_6: "Change Assigned To",
        component_TaskPlanList_tips_7: "Assign Assigned User",
        component_TaskPlanList_tips_8: "About {size} people",
        component_TaskPlanList_tips_9: "Unassigned",
        component_TaskPlanList_tips_10: "View Contact",
        component_TaskPlanList_tips_11: "etc.",
        component_TaskPlanList_tips_12: "Tasks",
        component_TaskPlanList_table_column_1: "Task",
        component_TaskPlanList_table_column_2: "Segment",
        component_TaskPlanList_table_column_3: "File Name",
        component_TaskPlanList_table_column_4: "Lang Direction",
        component_TaskPlanList_table_column_5: "Launched in",
        component_TaskPlanList_table_column_6: "Deadline",
        component_TaskPlanList_table_column_7: "Status",
        component_TaskPlanList_table_column_8: "Owner",
        component_TaskPlanList_table_column_9: "Action",
        component_TaskPlanList_dialog_1_title: "Contacts",
        component_TaskPlanList_dialog_2_title: "Task Crontab",
        component_TaskPlanList_dialog_2_input_placeholder_1: "Select Due Date",
        component_TaskPlanList_dialog_2_btn_1: "Cancel",
        component_TaskPlanList_dialog_2_btn_2: "Confirm",
        component_TaskPlanList_method_batchAssignTask_message_1:
            "Please select a task",
        component_TaskPlanList_method_batchSetDeadline_message_1:
            "Please select a task",
        component_TaskPlanList_method_submitDeadlineEvent_message_1:
            "Please select a due date",
        component_TaskPlanList_method_copyText_message_1: "Copied to clipboard",
        component_TaskPlanList_method_copyText_message_2:
            "Failed to copy to clipboard, please try again",
        project_list_page_tabPane_3_label: "Base Settings",
        project_list_page_tabPane_3_tips_1: "Project Name",
        project_list_page_tabPane_3_tips_2: "Team Owner",
        project_list_page_tabPane_3_tips_3: "Creator",
        project_list_page_tabPane_3_tips_4: "Created: ",
        project_list_page_tabPane_3_tips_5: "Workflow",
        project_list_page_tabPane_3_tips_6: "Lang Direction",
        project_list_page_tabPane_3_tips_7: "Pre-Translation Model",
        project_list_page_tabPane_3_tips_8: "Reference Translation Model",
        project_list_page_tabPane_3_tips_9: "Manual translation",
        project_list_page_tabPane_3_tips_10: "Advanced Settings",
        project_list_page_tabPane_3_tips_11:
            "1. Locked items in the editor are prioritized as follows: non-translatable elements > repeats > cross-file repeats > 100% > 101% > 102%",
        project_list_page_tabPane_3_tips_12:
            "2. The word count setting for pricing affects all files, while the lock setting only applies to new files",
        project_list_page_tabPane_3_tips_13: "Lock settings",
        project_list_page_tabPane_3_tips_14: "Billable Word Count",
        project_list_page_tabPane_3_tips_15: "Auto-replace",
        project_list_page_tabPane_3_input_placeholder_1: "Enter project name",
        project_list_page_tabPane_3_select_placeholder_1: "Please select",
        project_list_page_tabPane_3_btn_1: "Confirm",
        project_list_page_tabPane_3_btn_2: "Save",
        project_list_page_tabPane_4_label: "Translation Memory",
        project_list_page_tabPane_4_btn_1: "Create new",
        project_list_page_tabPane_4_btn_2: "Refresh",
        project_list_page_tabPane_4_tips_1: "Match Rate",
        project_list_page_tabPane_4_tips_2: "Entries",
        project_list_page_tabPane_4_select_placeholder_1: "Match Rate",
        project_list_page_tabPane_4_table_column_1: "Write",
        project_list_page_tabPane_4_table_column_2: "Name",
        project_list_page_tabPane_4_table_column_3: "Lang Direction",
        project_list_page_tabPane_4_table_column_4: "Entries",
        project_list_page_tabPane_4_table_column_5: "Penalty",
        project_list_page_tabPane_4_table_column_6: "Created: ",
        project_list_page_tabPane_5_label: "Termbase",
        project_list_page_tabPane_5_tips_1:
            "Project terminology will be suggested in the editor, but the current version does not support terminology intervention.",
        project_list_page_tabPane_5_tips_2:
            "Upgrade to PRO to try this feature",
        project_list_page_tabPane_5_tips_3: "{type} supports term intervention",
        project_list_page_tabPane_5_tips_4: "Entries",
        project_list_page_tabPane_5_btn_1: "Create new",
        project_list_page_tabPane_5_btn_2: "Refresh",
        project_list_page_tabPane_5_table_column_1: "Write",
        project_list_page_tabPane_5_table_column_2: "Name",
        project_list_page_tabPane_5_table_column_3: "Lang Direction",
        project_list_page_tabPane_5_table_column_4: "Entries",
        project_list_page_tabPane_5_table_column_5: "Created: ",
        project_list_page_tabPane_6_label: "Document settings",
        project_list_page_tabPane_6_checkbox_label_1: "Select All",
        project_list_page_tabPane_7_label: "QA Settings",
        project_list_page_tabPane_7_tips_1: "Rule-based QA",
        project_list_page_tabPane_7_tips_2: "Intelligent QA",
        project_list_page_tabPane_7_tips_3: "QA Process Settings",
        project_list_page_tabPane_7_tips_4: "Submission allowed only after QA",
        project_list_page_tabPane_8_label: "Style Guide",
        project_list_page_tabPane_8_tips_1: "Notes",
        project_list_page_tabPane_8_tips_2: "No notes yet",
        project_list_page_tabPane_8_input_placeholder_1: "Enter project note",
        project_list_page_tabPane_8_btn_1: "Add File",
        project_list_page_tabPane_8_table_column_1: "No.",
        project_list_page_tabPane_8_table_column_2: "File Name",
        project_list_page_tabPane_8_table_column_3: "Created Time",
        project_list_page_tabPane_8_table_column_4: "Action",
        project_list_page_tabPane_8_dialog_1_title: "Upload Style Guide File",
        project_list_page_tabPane_8_dialog_1_tips_1:
            "Maximum number of current items to upload",
        project_list_page_tabPane_8_dialog_1_tips_2:
            "files. If you have multiple files, it's recommended to upload a zip file.",
        project_list_page_tabPane_8_dialog_1_btn_1: "Cancel",
        project_list_page_tabPane_8_dialog_1_btn_2: "Confirm",
        project_list_page_tabPane_9_label: "Analysis",
        component_FileAnalysis_tips_1: "Statistical dimension: ",
        component_FileAnalysis_tips_2: "Total",
        component_FileAnalysis_tips_3: "All matches below 50% are new",
        component_FileAnalysis_tips_4:
            "The match is 100% with the current paragraph and extends to the adjacent paragraph",
        component_FileAnalysis_tips_5:
            "The current and adjacent paragraphs are identical to the content in the memory bank",
        component_FileAnalysis_tips_6:
            "The percentage results are rounded to the nearest whole number, for reference only",
        component_FileAnalysis_tips_7: "%",
        component_FileAnalysis_tips_8:
            "Each Chinese character equals one character. English words are counted by their letter count, e.g., a 5-letter word equals 5 characters.",
        component_FileAnalysis_tips_9: "Character Count",
        component_FileAnalysis_tips_10:
            "Each Chinese character is counted as one word; an English word is also counted as one word.",
        component_FileAnalysis_tips_11: "Word Count",
        component_FileAnalysis_tips_12:
            "Count includes Chinese characters and Korean words only, not English or Arabic numbers.",
        component_FileAnalysis_tips_13: "Chinese-Korean Word Count",
        component_FileAnalysis_select_placeholder_1: "Please select",
        component_FileAnalysis_btn_1: "Download Analysis Report",
        component_FileAnalysis_table_column_1: "Segment",
        component_FileAnalysis_table_column_2: "Chinese-Korean Word Count",
        component_FileAnalysis_method_downloadFileAnalysis_title:
            "{name} Analysis Report",
        project_list_page_tabPane_10_label: "Total Tasks",
        component_ProjectTaskStatisticsTableList_btn_1: "Download",
        project_list_page_tabPane_11_label: "Auto-scored",
        project_list_page_tabPane_11_form_item_label_1: "Auto-scored",
        project_list_page_tabPane_11_form_item_label_2: "Rating Threshold",
        project_list_page_tabPane_11_tips_1: "AI rates pre-translation",
        project_list_page_tabPane_11_tips_2:
            "Mark translations with a score below this as high-risk segments",
        component_ProjectTaskStatisticsTableList_tips_1:
            "No task start time yet",
        component_ProjectTaskStatisticsTableList_tips_2: "No task end time yet",
        component_ProjectTaskStatisticsTableList_tips_3: "%",
        component_ProjectTaskStatisticsTableList_table_column_1: "Owner",
        component_ProjectTaskStatisticsTableList_table_column_2: "Task Name",
        component_ProjectTaskStatisticsTableList_table_column_3: "Task Type",
        component_ProjectTaskStatisticsTableList_table_column_4:
            "Lang Direction",
        component_ProjectTaskStatisticsTableList_table_column_5: "Task Period",
        component_ProjectTaskStatisticsTableList_table_column_6:
            "Task Progress",
        component_ProjectTaskStatisticsTableList_table_column_7:
            "Task Word Count",
        component_ProjectTaskStatisticsTableList_table_column_8:
            "Billable Word Count",
        component_ProjectTaskStatisticsTableList_table_column_9: "Unit Price",
        component_ProjectTaskStatisticsTableList_table_column_10: "Currency",
        component_ProjectTaskStatisticsTableList_table_column_11: "Total Price",
        component_ProjectTaskStatisticsTableList_method_handleDownloadBtnEvent_title:
            "Total Tasks",
        project_list_page_dialog_1_title: "Add File",
        project_list_page_dialog_1_tips_1:
            "Maximum number of current items to upload",
        project_list_page_dialog_1_tips_2: "file(s), more uploads available",
        project_list_page_dialog_1_tips_3: "files(s)",
        project_list_page_dialog_1_btn_1: "Cancel",
        project_list_page_dialog_1_btn_2: "Confirm",
        project_list_page_dialog_2_title: "Prompt",
        project_list_page_dialog_2_tips_1:
            "Only unstarted project documents can be reset for process changes; started documents must be edited individually in the project files.",
        project_list_page_dialog_2_tips_2:
            "Are you sure to modify the project process?",
        project_list_page_dialog_2_btn_1: "Cancel",
        project_list_page_dialog_2_btn_2: "Confirm",
        project_list_page_dialog_3_title: "Prompt",
        project_list_page_dialog_3_tips_1:
            "Note: Modifying the process for started files will reset all content (including responsible person, progress, and edits). Proceed with caution!",
        project_list_page_dialog_3_tips_2:
            "Are you sure to modify the translation process for the current file?",
        project_list_page_dialog_3_btn_1: "Cancel",
        project_list_page_dialog_3_btn_2: "Confirm",
        project_list_page_dialog_4_title: "Modify File Process",
        project_list_page_dialog_4_form_item_label_1: "File Process",
        project_list_page_dialog_4_btn_1: "Cancel",
        project_list_page_dialog_4_btn_2: "Confirm",
        project_list_page_data_upload_supportFiles:
            "Support files in {type} formats",
        project_list_page_data_alertInfo_message:
            "Are you sure to delete items?",
        project_list_page_data_alertInfo_buttonName: "Confirm Deletion",
        project_list_page_method_deleteDocumentEvent_message_1: "Deleted",
        project_list_page_method_batchDeleteBtnEvent_message_1:
            "Please select projects to delete first.",
        project_list_page_method_handleBatchDownloadCommand_message_1:
            "Please select projects to download first",
        project_list_page_method_handleBatchDownloadCommand_message_2:
            "Exporting {size} projects.",
        project_list_page_method_submitAppendFile_message_1:
            "The newly uploaded file contains {size} files with the same name. Please rename the file before uploading",
        project_list_page_method_saveProjectName_message_1:
            "Project name modified successfully",
        project_list_page_method_saveProjectRemark_message_1:
            "Project note modified successfully",
        project_list_page_method_saveProjectWorkflowEdit_message_1:
            "Project process modified successfully",
        project_list_page_method_saveFlieWorkflowEdit_message_1:
            "File flow modified successfully",
        project_list_page_method_setProjectsSetting_message_1: "Saving...",
        project_list_page_method_handleMemoryPenaltyPointsChange_message_1:
            "Saving...",
        project_list_page_method_qaSettingItemChange_message_1: "Saving...",
        project_list_page_method_updateRemarkFile_message_1: "Saving...",
        project_list_page_method_downloadBatchOfferEvent_title:
            "{name}-Quotation",
        project_list_page_method_submitFileAnalysisSettingDialog_message_1:
            "Saving...",
        project_list_page_method_submitAutoReplaceOptsDialog_message_1:
            "Saving...",
        project_list_page_method_saveRatingSettings_message_1: "Saving...",
        component_TaskAssignDialog_dialog_title: "Task assignment",
        component_TaskAssignDialog_dialog_tips_1: "{size} sentences",
        component_TaskAssignDialog_dialog_tips_2: "etc.",
        component_TaskAssignDialog_dialog_tips_3: "tasks",
        component_TaskAssignDialog_dialog_tips_4: "{size} words",
        component_TaskAssignDialog_dialog_tips_5: "Principal: ",
        component_TaskAssignDialog_dialog_tips_6: "About {size} people",
        component_TaskAssignDialog_dialog_tips_7:
            "Premied Vendor List is selected resources provided by the resource center",
        component_TaskAssignDialog_dialog_tips_8: "contains",
        component_TaskAssignDialog_dialog_tips_9: "between",
        component_TaskAssignDialog_dialog_tips_10: "Additional Costs: ",
        component_TaskAssignDialog_dialog_tips_11:
            "Total Cost = Unit Price * Word Count + Additional Costs",
        component_TaskAssignDialog_dialog_tips_12: "Segment",
        component_TaskAssignDialog_dialog_tips_13:
            "If multiple people are selected, it is starting an assign mode, where the first person to accept the task becomes the task principal",
        component_TaskAssignDialog_dialog_tips_14:
            "Supports internal translators in querying bilingual pairs for the current task",
        component_TaskAssignDialog_dialog_btn_1: "Collapse",
        component_TaskAssignDialog_dialog_btn_2: "Search",
        component_TaskAssignDialog_dialog_btn_3: "Clear All",
        component_TaskAssignDialog_dialog_btn_4: "Cancel",
        component_TaskAssignDialog_dialog_btn_5: "Confirm",
        component_TaskAssignDialog_dialog_input_placeholder_1: "Enter Name",
        component_TaskAssignDialog_dialog_input_placeholder_2:
            "/Phone number/E-mail",
        component_TaskAssignDialog_dialog_input_placeholder_3:
            "/Phone tail number",
        component_TaskAssignDialog_dialog_input_placeholder_4: "Search",
        component_TaskAssignDialog_dialog_input_placeholder_5: "Lowest price",
        component_TaskAssignDialog_dialog_input_placeholder_6: "Highest price",
        component_TaskAssignDialog_dialog_checkbox_label_1:
            "Find only in PVL table",
        component_TaskAssignDialog_dialog_checkbox_label_2:
            "Query internal translators only",
        component_TaskAssignDialog_dialog_form_item_1_label: "Business Line",
        component_TaskAssignDialog_dialog_form_item_2_label: "Customer",
        component_TaskAssignDialog_dialog_form_item_3_label: "Task Type",
        component_TaskAssignDialog_dialog_form_item_4_label: "Statistical Unit",
        component_TaskAssignDialog_dialog_form_item_5_label:
            "Fields of expertise",
        component_TaskAssignDialog_dialog_form_item_6_label: "Currency",
        component_TaskAssignDialog_dialog_form_item_7_label: "CAT Tools",
        component_TaskAssignDialog_dialog_form_item_8_label: "Price Range",
        component_TaskAssignDialog_dialog_form_item_placeholder_1:
            "Please select",
        component_TaskAssignDialog_dialog_table_column_1: "Name",
        component_TaskAssignDialog_dialog_table_column_2: "Roles",
        component_TaskAssignDialog_dialog_table_column_3: "Task Type",
        component_TaskAssignDialog_dialog_table_column_4: "Fields of expertise",
        component_TaskAssignDialog_dialog_table_column_5: "Unit Price",
        component_TaskAssignDialog_dialog_table_column_6: "Statistical Unit",
        component_TaskAssignDialog_dialog_table_column_7: "Currency",
        component_TaskAssignDialog_dialog_table_column_8: "Roles",
        component_TaskAssignDialog_dialog_table_column_9: "Task Type",
        component_TaskAssignDialog_dialog_table_column_10: "Task unit price",
        component_TaskAssignDialog_dialog_table_column_11:
            "Billable Word Count",
        component_TaskAssignDialog_dialog_table_column_12: "Total price",
        component_TaskAssignDialog_dialog_table_column_13: "Source",
        component_TaskAssignDialog_dialog_table_column_14: "Target",
        component_TaskAssignDialog_dialog_method_submitAssignEvent_message_1:
            "Please select a principal",
        component_TaskAssignDialog_dialog_method_rowClickEvent_message_1:
            "Unable to assign, please contact user for phone number and try again",
        project_task_statistics_page_tab_pane_label_1: "All",
        project_task_statistics_page_tab_pane_label_2: "ASSIGNED",
        project_task_statistics_page_tab_pane_label_3: "IN_PROGRESS",
        project_task_statistics_page_tab_pane_label_4: "FINISHED",
        project_task_statistics_page_tips_1: "Refresh",
        project_task_statistics_page_tips_2: "No task start time yet",
        project_task_statistics_page_tips_3: "No task end time yet",
        project_task_statistics_page_tips_4: "%",
        project_task_statistics_page_form_item_label_1: "Team Owner",
        project_task_statistics_page_form_item_label_2: "Project Creator",
        project_task_statistics_page_form_item_label_3: "Task Manager",
        project_task_statistics_page_form_item_label_4: "Task Type",
        project_task_statistics_page_form_item_label_5: "Source",
        project_task_statistics_page_form_item_label_6: "Target",
        project_task_statistics_page_form_item_label_7: "Start Date",
        project_task_statistics_page_form_item_label_8: "End Date",
        project_task_statistics_page_select_placeholder_1: "Team Owner",
        project_task_statistics_page_select_placeholder_2: "Project Creator",
        project_task_statistics_page_select_placeholder_3: "Task Manager",
        project_task_statistics_page_select_placeholder_4: "Task Type",
        project_task_statistics_page_select_placeholder_5: "Source",
        project_task_statistics_page_select_placeholder_6: "Target",
        project_task_statistics_page_select_placeholder_7: "Start Date",
        project_task_statistics_page_select_placeholder_8: "End Date",
        project_task_statistics_page_input_placeholder_1: "Search tasks",
        project_task_statistics_page_table_column_1: "Task Name",
        project_task_statistics_page_table_column_2: "Owner",
        project_task_statistics_page_table_column_3: "Task Type",
        project_task_statistics_page_table_column_4: "Project Name",
        project_task_statistics_page_table_column_5: "Project Creator",
        project_task_statistics_page_table_column_6: "Lang Direction",
        project_task_statistics_page_table_column_7: "Task Period",
        project_task_statistics_page_table_column_8: "Status",
        project_task_statistics_page_table_column_9: "Task Progress",
        project_task_statistics_page_table_column_10: "Task Word Count",
        project_task_statistics_page_table_column_11: "Billable Word Count",
        project_task_statistics_page_table_column_12: "Unit Price",
        project_task_statistics_page_table_column_13: "Currency",
        project_task_statistics_page_table_column_14: "Total Price",
        project_task_statistics_page_method_downloadBtnEvent_title:
            "Total Tasks",
        project_template_page_btn_1: "Refresh",
        project_template_page_btn_2: "Delete",
        project_template_page_btn_3: "Create",
        project_template_page_input_placeholder_1: "Enter Template Name",
        project_template_page_table_column_1: "Project Template Name",
        project_template_page_table_column_2: "Lang Direction",
        project_template_page_table_column_3: "Workflow",
        project_template_page_table_column_4: "Team Owner",
        project_template_page_table_column_5: "Creator",
        project_template_page_table_column_6: "Created: ",
        project_template_page_table_column_7: "Action",
        project_template_page_dropdown_item_1: "Rename",
        project_template_page_dropdown_item_2: "Delete",
        project_template_page_dropdown_item_3: "Copy",
        project_template_page_dropdown_item_4: "Edit",
        project_template_page_dialog_1_title: "Rename Template",
        project_template_page_dialog_1_input_placeholder_1:
            "Enter Template Name",
        project_template_page_dialog_1_btn_1: "Cancel",
        project_template_page_dialog_1_btn_2: "Confirm",
        project_template_page_data_alertInfo_message:
            "Are you sure to delete this template?",
        project_template_page_data_alertInfo_buttonName: "Confirm",
        project_template_page_method_saveRenameBtnEvent_message_1:
            "Please enter a template name",
        project_template_page_method_saveRenameBtnEvent_message_2:
            "Rename successfully",
        project_template_page_method_deleteBtnEvent_message_1:
            "Please select a template",
        project_template_page_method_deleteBtnEvent_message_2:
            "Are you sure to delete the selected project templates?",
        project_template_page_method_deleteTemplateItem_message_1:
            "Are you sure to delete the project template?",
        project_template_page_method_deleteConfirmEvent_message_1:
            "Deleted successfully",
        project_template_page_method_copyTemplate_message_1:
            "Copied Successfully",
        project_templateDetail_page_btn_1: "Save Template",
        project_templateDetail_page_tab_pane_label_1: "Base Settings",
        project_templateDetail_page_tab_pane_label_2: "Translation Memory",
        project_templateDetail_page_tab_pane_label_3: "Termbase",
        project_templateDetail_page_tab_pane_label_4: "Document settings",
        project_templateDetail_page_tab_pane_label_5: "QA Settings",
        project_templateDetail_page_tab_pane_label_6: "Style Guide",
        project_templateDetail_page_tab_pane_label_7: "Auto-scored",
        project_templateDetail_page_tips_1:
            "Once the basic settings are completed, the template can be saved, please save regularly to prevent data loss, shortcut:",
        project_templateDetail_page_tips_2: "Template Name",
        project_templateDetail_page_tips_3: "Team Owner",
        project_templateDetail_page_tips_4: "Project Process",
        project_templateDetail_page_tips_5: "Language Direction",
        project_templateDetail_page_tips_6: "Pre-translation Model",
        project_templateDetail_page_tips_7:
            "Reference Translation Model (not necessary)",
        project_templateDetail_page_tips_8: "Manual Translation",
        project_templateDetail_page_tips_9:
            "Set translation model after selecting source and target language",
        project_templateDetail_page_tips_10: "Advanced Settings",
        project_templateDetail_page_tips_11:
            "1. The priority order of locked items in the editor is: Non-translatable elements",
        project_templateDetail_page_tips_12:
            "2. The word count settings apply to all files; locked settings only apply to additional files",
        project_templateDetail_page_tips_13: "Auto-replace",
        project_templateDetail_page_tips_14: "Lock Settings",
        project_templateDetail_page_tips_15: "Billable Word Count",
        project_templateDetail_page_tips_16: "Creator",
        project_templateDetail_page_tips_17: "Created Time",
        project_templateDetail_page_tips_18: "Modified Time",
        project_templateDetail_page_tips_19: "Match Rate",
        project_templateDetail_page_tips_20: "Entries",
        project_templateDetail_page_tips_21: "Select All",
        project_templateDetail_page_tips_22: "Rule-based QA settings",
        project_templateDetail_page_tips_23: "Intelligent QA settings",
        project_templateDetail_page_tips_24: "QA Process Settings",
        project_templateDetail_page_tips_25: "Submission allowed only after QA",
        project_templateDetail_page_tips_26: "Notes",
        project_templateDetail_page_tips_27: "Auto-scored",
        project_templateDetail_page_tips_28: "AI rates pre-translation",
        project_templateDetail_page_tips_29: "Rating Threshold",
        project_templateDetail_page_tips_30:
            "Mark translations with a score below this as high-risk segments",
        project_templateDetail_page_placeholder_1: "Enter Template Name",
        project_templateDetail_page_placeholder_2: "Select Team",
        project_templateDetail_page_placeholder_3: "Select Workflow",
        project_templateDetail_page_placeholder_4: "Select Source Language",
        project_templateDetail_page_placeholder_5: "Select Target Language",
        project_templateDetail_page_placeholder_6:
            "Select Pre-Translation Model",
        project_templateDetail_page_placeholder_7:
            "Select Reference Translation Model",
        project_templateDetail_page_placeholder_8: "Match Rate",
        project_templateDetail_page_placeholder_9: "Enter Note Description",
        project_templateDetail_page_table_column_1: "Write",
        project_templateDetail_page_table_column_2: "Name",
        project_templateDetail_page_table_column_3: "Lang Direction",
        project_templateDetail_page_table_column_4: "Entries",
        project_templateDetail_page_table_column_5: "Penalty",
        project_templateDetail_page_table_column_6: "Created Time",
        project_templateDetail_page_table_column_7: "Serial number",
        project_templateDetail_page_table_column_8: "File Name",
        project_templateDetail_page_table_column_9: "Created Time",
        project_templateDetail_page_table_column_10: "Action",
        project_templateDetail_page_btn_1: "Create",
        project_templateDetail_page_btn_2: "Refresh",
        project_templateDetail_page_btn_3: "Add File",
        project_templateDetail_page_btn_4: "Cancel",
        project_templateDetail_page_btn_5: "Confirm",
        project_templateDetail_page_btn_6: "Save Template",
        project_templateDetail_page_dialog_1_title: "Upload Style Guide File",
        project_templateDetail_page_dialog_1_tips_1:
            "Maximum number of current items to upload",
        project_templateDetail_page_dialog_1_tips_2:
            "files. If you have multiple files, zip file is recommended",
        project_templateDetail_page_method_settingTabChange_message_1:
            "Please select source and target language first",
        project_templateDetail_page_method_saveTemplateBtnEvent_message_1:
            "Template edited successfully",
        project_templateDetail_page_method_saveTemplateBtnEvent_message_2:
            "New template created successfully",
        project_templateDetail_page_method_saveTemplateBtnEvent_message_3:
            "Please enter the template name",
        project_templateDetail_page_method_saveTemplateBtnEvent_message_4:
            "Please select the team",
        project_templateDetail_page_method_saveTemplateBtnEvent_message_5:
            "Please select source language",
        project_templateDetail_page_method_saveTemplateBtnEvent_message_6:
            "Please select target language",
    },
    asset: {
        memory_index_page_button_text_1: "Create Translation Memory",
        memory_index_page_button_text_2: "Merge Translation Memories",
        memory_index_page_button_text_3: "Delete Memory",
        memory_index_page_tab_label_1: "All",
        memory_index_page_tab_label_2: "Self-build TM",
        memory_index_page_tab_label_3: "Default TM",
        memory_index_page_tab_label_4: "My TM",
        memory_index_page_search_input_placeholder: "Full Search",
        memory_index_page_search_select_placeholder_1: "Source",
        memory_index_page_search_select_placeholder_2: "Target",
        memory_index_page_search_select_placeholder_3: "Team Owner",
        memory_index_page_search_select_placeholder_4: "Creator",
        memory_index_page_search_select_placeholder_5: "Created: ",
        memory_index_page_search_select_placeholder_6: "Do you want to merge",
        memory_index_page_tips_1: "Toggle",
        memory_index_page_tips_2: " List",
        memory_index_page_tips_3: "Card",
        memory_index_page_tips_4: " View",
        memory_index_page_card_item_label_1: "Translation Memory Name: ",
        memory_index_page_card_item_label_2: "Team Owner: ",
        memory_index_page_card_item_label_3: "Creator: ",
        memory_index_page_card_item_label_4: "Entries",
        memory_index_page_card_item_label_5: "Created Time:",
        memory_index_page_card_item_label_6: "Last Updated by: ",
        memory_index_page_card_item_label_7: "Last Updated: ",
        memory_index_page_card_item_dropdown_label_1: "View",
        memory_index_page_card_item_dropdown_label_2: "Download Excel",
        memory_index_page_card_item_dropdown_label_3: "Download TMX",
        memory_index_page_card_item_dropdown_label_4: "Rename",
        memory_index_page_card_item_dropdown_label_5: "Delete",
        memory_index_page_table_column_item_label_1: "Translation Memory Name",
        memory_index_page_table_column_item_label_2: "Lang Direction",
        memory_index_page_table_column_item_label_3: "Entries",
        memory_index_page_table_column_item_label_4: "Creator",
        memory_index_page_table_column_item_label_5: "Created: ",
        memory_index_page_table_column_item_label_6: "Action",
        memory_index_page_empty_label_1: "No translation memories found～",
        memory_index_page_empty_label_2:
            "No translation memories yet, go create one～",
        memory_index_page_dialog_1_title: "Rename Translation Memory",
        memory_index_page_dialog_1_form_item_label_1: "Name",
        memory_index_page_dialog_1_form_item_placeholder_1:
            "Enter translation memory name",
        memory_index_page_dialog_1_btn_label_1: "Cancel",
        memory_index_page_dialog_1_btn_label_2: "Save",
        memory_index_page_dialog_2_title: "Merge Translation Memories",
        memory_index_page_dialog_2_form_item_label_1: "Translation Memory Name",
        memory_index_page_dialog_2_form_item_placeholder_1:
            "Enter translation memory name",
        memory_index_page_dialog_2_form_item_checkbox_label_2:
            "Delete original translation memories after merge",
        memory_index_page_dialog_2_form_item_label_2: "Settings",
        memory_index_page_dialog_2_form_item_radio_label_1:
            "Merge translation memories matching context",
        memory_index_page_dialog_2_form_item_radio_label_2:
            "Overwrite existing translation memories",
        memory_index_page_dialog_2_form_item_radio_label_3:
            "Keep new and old translation memories",
        memory_index_page_dialog_2_tips_1:
            "For translation memories with the same source text but different target translations: ",
        memory_index_page_dialog_2_btn_label_1: "Cancel",
        memory_index_page_dialog_2_btn_label_2: "Merge",
        memory_index_page_alert_info_message_1:
            "Are you sure you want to delete this memory?",
        memory_index_page_alert_info_buttonName_1: "Confirm Deletion",
        memory_index_page_mergeOptions_name_1: "Not merged",
        memory_index_page_mergeOptions_name_2: "Merged",
        memory_index_page_validation_message_1: "Permission denied",
        memory_index_page_validation_message_2:
            "Translation memory name is required",
        memory_index_page_validation_message_3:
            "Translation memory renamed successfully",
        memory_index_page_validation_message_4:
            "Please select two or more translation memories with the same language direction to merge",
        memory_index_page_validation_message_5:
            "Please select translation memories with the same language direction to merge",
        memory_index_page_validation_message_6:
            "Translation memory name cannot be empty",
        memory_index_page_validation_message_7:
            "Translation memories have been merged",
        memory_index_page_validation_message_8:
            "Translation memory has been deleted",
        memory_index_page_validation_message_9: "Please select memory",
        memory_detail_page_fullLoading_message: "Loading...",
        memory_detail_page_more_info_form_item_label_1: "Lang Direction",
        memory_detail_page_more_info_form_item_label_2: "Entries",
        memory_detail_page_more_info_form_item_label_2_1: "Entries",
        memory_detail_page_more_info_form_item_label_3: "Created Time",
        memory_detail_page_search_input_placeholder: "Enter translation",
        memory_detail_page_search_btn_label_1: "Delete",
        memory_detail_page_search_btn_label_2: "Upload Translation Memory",
        memory_detail_page_search_btn_label_3: "Download",
        memory_detail_page_search_btn_label_4: "Download Excel",
        memory_detail_page_search_btn_label_5: "Download TMX",
        memory_detail_page_table_colum_label_1: "No.",
        memory_detail_page_table_colum_label_2: "Source Text ({value})",
        memory_detail_page_table_colum_label_3: "Target Text ({value})",
        memory_detail_page_table_colum_label_4: "Action",
        memory_detail_page_table_colum_input_placeholder_1: "Enter source text",
        memory_detail_page_table_colum_input_placeholder_2: "Enter target text",
        memory_detail_page_table_colum_btn_tips_1: "Save",
        memory_detail_page_table_colum_btn_tips_2: "Delete",
        memory_detail_page_table_colum_btn_tips_3: "Edit",
        memory_detail_page_table_colum_tips_1: "Created Time:",
        memory_detail_page_table_colum_tips_2: "Creator: ",
        memory_detail_page_table_colum_tips_3: "Last Updated: ",
        memory_detail_page_table_colum_tips_4: "Last Updated by: ",
        memory_detail_page_table_colum_tips_5: "Source File Name: ",
        memory_detail_page_table_colum_tips_6: "Source project name: ",
        memory_detail_page_dialog_title_1: "Upload Translation Memory",
        memory_detail_page_dialog_message_1:
            "Support {value}, click to download template: ",
        memory_detail_page_dialog_1_btn_1: "Cancel",
        memory_detail_page_dialog_1_btn_2: "Confirm",
        memory_detail_page_alertInfo_message:
            "Are you sure you want to delete these translation memories?",
        memory_detail_page_alertInfo_buttonName: "Confirm Deletion",
        memory_detail_page_downloadTemplate_message: "Downloading...",
        memory_detail_page_validation_message_1:
            "Failed to get download address",
        memory_detail_page_validation_message_2: "Source text cannot be empty",
        memory_detail_page_validation_message_3: "Target text cannot be empty",
        memory_detail_page_validation_message_4:
            "Translation memory saved successfully",
        memory_detail_page_validation_message_5: "Source text cannot be empty",
        memory_detail_page_validation_message_6: "Target text cannot be empty",
        memory_detail_page_validation_message_7:
            "Translation memory saved successfully",
        memory_detail_page_validation_message_8:
            "Translation memory name is required",
        memory_detail_page_validation_message_9:
            "Translation memory renamed successfully",
        memory_detail_page_validation_message_10:
            "Translation memory has been deleted",
        memory_detail_page_validation_message_11:
            "Please confirm file upload is complete and successful",
        memory_detail_page_validation_message_12:
            "Upload completed: {totalCount} records detected, {successCount} successfully imported, {errorCount} discarded (empty content, identical source/target, or duplicates).",
        term_index_page_search_btn_label_1: "Create Termbase",
        term_index_page_search_btn_label_2: "Merge Termbases",
        term_index_page_search_btn_label_3: "Delete Term Base",
        term_index_page_tab_label_1: "All",
        term_index_page_tab_label_2: "Self-build TB",
        term_index_page_tab_label_3: "Default TB",
        term_index_page_tab_label_4: "My TB",
        term_index_page_search_input_placeholder: "Full Search",
        term_index_page_search_select_1_placeholder: "Source",
        term_index_page_search_select_2_placeholder: "Target",
        term_index_page_search_select_3_placeholder: "Team Owner",
        term_index_page_search_select_placeholder_4: "Creator",
        term_index_page_search_select_placeholder_5: "Created: ",
        term_index_page_search_select_placeholder_6: "Do you want to merge",
        term_index_page_tips_1: "Toggle",
        term_index_page_tips_2: " List",
        term_index_page_tips_3: "Card",
        term_index_page_tips_4: " View",
        term_index_page_item_tips_1: "Termbase Name",
        term_index_page_item_tips_2: "Team Owner: ",
        term_index_page_item_tips_3: "Creator: ",
        term_index_page_item_tips_4: "Entries",
        term_index_page_item_tips_5: "Created Time:",
        term_index_page_item_tips_6: "Last Updated by: ",
        term_index_page_item_tips_7: "Last Updated: ",
        term_index_page_item_dropdown_label_1: "View",
        term_index_page_item_dropdown_label_2: "Download Excel",
        term_index_page_item_dropdown_label_3: "Download TBX",
        term_index_page_item_dropdown_label_4: "Rename",
        term_index_page_item_dropdown_label_5: "Delete",
        term_index_page_empty_message_1: "No termbases found～",
        term_index_page_empty_message_2: "No termbases yet, go create one～",
        term_index_page_dialog_1_title: "Rename Termbase",
        term_index_page_dialog_1_form_item_label_1: "Name",
        term_index_page_dialog_1_form_item_placeholder_1: "Enter termbase name",
        term_index_page_dialog_1_btn_label_1: "Cancel",
        term_index_page_dialog_1_btn_label_2: "Save",
        term_index_page_dialog_2_title: "Merge Termbases",
        term_index_page_dialog_2_form_item_label_1: "Termbase Name",
        term_index_page_dialog_2_form_item_placeholder_1: "Enter termbase name",
        term_index_page_dialog_2_form_item_checkbox_label_1:
            "Delete original termbases after merge",
        term_index_page_dialog_2_form_item_label_2: "Settings",
        term_index_page_dialog_2_form_item_radio_label_1:
            "Overwrite existing terms",
        term_index_page_dialog_2_form_item_radio_label_2:
            "Keep new and old terms",
        term_index_page_dialog_2_tips_1:
            "For terms with the same source text but different translations: ",
        term_index_page_dialog_2_btn_label_1: "Cancel",
        term_index_page_dialog_2_btn_label_2: "Save",
        term_index_page_alertInfo_message: "Delete selected termbase?",
        term_index_page_alertInfo_buttonName: "Confirm Deletion",
        term_index_page_mergeOptions_name_1: "Not merged",
        term_index_page_mergeOptions_name_2: "Merged",
        term_index_page_validation_message_1: "Permission denied",
        term_index_page_validation_message_2: "Termbase name is required",
        term_index_page_validation_message_3: "Termbase renamed successfully",
        term_index_page_validation_message_4:
            "Please select two or more termbases with the same language direction to merge",
        term_index_page_validation_message_5:
            "Please select termbases with the same language direction to merge",
        term_index_page_validation_message_6: "Termbase name cannot be empty",
        term_index_page_validation_message_7: "Termbases have been merged",
        term_index_page_validation_message_8: "Termbases have been deleted",
        term_index_page_validation_message_9: "Please select a termbase",
        term_index_page_table_column_item_label_1: "Termbase Name",
        term_index_page_table_column_item_label_2: "Lang Direction",
        term_index_page_table_column_item_label_3: "Entries",
        term_index_page_table_column_item_label_4: "Creator",
        term_index_page_table_column_item_label_5: "Created Time",
        term_index_page_table_column_item_label_6: "Action",
        term_detail_page_more_info_form_item_label_1: "Lang Direction",
        term_detail_page_more_info_form_item_label_2: "Entries",
        term_detail_page_more_info_form_item_label_2_1: "Entries",
        term_detail_page_more_info_form_item_label_3: "Created Time",
        term_detail_page_search_input_placeholder: "Enter term",
        term_detail_page_search_btn_label_1: "Delete",
        term_detail_page_search_btn_label_2: "Upload Terminology",
        term_detail_page_search_btn_label_3: "Download",
        term_detail_page_search_btn_label_4: "Download Excel",
        term_detail_page_search_btn_label_5: "Download TBX",
        term_detail_page_table_colum_label_1: "No.",
        term_detail_page_table_colum_label_2: "Source Text ({value})",
        term_detail_page_table_colum_label_3: "Target Text ({value})",
        term_detail_page_table_colum_label_4: "Remarks",
        term_detail_page_table_colum_label_5: "Action",
        term_detail_page_table_colum_input_placeholder_1:
            "Enter term source text",
        term_detail_page_table_colum_input_placeholder_2:
            "Enter term target text",
        term_detail_page_table_colum_input_placeholder_3: "Enter remarks",
        term_detail_page_table_colum_btn_tips_1: "Save",
        term_detail_page_table_colum_btn_tips_2: "Delete",
        term_detail_page_table_colum_btn_tips_3: "Edit",
        term_detail_page_table_colum_tips_1: "Created Time:",
        term_detail_page_table_colum_tips_2: "Creator: ",
        term_detail_page_table_colum_tips_3: "Last Updated: ",
        term_detail_page_table_colum_tips_4: "Last Updated by: ",
        term_detail_page_dialog_title_1: "Upload Termbase",
        term_detail_page_dialog_message_1:
            "Support {value}, click to download template: ",
        term_detail_page_dialog_1_btn_1: "Cancel",
        term_detail_page_dialog_1_btn_2: "Confirm",
        term_detail_page_alertInfo_message:
            "Are you sure you want to delete these terms?",
        term_detail_page_alertInfo_buttonName: "Confirm Deletion",
        term_detail_page_downloadTemplate_message: "Downloading...",
        term_detail_page_validation_message_1:
            "Term source text cannot be empty",
        term_detail_page_validation_message_2:
            "Term target text cannot be empty",
        term_detail_page_validation_message_3: "Term saved successfully",
        term_detail_page_validation_message_4:
            "Term source text cannot be empty",
        term_detail_page_validation_message_5:
            "Term target text cannot be empty",
        term_detail_page_validation_message_6: "Term saved successfully",
        term_detail_page_validation_message_7: "Termbase name is required",
        term_detail_page_validation_message_8: "Termbase renamed successfully",
        term_detail_page_validation_message_9: "Term has been deleted",
        term_detail_page_validation_message_10:
            "Failed to get download address",
        term_detail_page_validation_message_11:
            "Please confirm file upload is complete and successful",
        term_detail_page_validation_message_12:
            "Upload completed: {totalCount} records detected, {successCount} successfully imported, {errorCount} discarded (excessive length, duplication, or language mismatch).",
        component_FulltextSearch_dialog_title_1:
            "Full-text Search in Translation Memory",
        component_FulltextSearch_dialog_title_2: "Full-text Search in Termbase",
        component_FulltextSearch_search_input_placeholder: "Enter keyword",
        component_FulltextSearch_search_select_placeholder: "Please select",
        component_FulltextSearch_search_select_option_1: "By title",
        component_FulltextSearch_search_select_option_2: "By content",
        component_FulltextSearch_search_btn_label: "Search",
        component_FulltextSearch_search_result_total:
            "Search results {total} items",
        component_FulltextSearch_search_result_param_name_1: "Team Owner: ",
        component_FulltextSearch_search_result_param_name_2: "Creator: ",
        component_FulltextSearch_search_result_param_name_3:
            "Language Direction: ",
        component_FulltextSearch_search_result_param_name_4:
            "Modification Time: ",
        component_FulltextSearch_search_result_param_label_1: "Entries",
        component_FulltextSearch_search_result_param_label_2: "Title: ",
        component_FulltextSearch_search_result_param_label_3: "Source Text: ",
        component_FulltextSearch_search_result_param_label_4: "Target Text: ",
        component_FulltextSearch_search_result_message_1: "Loading...",
        component_FulltextSearch_search_result_message_2:
            "All results displayed",
        component_FulltextSearch_validation_message_1:
            "Please enter search content",
        component_Tabs_tab_name_1: "Translation Memory",
        component_Tabs_tab_name_2: "Termbase",
        component_CreateMemory_dialog_title: "Create Translation Memory",
        component_CreateMemory_form_item_label_1: "Name",
        component_CreateMemory_form_item_placeholder_1:
            "Enter translation memory name",
        component_CreateMemory_form_item_label_2: "Language Pair",
        component_CreateMemory_form_item_placeholder_2: "Source",
        component_CreateMemory_form_item_placeholder_3: "Target",
        component_CreateMemory_form_item_label_3: "Team Owner",
        component_CreateMemory_form_item_placeholder_4: "Select Team",
        component_CreateMemory_form_item_label_4: "Upload Translation Memory",
        component_CreateMemory_form_item_message_1:
            "Support {type}, up to {size}M. Download template",
        component_CreateMemory_dialog_btn_label_1: "Cancel",
        component_CreateMemory_dialog_btn_label_2: "Save",
        component_CreateMemory_downloadTemplate_message: "Downloading...",
        component_CreateMemory_validation_message_1:
            "Failed to get download address",
        component_CreateMemory_validation_message_2:
            "Translation memory name is required",
        component_CreateMemory_validation_message_3:
            "Source and target languages for the language pair must be selected",
        component_CreateMemory_validation_message_4:
            "Translation memory created successfully",
        component_CreateTerm_dialog_title: "Create Termbase",
        component_CreateTerm_form_item_label_1: "Name",
        component_CreateTerm_form_item_placeholder_1: "Enter termbase name",
        component_CreateTerm_form_item_label_2: "Language Pair",
        component_CreateTerm_form_item_placeholder_2: "Source",
        component_CreateTerm_form_item_placeholder_3: "Target",
        component_CreateTerm_form_item_label_3: "Team Owner",
        component_CreateTerm_form_item_placeholder_4: "Select Team",
        component_CreateTerm_form_item_label_4: "Upload Terms",
        component_CreateTerm_form_item_message_1:
            "Support {type}, up to {size}M. Download template: ",
        component_CreateTerm_dialog_btn_label_1: "Cancel",
        component_CreateTerm_dialog_btn_label_2: "Save",
        component_CreateTerm_downloadTemplate_message: "Downloading...",
        component_CreateTerm_validation_message_1:
            "Failed to get download address",
        component_CreateTerm_validation_message_2: "Termbase name is required",
        component_CreateTerm_validation_message_3:
            "Source and target languages for the language pair must be selected",
        component_CreateTerm_validation_message_4:
            "Termbase created successfully",
    },
    tools: {
        tools_page_methods_initList_list_1_name: "AI Polish",
        tools_page_methods_initList_list_1_desc:
            "Generative AI-based, your on-the-go native language touch-up expert",
        tools_page_methods_initList_list_2_name: "AI Translation Rating",
        tools_page_methods_initList_list_2_desc:
            "AI evaluation on MT, thus recommending the most suitable engine",
        tools_page_methods_initList_list_3_name:
            "Machine Translation Detection",
        tools_page_methods_initList_list_3_desc:
            "Intelligently recognizing machine translation, effectively identifying translation quality problems",
        tools_page_methods_initList_list_4_name: "Alignment",
        tools_page_methods_initList_list_4_desc:
            "Industry-leading alignment algorithm, drag-and-drop alignment experience, AI makes corpus alignment simpler",
        tools_page_methods_initList_list_5_name: "AI Video Translation",
        tools_page_methods_initList_list_5_desc:
            "Within one click, translating and dubbing both are settled",
        tools_page_methods_initList_list_5_free: "Free trial on",
        tools_page_methods_initList_list_6_name: "QA Check",
        tools_page_methods_initList_list_6_desc:
            "More than a rules-based QA, a smarter check based on semantic understanding",
        tools_page_methods_initList_list_7_name: "Terminology Extraction",
        tools_page_methods_initList_list_7_desc:
            "Intelligently extracting terms from bulk files and swiftly editing to create your termbases",
        tools_page_methods_goTo_message_1:
            "Please upgrade to the corresponding version to use.",
        tools_alignIndex_page_btn_1: "Alignment",
        tools_alignIndex_page_btn_2: "Refresh",
        tools_alignIndex_page_btn_3: "Alignment",
        tools_alignIndex_page_input_placeholder_1: "Enter Name",
        tools_alignIndex_page_select_placeholder_1: "Sort by",
        tools_alignIndex_page_select_option_1: "Sort by time",
        tools_alignIndex_page_tips_1: "There are no tasks ~",
        tools_alignIndex_page_tips_2:
            "Industry-leading alignment algorithm with a brand-new drag-and-drop alignment experience",
        tools_alignIndex_page_dialog_1_title_1: "Alignment",
        tools_alignIndex_page_dialog_1_title_2: "Confirm",
        tools_alignIndex_page_dialog_1_tips_1:
            "Supports {type} format, with a maximum file size of {size} MB",
        tools_alignIndex_page_dialog_1_tips_2: "Upload",
        tools_alignIndex_page_dialog_1_tips_3: "Source",
        tools_alignIndex_page_dialog_1_tips_4: "Document",
        tools_alignIndex_page_dialog_1_tips_5: "Upload Translation",
        tools_alignIndex_page_dialog_1_tips_6: "Lang Direction",
        tools_alignIndex_page_dialog_1_tips_7: "Click to Switch",
        tools_alignIndex_page_dialog_1_tips_8: "Target Text",
        tools_alignIndex_page_dialog_1_btn_1: "Cancel",
        tools_alignIndex_page_dialog_1_btn_2: "Next",
        tools_alignIndex_page_dialog_1_btn_3: "Back",
        tools_alignIndex_page_dialog_1_btn_4: "Start alignment",
        tools_alignIndex_page_data_alertInfo_message:
            "Are you sure you want to delete this task?",
        tools_alignIndex_page_data_alertInfo_buttonName: "Confirm Deletion",
        tools_alignIndex_page_data_languageDict_zh_name: "Chinese",
        tools_alignIndex_page_data_languageDict_zh_shortName: "Zh",
        tools_alignIndex_page_data_languageDict_en_name: "English",
        tools_alignIndex_page_data_languageDict_en_shortName: "En",
        tools_alignIndex_page_data_languageDict_ru_name: "Russian",
        tools_alignIndex_page_data_languageDict_ru_shortName: "ru",
        tools_alignIndex_page_data_languageDict_fr_name: "French",
        tools_alignIndex_page_data_languageDict_fr_shortName: "fr",
        tools_alignIndex_page_data_languageDict_de_name: "German",
        tools_alignIndex_page_data_languageDict_de_shortName: "de",
        tools_alignIndex_page_data_languageDict_es_name: "Spanish",
        tools_alignIndex_page_data_languageDict_es_shortName: "es",
        tools_alignIndex_page_data_languageDict_pt_name: "Portuguese",
        tools_alignIndex_page_data_languageDict_pt_shortName: "pt",
        tools_alignIndex_page_data_languageDict_ar_name: "Arabic",
        tools_alignIndex_page_data_languageDict_ar_shortName: "ar",
        tools_alignIndex_page_data_languageDict_ja_name: "Japanese",
        tools_alignIndex_page_data_languageDict_ja_shortName: "ja",
        tools_alignIndex_page_data_languageDict_ko_name: "Korean",
        tools_alignIndex_page_data_languageDict_ko_shortName: "Ko",
        tools_alignIndex_page_data_languageDict_th_name: "Thai",
        tools_alignIndex_page_data_languageDict_th_shortName: "th",
        tools_alignIndex_page_data_languageDict_vi_name: "Thai",
        tools_alignIndex_page_data_languageDict_vi_shortName: "th",
        tools_alignIndex_page_data_languageDict_ms_name: "Malay",
        tools_alignIndex_page_data_languageDict_ms_shortName: "ms",
        tools_alignIndex_page_data_languageDict_id_name: "Indonesian",
        tools_alignIndex_page_data_languageDict_id_shortName: "id",
        tools_alignIndex_page_data_languageDict_it_name: "Italian",
        tools_alignIndex_page_data_languageDict_it_shortName: "it",
        tools_alignIndex_page_data_languageDict_da_name: "Danish",
        tools_alignIndex_page_data_languageDict_da_shortName: "Denmark",
        tools_alignIndex_page_data_languageDict_nl_name: "Dutch",
        tools_alignIndex_page_data_languageDict_nl_shortName: "nl",
        tools_alignIndex_page_data_languageDict_no_name: "Norwegian",
        tools_alignIndex_page_data_languageDict_no_shortName: "Norwegian",
        tools_alignIndex_page_data_languageDict_sv_name: "Swedish",
        tools_alignIndex_page_data_languageDict_sv_shortName: "sv",
        tools_alignIndex_page_data_typeRadioOptions_name_1:
            "Bilingual Alignment",
        tools_alignIndex_page_data_typeRadioOptions_name_2:
            "Monolingual Alignment",
        tools_alignIndex_page_method_comfirmTaskEvent_message_1:
            "Upload Source File",
        tools_alignIndex_page_method_comfirmTaskEvent_message_2:
            "Upload Target File",
        tools_alignIndex_page_method_startTaskEvent_message_1:
            "Upload Source File",
        tools_alignIndex_page_method_startTaskEvent_message_2:
            "Upload Target File",
        tools_alignIndex_page_method_startTaskEvent_message_3:
            "Task has started",
        tools_alignIndex_page_method_executeAction_message_1: "No permission",
        tools_alignIndex_page_method_deleteTask_message_1: "Task deleted",
        tools_alignDetail_page_form_item_label_1: "Lang Direction",
        tools_alignDetail_page_form_item_label_2: "Created: ",
        tools_alignDetail_page_tips_1: "AI Alignment",
        tools_alignDetail_page_tips_2: "Rule-based Alignment",
        tools_alignDetail_page_tips_3:
            "AI Alignment: Suitable for complex or irregularly matched documents. AI handles alignment, with manual adjustments that do not shift the entire content up/down",
        tools_alignDetail_page_tips_4:
            "Rule-based Alignment: Suitable for well-structured documents. Aligns based on segmentation rules, allowing manual adjustments to shift entire segments up/down",
        tools_alignDetail_page_tips_5: "Download",
        tools_alignDetail_page_tips_6: "Download Word",
        tools_alignDetail_page_tips_7: "Download Excel",
        tools_alignDetail_page_tips_8: "Download TMX",
        tools_alignDetail_page_tips_9: "Ctrl/⌘ + Z",
        tools_alignDetail_page_tips_10: "Ctrl/⌘ + Y",
        tools_alignDetail_page_tips_11: "Ctrl/⌘ + I",
        tools_alignDetail_page_tips_12: "Ctrl/⌘ + E",
        tools_alignDetail_page_tips_13:
            "Double-click to enter edit mode, then split Ctrl/⌘ + Enter",
        tools_alignDetail_page_tips_14: "Ctrl/⌘ + M",
        tools_alignDetail_page_tips_15: "Ctrl/⌘ + Delete",
        tools_alignDetail_page_tips_16: "Ctrl/⌘ + F",
        tools_alignDetail_page_tips_17: "Click",
        tools_alignDetail_page_tips_18:
            "Drag to adjust segment position; press <kbd>Ctrl</kbd> / <kbd>⌘</kbd> + click to select multiple segments",
        tools_alignDetail_page_tips_19: "No.",
        tools_alignDetail_page_tips_20: "Mark",
        tools_alignDetail_page_tips_21: "Source Text ({lang})",
        tools_alignDetail_page_tips_21: "Target Text ({lang})",
        tools_alignDetail_page_tips_22: "Unmark",
        tools_alignDetail_page_tips_23: "Mark as Pending",
        tools_alignDetail_page_tips_24: "Double click to edit",
        tools_alignDetail_page_tips_25: "No results in list",
        tools_alignDetail_page_btn_1: "Save to memory",
        tools_alignDetail_page_btn_2: "Undo",
        tools_alignDetail_page_btn_3: "Restore",
        tools_alignDetail_page_btn_4: "Insert",
        tools_alignDetail_page_btn_5: "Edit",
        tools_alignDetail_page_btn_6: "Split",
        tools_alignDetail_page_btn_7: "Merge",
        tools_alignDetail_page_btn_8: "Delete",
        tools_alignDetail_page_btn_9: "Shortcut Keys",
        tools_alignDetail_page_btn_10: "Find/Replace",
        tools_alignDetail_page_btn_11: "Clean",
        tools_alignDetail_page_select_placeholder_1:
            "Corpus Filtering and Cleaning",
        tools_alignDetail_page_input_placeholder_1: "Enter Source Text",
        tools_alignDetail_page_input_placeholder_2: "Enter Target Text",
        tools_alignDetail_page_hotkeyTable_columns_1: "Function",
        tools_alignDetail_page_hotkeyTable_columns_2: "Shortcut Keys",
        tools_alignDetail_page_dialog_1_title: "Save to memory",
        tools_alignDetail_page_dialog_1_tips_1:
            "Alignment results can only be saved once. Please ensure all alignments are complete before saving",
        tools_alignDetail_page_dialog_1_form_item_1: "Translation Memory Name",
        tools_alignDetail_page_dialog_1_form_item_2: "Select Team",
        tools_alignDetail_page_dialog_1_input_placeholder_1:
            "Enter a new translation memory name or select an existing one",
        tools_alignDetail_page_dialog_1_select_placeholder_1: "Select Team",
        tools_alignDetail_page_dialog_1_btn_1: "Cancel",
        tools_alignDetail_page_dialog_1_btn_2: "Save",
        tools_alignDetail_page_dialog_2_title: "Insert",
        tools_alignDetail_page_dialog_2_form_item_1: "Source Text ({lang})",
        tools_alignDetail_page_dialog_2_input_placeholder_1:
            "Enter Source Text",
        tools_alignDetail_page_dialog_2_form_item_2: "Target Text ({lang})",
        tools_alignDetail_page_dialog_2_input_placeholder_2:
            "Enter Target Text",
        tools_alignDetail_page_dialog_2_btn_1: "Cancel",
        tools_alignDetail_page_dialog_2_btn_2: "Insert",
        tools_alignDetail_page_dialog_3_title: "Find/Replace",
        tools_alignDetail_page_dialog_3_tips_1: "Find",
        tools_alignDetail_page_dialog_3_tips_2: "Replace with",
        tools_alignDetail_page_dialog_3_tips_3:
            "Page {number}/{count}, {size} items in total",
        tools_alignDetail_page_dialog_3_input_placeholder_1:
            "Enter search text",
        tools_alignDetail_page_dialog_3_input_placeholder_2:
            "Enter replacement text",
        tools_alignDetail_page_dialog_3_checkbox_label_1: "Case sensitive",
        tools_alignDetail_page_dialog_3_btn_1: "Prev",
        tools_alignDetail_page_dialog_3_btn_2: "Next",
        tools_alignDetail_page_dialog_3_btn_3: "Replace",
        tools_alignDetail_page_dialog_3_btn_4: "Replace All",
        tools_alignDetail_page_data_hotkeyList_name_1: "Undo",
        tools_alignDetail_page_data_hotkeyList_name_2: "Restore",
        tools_alignDetail_page_data_hotkeyList_name_3: "Edit",
        tools_alignDetail_page_data_hotkeyList_name_4: "Insert",
        tools_alignDetail_page_data_hotkeyList_name_5: "Split",
        tools_alignDetail_page_data_hotkeyList_name_6: "Merge",
        tools_alignDetail_page_data_hotkeyList_name_7: "Delete",
        tools_alignDetail_page_data_hotkeyList_name_8: "Find/Replace",
        tools_alignDetail_page_data_hotkeyList_name_9: "Cross-row selected",
        tools_alignDetail_page_data_hotkeyList_name_10: "Bulk selected",
        tools_alignDetail_page_data_hotkeyList_key_tips_1: "Click to select",
        tools_alignDetail_page_data_alertInfo_message:
            "Are you sure to delete the corpus?",
        tools_alignDetail_page_data_alertInfo_buttonName: "Confirm Deletion",
        tools_alignDetail_page_data_cleanUnAlignDialog_buttonName: "Confirm",
        tools_alignDetail_page_data_submitAllDialog_message:
            "Confirm all segments as aligned in one click? Segments missing source or target text will be excluded",
        tools_alignDetail_page_data_submitAllDialog_buttonName: "Confirmation",
        tools_alignDetail_page_data_sortOptions_value_1:
            "Warning color (unaligned)",
        tools_alignDetail_page_data_sortOptions_value_2:
            "Missing source or target text",
        tools_alignDetail_page_data_sortOptions_value_3:
            "Repeated source and target text",
        tools_alignDetail_page_data_sortOptions_value_4: "Same ST and TT",
        tools_alignDetail_page_method_initPage_message_1:
            "No matching records found",
        tools_alignDetail_page_method_saveEditEvent_message_1:
            "Saved successfully",
        tools_alignDetail_page_method_saveAddEvent_message_1:
            "Original text cannot be empty",
        tools_alignDetail_page_method_saveAddEvent_message_2:
            "Translated text cannot be empty",
        tools_alignDetail_page_method_saveAddEvent_message_3:
            "Saved successfully",
        tools_alignDetail_page_method_deleteUnAlignBtnEvent_message_1:
            "Unaligned data has been deleted",
        tools_alignDetail_page_method_repealBtnEvent_message_1: "Revoked",
        tools_alignDetail_page_method_recoverBtnEvent_message_1: "Recovered",
        tools_alignDetail_page_method_splitColEvent_message_1:
            "Source/target text must be in edit mode to split. Double-click the cell to edit.",
        tools_alignDetail_page_method_splitColEvent_message_2:
            "Splitting is not supported at the beginning or end of a sentence",
        tools_alignDetail_page_method_splitColEvent_message_3:
            "Split completed",
        tools_alignDetail_page_method_mergeColEvent_message_1:
            "Cannot merge source text and translation",
        tools_alignDetail_page_method_mergeColEvent_message_2: "Merged",
        tools_alignDetail_page_method_exchangeColEvent_message_1:
            "Switched successfully",
        tools_alignDetail_page_method_aligningColEvent_message_1:
            "Source text and translation cannot be empty",
        tools_alignDetail_page_method_aligningColEvent_message_2: "Aligned",
        tools_alignDetail_page_method_submitRowAlignBtnEvent_message_1:
            "Source text and translation cannot be empty",
        tools_alignDetail_page_method_submitRowAlignBtnEvent_message_2:
            "Alignment confirmed",
        tools_alignDetail_page_method_deleteBtnEvent_message_1:
            "Please select a segment",
        tools_alignDetail_page_method_deleteConfirmEvent_message_1:
            "Please select a segment",
        tools_alignDetail_page_method_deleteConfirmEvent_message_2: "Deleted",
        tools_alignDetail_page_method_saveToMemEvent_message_1:
            "Please enter or select a memory name",
        tools_alignDetail_page_method_saveToMemEvent_message_2:
            "Saved to memory",
        tools_alignDetail_page_method_submitAllBtnEvent_message_1:
            "Alignment confirmed",
        tools_alignDetail_page_method_onContextmenu_item_label_1:
            "Insert (Ctrl/⌘ + I)",
        tools_alignDetail_page_method_onContextmenu_item_label_2:
            "Edit (Ctrl/⌘ + E)",
        tools_alignDetail_page_method_onContextmenu_item_label_3:
            "Merge (Ctrl/⌘ + M)",
        tools_alignDetail_page_method_onContextmenu_item_label_4:
            "Delete (Ctrl/⌘ + Delete)",
        tools_alignDetail_page_method_clearFilterAlignResultBtnEvent_message_1:
            "Confirm cleaning of {name}'s corpus",
        tools_alignDetail_page_method_clearFilterAlignResultBtnEvent_message_2:
            "Keep only the first entry",
        tools_alignDetail_page_method_clearFilterAlignResultBtnEvent_message_3:
            "?",
        tools_alignDetail_page_method_submitClearFilterAlignResult_message_1:
            "Data has been cleared",
        tools_alignDetail_page_method_prevBtnEvent_message_1:
            "No corresponding records found",
        tools_alignDetail_page_method_prevBtnEvent_message_2:
            "This is already the first entry",
        tools_alignDetail_page_method_nextBtnEvent_message_1:
            "No corresponding records found",
        tools_alignDetail_page_method_nextBtnEvent_message_2:
            "This is already the last entry",
        tools_alignDetail_page_method_replaceBtnEvent_message_1:
            "This has been replaced with the last one",
        tools_alignDetail_page_method_replaceAllBtnEvent_message_1:
            "Successfully replaced {count1} rows of records, {count2} text occurrences",
        tools_alignDetail_page_method_saveEditTitleEvent_message_1:
            "Rename successfully",
        tools_alignTiled_page_form_item_label_1: "Lang Direction",
        tools_alignTiled_page_form_item_label_2: "Created: ",
        tools_alignTiled_page_tips_1: "AI Alignment",
        tools_alignTiled_page_tips_2: "Rule-based Alignment",
        tools_alignTiled_page_tips_3:
            "AI Alignment: For complex or poorly formatted documents, aligned by AI with manual adjustments that don’t move the entire text",
        tools_alignTiled_page_tips_4:
            "Rule-based Alignment: For well-structured documents, aligned by sentence rules, with manual adjustments moving the entire text",
        tools_alignTiled_page_tips_5: "Download Word",
        tools_alignTiled_page_tips_6: "Download Excel",
        tools_alignTiled_page_tips_7: "Download TMX",
        tools_alignTiled_page_tips_8: "Ctrl/⌘ + Z",
        tools_alignTiled_page_tips_9: "Ctrl/⌘ + Y",
        tools_alignTiled_page_tips_10: "Ctrl/⌘ + I",
        tools_alignTiled_page_tips_11: "Ctrl/⌘ + E",
        tools_alignTiled_page_tips_12:
            "Double-click to enter edit mode, then split Ctrl/⌘ + Enter",
        tools_alignTiled_page_tips_13: "Ctrl/⌘ + M",
        tools_alignTiled_page_tips_14: "Ctrl/⌘ + Delete",
        tools_alignTiled_page_tips_15: "Ctrl/⌘ + F",
        tools_alignTiled_page_tips_16: "Click",
        tools_alignTiled_page_tips_17:
            "Drag to adjust segment position; press <kbd>Ctrl</kbd> / <kbd>⌘</kbd> + click to select multiple segments",
        tools_alignTiled_page_tips_18: "No.",
        tools_alignTiled_page_tips_19: "Source Text ({lang})",
        tools_alignTiled_page_tips_20: "Target Text ({lang})",
        tools_alignTiled_page_tips_21: "Unmark",
        tools_alignTiled_page_tips_22: "Mark as Pending",
        tools_alignTiled_page_tips_23: "Double click to edit",
        tools_alignTiled_page_tips_24: "No results in list",
        tools_alignTiled_page_btn_1: "Saved to memory",
        tools_alignTiled_page_btn_2: "Download",
        tools_alignTiled_page_btn_3: "Undo",
        tools_alignTiled_page_btn_4: "Restore",
        tools_alignTiled_page_btn_5: "Insert",
        tools_alignTiled_page_btn_6: "Edit",
        tools_alignTiled_page_btn_7: "Split",
        tools_alignTiled_page_btn_8: "Merge",
        tools_alignTiled_page_btn_9: "Delete",
        tools_alignTiled_page_btn_10: "Shortcut Key",
        tools_alignTiled_page_btn_11: "Find/Replace",
        tools_alignTiled_page_btn_12: "Clean",
        tools_alignTiled_page_hotkeyListTable_item_label_1: "Function",
        tools_alignTiled_page_hotkeyListTable_item_label_2: "Shortcut Key",
        tools_alignTiled_page_select_placeholder_1:
            "Corpus Filtering and Cleaning",
        tools_alignTiled_page_input_placeholder_1: "Enter Source Text",
        tools_alignTiled_page_input_placeholder_2: "Enter Target Text",
        tools_alignTiled_page_dialog_1_title: "Saved to memory",
        tools_alignTiled_page_dialog_1_tips_1:
            "Alignment results can only be saved once. Please ensure all alignments are complete before saving",
        tools_alignTiled_page_dialog_1_form_item_label_1:
            "Translation Memory Name",
        tools_alignTiled_page_dialog_1_form_item_placeholder_1:
            "Enter a new translation memory name or select an existing one",
        tools_alignTiled_page_dialog_1_form_item_label_2: "Select Team",
        tools_alignTiled_page_dialog_1_form_item_placeholder_2: "Select Team",
        tools_alignTiled_page_dialog_1_btn_1: "Cancel",
        tools_alignTiled_page_dialog_1_btn_2: "Save",
        tools_alignTiled_page_dialog_2_title: "Insert",
        tools_alignTiled_page_dialog_2_form_item_label_1:
            "Source Text ({lang})",
        tools_alignTiled_page_dialog_2_form_item_placeholder_1:
            "Enter Source Text",
        tools_alignTiled_page_dialog_2_form_item_label_2:
            "Target Text ({lang})",
        tools_alignTiled_page_dialog_2_form_item_placeholder_2:
            "Enter Target Text",
        tools_alignTiled_page_dialog_2_btn_1: "Cancel",
        tools_alignTiled_page_dialog_2_btn_2: "Insert",
        tools_alignTiled_page_dialog_3_title: "Find/Replace",
        tools_alignTiled_page_dialog_3_tips_1: "Find",
        tools_alignTiled_page_dialog_3_tips_2: "Replace with",
        tools_alignTiled_page_dialog_3_tips_3:
            "Page {number}/{size1}, {size2} items in total",
        tools_alignTiled_page_dialog_3_input_placeholder_1: "Enter search text",
        tools_alignTiled_page_dialog_3_input_placeholder_2:
            "Enter replacement text",
        tools_alignTiled_page_dialog_3_checkbox_1: "Case sensitive",
        tools_alignTiled_page_dialog_3_btn_1: "Prev",
        tools_alignTiled_page_dialog_3_btn_2: "Next",
        tools_alignTiled_page_dialog_3_btn_3: "Replace",
        tools_alignTiled_page_dialog_3_btn_4: "Replace All",
        tools_alignTiled_page_data_hotkeyList_name_1: "Undo",
        tools_alignTiled_page_data_hotkeyList_name_2: "Restore",
        tools_alignTiled_page_data_hotkeyList_name_3: "Edit",
        tools_alignTiled_page_data_hotkeyList_name_4: "Insert",
        tools_alignTiled_page_data_hotkeyList_name_5: "Split",
        tools_alignTiled_page_data_hotkeyList_name_6: "Merge",
        tools_alignTiled_page_data_hotkeyList_name_7: "Delete",
        tools_alignTiled_page_data_hotkeyList_name_8: "Find/Replace",
        tools_alignTiled_page_data_hotkeyList_name_9: "Cross-row selected",
        tools_alignTiled_page_data_hotkeyList_name_10: "Bulk selected",
        tools_alignTiled_page_data_hotkeyList_key_tips_1: "Click to select",
        tools_alignTiled_page_data_alertInfo_message:
            "Are you sure to delete the corpus?",
        tools_alignTiled_page_data_alertInfo_buttonName: "Confirm Deletion",
        tools_alignTiled_page_data_cleanUnAlignDialog_buttonName: "Confirm",
        tools_alignTiled_page_data_submitAllDialog_message:
            "Confirm all segments as aligned in one click? Segments missing source or target text will be excluded",
        tools_alignTiled_page_data_submitAllDialog_buttonName: "Confirm",
        tools_alignTiled_page_data_sortOptions_value_1:
            "Missing source or target text",
        tools_alignTiled_page_data_sortOptions_value_2:
            "Repeated source and target text",
        tools_alignTiled_page_data_sortOptions_value_3: "Same ST and TT",
        tools_alignTiled_page_method_saveEditEvent_message_1:
            "Saved successfully",
        tools_alignTiled_page_method_saveAddEvent_message_1:
            "Original text cannot be empty",
        tools_alignTiled_page_method_saveAddEvent_message_2:
            "Translated text cannot be empty",
        tools_alignTiled_page_method_saveAddEvent_message_3:
            "Saved successfully",
        tools_alignTiled_page_method_deleteUnAlignBtnEvent_message_1:
            "Unaligned data has been deleted",
        tools_alignTiled_page_method_repealBtnEvent_message_1: "Revoked",
        tools_alignTiled_page_method_recoverBtnEvent_message_1: "Recovered",
        tools_alignTiled_page_method_splitColEvent_message_1:
            "Source/target text must be in edit mode to split. Double-click the cell to edit.",
        tools_alignTiled_page_method_splitColEvent_message_2:
            "Splitting is not supported at the beginning or end of a sentence",
        tools_alignTiled_page_method_splitColEvent_message_3: "Split completed",
        tools_alignTiled_page_method_mergeColEvent_message_1:
            "Cannot merge source text and translation",
        tools_alignTiled_page_method_mergeColEvent_message_2: "Merged",
        tools_alignTiled_page_method_exchangeColEvent_message_1:
            "Switched successfully",
        tools_alignTiled_page_method_aligningColEvent_message_1:
            "Source text and translation cannot be empty",
        tools_alignTiled_page_method_aligningColEvent_message_2: "Aligned",
        tools_alignTiled_page_method_submitRowAlignBtnEvent_message_1:
            "Source text and translation cannot be empty",
        tools_alignTiled_page_method_submitRowAlignBtnEvent_message_2:
            "Alignment confirmed",
        tools_alignTiled_page_method_deleteBtnEvent_message_1:
            "Please select a segment",
        tools_alignTiled_page_method_deleteConfirmEvent_message_1:
            "Please select a segment",
        tools_alignTiled_page_method_deleteConfirmEvent_message_2: "Deleted",
        tools_alignTiled_page_method_saveToMemEvent_message_1:
            "Please enter or select a memory name",
        tools_alignTiled_page_method_saveToMemEvent_message_2:
            "Saved to memory",
        tools_alignTiled_page_method_submitAllBtnEvent_message_1:
            "Alignment confirmed",
        tools_alignTiled_page_method_onContextmenu_item_label_1:
            "Insert (Ctrl/⌘ + I)",
        tools_alignTiled_page_method_onContextmenu_item_label_2:
            "Edit (Ctrl/⌘ + E)",
        tools_alignTiled_page_method_onContextmenu_item_label_3:
            "Merge (Ctrl/⌘ + M)",
        tools_alignTiled_page_method_onContextmenu_item_label_4:
            "Delete (Ctrl/⌘ + Delete)",
        tools_alignTiled_page_method_clearFilterAlignResultBtnEvent_message_1:
            "Confirm cleaning of {name}'s corpus",
        tools_alignTiled_page_method_clearFilterAlignResultBtnEvent_message_2:
            "Keep only the first entry",
        tools_alignTiled_page_method_clearFilterAlignResultBtnEvent_message_3:
            "?",
        tools_alignTiled_page_method_submitClearFilterAlignResult_message_1:
            "Data has been cleared",
        tools_alignTiled_page_method_initFindReplaceData_message_1:
            "No corresponding records found",
        tools_alignTiled_page_method_prevBtnEvent_message_1:
            "No corresponding records found",
        tools_alignTiled_page_method_prevBtnEvent_message_2:
            "This is already the first entry",
        tools_alignTiled_page_method_nextBtnEvent_message_1:
            "No corresponding records found",
        tools_alignTiled_page_method_nextBtnEvent_message_2:
            "This is already the last entry",
        tools_alignTiled_page_method_replaceBtnEvent_message_1:
            "This has been replaced with the last one",
        tools_alignTiled_page_method_replaceAllBtnEvent_message_1:
            "Successfully replaced {count1} lines of source text, {count2} lines of translation, and {count3} text occurrences",
        tools_alignTiled_page_method_saveEditTitleEvent_message_1:
            "Rename successfully",
        tools_detectorIndex_page_btn_1: "Dual Document",
        tools_detectorIndex_page_btn_2: "Single Document",
        tools_detectorIndex_page_btn_3: "Refresh",
        tools_detectorIndex_page_input_placeholder_1: "Enter a name",
        tools_detectorIndex_page_select_placeholder_1: "Sort by",
        tools_detectorIndex_page_select_option_label_1: "Sort by time",
        tools_detectorIndex_page_tips_1: "There are no tasks ~",
        tools_detectorIndex_page_tips_2:
            "AI-powered machine translation detection for quick identification of quality risks in translations.",
        tools_detectorIndex_page_tips_3:
            "Supports pre-aligned documents, {type}, and external review formats (docx/doc)",
        tools_detectorIndex_page_tips_4: "View sample format",
        tools_detectorIndex_page_tips_5: ", not exceeding {size}MB",
        tools_detectorIndex_page_tips_6:
            "The data usage is based on the source text characters. For example, when uploading dual documents, the character count is based on the source text; for aligned segment-based documents, the character count is based on the source document. Total characters = Source text characters × Sampling rate (0.1–1) × Number of models",
        tools_detectorIndex_page_tips_7: "Traffic Charge Rules",
        tools_detectorIndex_page_tips_8:
            "Supports unaligned documents, {type} format, not exceeding {size}MB",
        tools_detectorIndex_page_tips_9:
            "The data usage is based on the source text characters. For example, when uploading dual documents, the character count is based on the source text; for aligned segment-based documents, the character count is based on the source document. Total characters = Source text characters × Sampling rate (0.1–1) × Number of models",
        tools_detectorIndex_page_tips_10: "Upload File",
        tools_detectorIndex_page_tips_11: "Upload Source File",
        tools_detectorIndex_page_tips_12: "Upload Translation",
        tools_detectorIndex_page_tips_13: "Click to Switch",
        tools_detectorIndex_page_tips_14: "Detection Settings",
        tools_detectorIndex_page_dialog_1_title:
            "Machine Translation Detection",
        tools_detectorIndex_page_dialog_1_form_item_label_1: "Sample Size",
        tools_detectorIndex_page_dialog_1_select_placeholder_1:
            "Select Sample Size",
        tools_detectorIndex_page_dialog_1_form_item_label_2:
            "Filter Short Phrases",
        tools_detectorIndex_page_dialog_1_select_placeholder_2:
            "Select Filter Options",
        tools_detectorIndex_page_dialog_1_option_label_1:
            "Up to {size} characters",
        tools_detectorIndex_page_dialog_1_tips_1:
            "Number of randomly selected segments",
        tools_detectorIndex_page_dialog_1_tips_2:
            "Filter out segments with overly short source text",
        tools_detectorIndex_page_dialog_1_btn_1: "Cancel",
        tools_detectorIndex_page_dialog_1_btn_2: "detect",
        tools_detectorIndex_page_data_alertInfo_message:
            "Are you sure you want to delete this task?",
        tools_detectorIndex_page_data_alertInfo_buttonName: "Confirm Deletion",
        tools_detectorIndex_page_data_typeRadioOptions_name_1: "Aligned",
        tools_detectorIndex_page_data_typeRadioOptions_name_2: "Not Aligned",
        tools_detectorIndex_page_method_startTaskEvent_message_1:
            "Please upload file",
        tools_detectorIndex_page_method_startTaskEvent_message_2:
            "Upload Source File",
        tools_detectorIndex_page_method_startTaskEvent_message_3:
            "Upload Target File",
        tools_detectorIndex_page_method_startTaskEvent_message_4:
            "Please select a model",
        tools_detectorIndex_page_method_startTaskEvent_message_5:
            "Task has started",
        tools_detectorIndex_page_method_deleteTask_message_1: "Task deleted",
        tools_detectorDetail_page_tips_1: "Similarity",
        tools_detectorDetail_page_tips_2: "Retry",
        tools_detectorDetail_page_select_placeholder_1: "Please select",
        tools_detectorDetail_page_btn_1: "Download Report",
        tools_detectorDetail_page_table_column_label_1: "No.",
        tools_detectorDetail_page_table_column_label_2: "Source Text ({lang})",
        tools_detectorDetail_page_table_column_label_3: "Target Text ({lang})",
        tools_detectorDetail_page_table_column_label_4: "Similarity",
        tools_detectorDetail_page_table_column_label_5: "{name} translation",
        tools_detectorDetail_page_data_filterOptions_name_1: "Below 79%",
        tools_detectorDetail_page_data_filterOptions_name_2: "80%-89%",
        tools_detectorDetail_page_data_filterOptions_name_3: "90%-99%",
        tools_detectorDetail_page_data_filterOptions_name_4: "100%",
        tools_detectorDetail_page_method_engineItemClick_message_1:
            "Current Model Detection Failed",
        tools_detectorDetail_page_method_engineItemClick_message_2:
            "Current Model Detection in Progress, Please Wait",
        tools_detectorDetail_page_method_retryBtnClick_message_1: "Retried",
        tools_gptTranslate_page_tips_1: "Project History",
        tools_gptTranslate_page_tips_2:
            "AI localization collaboration process based on large model for non-translated elements handling/terminology unification/error checking",
        tools_gptTranslate_page_tips_3: "In total",
        tools_gptTranslate_page_tips_4: "files, ",
        tools_gptTranslate_page_tips_5: "WORD",
        tools_gptTranslate_page_tips_6: "Estimated to consume",
        tools_gptTranslate_page_tips_7: "token, click to begin translating",
        tools_gptTranslate_page_tips_8:
            "Token counting in progress, please wait",
        tools_gptTranslate_page_tips_9: "Drag or click to upload files",
        tools_gptTranslate_page_tips_10:
            "Please purchase Tokens before using the Agent",
        tools_gptTranslate_page_tips_11: "Purchase",
        tools_gptTranslate_page_tips_12: "Source",
        tools_gptTranslate_page_tips_13: "Target",
        tools_gptTranslate_page_tips_14: "Terminology",
        tools_gptTranslate_page_tips_15: "Clear Glossary",
        tools_gptTranslate_page_tips_16: "{size} file(s)",
        tools_gptTranslate_page_tips_17: "{size} word(s)",
        tools_gptTranslate_page_tips_18: "Progress",
        tools_gptTranslate_page_tips_19: "Download Target Text",
        tools_gptTranslate_page_tips_20: "Download Bilingual Text",
        tools_gptTranslate_page_tips_21: "Delete",
        tools_gptTranslate_page_tips_22: "Retry",
        tools_gptTranslate_page_tips_23: "Recharge",
        tools_gptTranslate_page_tips_24: "Current File: ",
        tools_gptTranslate_page_tips_25: "Enter keywords to search",
        tools_gptTranslate_page_tips_26: "Switch source and target languages",
        tools_gptTranslate_page_dialog_1_title: "Upload Terminology",
        tools_gptTranslate_page_dialog_1_tips_1:
            "Supports {type}, up to 10 files, with a maximum size of {size}M per file. Download template: ",
        tools_gptTranslate_page_dialog_1_btn_1: "Cancel",
        tools_gptTranslate_page_dialog_1_btn_2: "Confirm",
        tools_gptTranslate_page_dialog_2_title: "Upload Translation Memory",
        tools_gptTranslate_page_dialog_2_tips_1:
            "Supports {type}, up to 10 files, each up to {size}M. Download template: ",
        tools_gptTranslate_page_dialog_2_btn_1: "Cancel",
        tools_gptTranslate_page_dialog_2_btn_2: "Confirm",
        tools_gptTranslate_page_select_placeholder_1: "Select Language",
        tools_gptTranslate_page_btn_1: "Upload Terminology",
        tools_gptTranslate_page_btn_2: "Continue uploading file",
        tools_gptTranslate_page_btn_3: "Back",
        tools_gptTranslate_page_btn_4: "Next",
        tools_gptTranslate_page_btn_5: "Start translating",
        tools_gptTranslate_page_data_uploadFileMessage:
            "Support files in {type} formats",
        tools_gptTranslate_page_data_alertInfo_cancelButtonName: "Cancel",
        tools_gptTranslate_page_method_nextBtnEvent_message_1:
            "Please upload file",
        tools_gptTranslate_page_method_initTaskList_message_1:
            "Insufficient tokens. Please recharge and try again",
        tools_gptTranslate_page_method_createTask_message_1:
            "Please upload file",
        tools_gptTranslate_page_method_pollingTaskTokenInfo_message_1:
            "File parsing failed. Please re-upload",
        tools_gptTranslate_page_method_deleteTask_message_1:
            "Are you sure to delete this task?",
        tools_gptTranslate_page_method_deleteTaskEvent_message_1:
            "Deleted successfully",
        tools_gptTranslateHistory_page_tips_1: "Project History",
        tools_gptTranslateHistory_page_tips_2: "Download Target Text",
        tools_gptTranslateHistory_page_tips_3: "Download Bilingual Text",
        tools_gptTranslateHistory_page_tips_4: "Batch Delete",
        tools_gptTranslateHistory_page_tips_5: "Download Target Text",
        tools_gptTranslateHistory_page_tips_6: "Download Bilingual Text",
        tools_gptTranslateHistory_page_tips_7: "Retry",
        tools_gptTranslateHistory_page_tips_8: "Delete File",
        tools_gptTranslateHistory_page_btn_1: "Refresh",
        tools_gptTranslateHistory_page_btn_2: "Recharge",
        tools_gptTranslateHistory_page_input_placeholder_1: "Enter file name",
        tools_gptTranslateHistory_page_table_column_1: "File Name",
        tools_gptTranslateHistory_page_table_column_2: "File Count",
        tools_gptTranslateHistory_page_table_column_3: "Lang Direction",
        tools_gptTranslateHistory_page_table_column_4: "Token Count",
        tools_gptTranslateHistory_page_table_column_5: "Status",
        tools_gptTranslateHistory_page_table_column_6: "Progress",
        tools_gptTranslateHistory_page_table_column_7: "Uploaded time",
        tools_gptTranslateHistory_page_table_column_8: "Action",
        tools_gptTranslateHistory_page_data_alertInfo_message:
            "Are you sure to delete items?",
        tools_gptTranslateHistory_page_data_alertInfo_cancelButtonName:
            "Confirm Deletion",
        tools_gptTranslateHistory_page_method_handleFileReset_message_1:
            "Insufficient tokens. Please recharge and try again",
        tools_gptTranslateHistory_page_method_batchDownloadBtnEvent_message_1:
            "Please select projects to download first",
        tools_gptTranslateHistory_page_method_batchDownloadBtnEvent_message_2:
            "Exporting {size} projects.",
        tools_gptTranslateHistory_page_method_batchDeleteBtnEvent_message_1:
            "Please select projects to delete first.",
        tools_gptTranslateHistory_page_method_deleteProject_message_1:
            "Deleted successfully",
        tools_polishIndex_page_tips_1: "Text",
        tools_polishIndex_page_tips_2: "Document",
        tools_polishIndex_page_tips_3: "Paste Text",
        tools_polishIndex_page_tips_4: "{size1}/{size2} characters",
        tools_polishIndex_page_tips_5: "Polish Monolingual Document",
        tools_polishIndex_page_tips_5_1:
            "You can upload doc/docx/ppt/pptx files within 20M",
        tools_polishIndex_page_tips_6: "Upload File",
        tools_polishIndex_page_tips_7: "Insufficient traffic",
        tools_polishIndex_page_tips_8: "Terminated",
        tools_polishIndex_page_tips_9: "Polishing Failed",
        tools_polishIndex_page_tips_10: "Polishing Completed",
        tools_polishIndex_page_tips_11: "Task Terminated, No Traffic Deducted",
        tools_polishIndex_page_tips_12:
            "Traffic Deducted, Please Wait and Do Not Refresh the Page",
        tools_polishIndex_page_tips_13:
            "The file will be downloaded automatically after polishing. If not, please",
        tools_polishIndex_page_tips_14: "download manually",
        tools_polishIndex_page_tips_15: "Polishing Language",
        tools_polishIndex_page_tips_16: "Detected {name}",
        tools_polishIndex_page_tips_17: "Auto Detect",
        tools_polishIndex_page_tips_18: "Polishing Model",
        tools_polishIndex_page_tips_19: "Text Length",
        tools_polishIndex_page_tips_20: "Polishing Style",
        tools_polishIndex_page_tips_21: "Custom Requirements",
        tools_polishIndex_page_tips_22: "AI Polish",
        tools_polishIndex_page_tips_23: "Collapse List",
        tools_polishIndex_page_tips_24: "Expand List",
        tools_polishIndex_page_tips_25: "Polishing Successful",
        tools_polishIndex_page_tips_26: "Polishing Failed",
        tools_polishIndex_page_tips_27: "Purchase",
        tools_polishIndex_page_tips_28: "Insufficient Traffic",
        tools_polishIndex_page_tips_29: "Download",
        tools_polishIndex_page_tips_30: "Delete",
        tools_polishIndex_page_btn_1: "Start Polishing",
        tools_polishIndex_page_btn_2: "Purchase Character Pack",
        tools_polishIndex_page_btn_3: "Retry",
        tools_polishIndex_page_btn_4: "Terminate",
        tools_polishIndex_page_btn_5: "Re-polish",
        tools_polishIndex_page_btn_6: "Copy",
        tools_polishIndex_page_input_placeholder_1:
            "Paste the Text to Be Polished",
        tools_polishIndex_page_select_placeholder_2:
            "Select Polishing Language",
        tools_polishIndex_page_select_placeholder_3: "Select Model",
        tools_polishIndex_page_select_placeholder_4: "Select Text Length",
        tools_polishIndex_page_select_placeholder_5: "Select Polishing Style",
        tools_polishIndex_page_input_placeholder_1:
            "+Add Custom, Press Enter to Confirm",
        tools_polishIndex_page_data_form_customStyle_1: "Native expression",
        tools_polishIndex_page_data_systemStyleOptions_1: "Native expression",
        tools_polishIndex_page_data_systemStyleOptions_2: "Gaming Industry",
        tools_polishIndex_page_data_systemStyleOptions_3: "Academic Papers",
        tools_polishIndex_page_data_systemStyleOptions_4: "Formal Emails",
        tools_polishIndex_page_data_systemStyleOptions_5: "Political PR",
        tools_polishIndex_page_data_systemStyleOptions_6:
            "Legal Documents (Contracts)",
        tools_polishIndex_page_data_btnName: "Polish It",
        tools_polishIndex_page_data_alertInfo_cancelButtonName:
            "Please Wait a Moment",
        tools_polishIndex_page_created_languageList_name_1: "English",
        tools_polishIndex_page_created_languageList_shortName_1: "En",
        tools_polishIndex_page_created_languageList_name_2:
            "Chinese (Simplified)",
        tools_polishIndex_page_created_languageList_shortName_2: "Zh",
        tools_polishIndex_page_created_languageList_name_3: "Russian",
        tools_polishIndex_page_created_languageList_shortName_3: "ru",
        tools_polishIndex_page_created_languageList_name_4: "French",
        tools_polishIndex_page_created_languageList_shortName_4: "fr",
        tools_polishIndex_page_created_languageList_name_5: "German",
        tools_polishIndex_page_created_languageList_shortName_5: "de",
        tools_polishIndex_page_created_languageList_name_6: "Spanish",
        tools_polishIndex_page_created_languageList_shortName_6: "es",
        tools_polishIndex_page_created_languageList_name_7: "Portuguese",
        tools_polishIndex_page_created_languageList_shortName_7: "pt",
        tools_polishIndex_page_created_languageList_name_8: "Arabic",
        tools_polishIndex_page_created_languageList_shortName_8: "ar",
        tools_polishIndex_page_created_languageList_name_9: "Japanese",
        tools_polishIndex_page_created_languageList_shortName_9: "ja",
        tools_polishIndex_page_created_languageList_name_10: "Korean",
        tools_polishIndex_page_created_languageList_shortName_10: "Ko",
        tools_polishIndex_page_created_languageList_name_11: "Indonesian",
        tools_polishIndex_page_created_languageList_shortName_11: "id",
        tools_polishIndex_page_method_createPolishTask_message_1:
            "Please Enter the Text to Be Polished",
        tools_polishIndex_page_method_createPolishTask_message_2:
            "Text length cannot be less than 10 characters",
        tools_polishIndex_page_method_pollingTxtPolishResult_message_1:
            '</a>: Insufficient Traffic, <a href="/account/vip?view=char" target="_blank">Purchase More</a>',
        tools_polishIndex_page_method_clearTextInput_btnName: "Polish It",
        tools_polishIndex_page_method_addStyle_message_1:
            "Custom style already exists",
        tools_polishIndex_page_method_copyResult_message_1:
            "Copied to clipboard",
        tools_polishIndex_page_method_copyResult_message_2:
            "Failed to copy to clipboard, please try again",
        tools_polishIndex_page_method_closeUploadDocumentBtnEvent_message_1:
            "Are you sure to cancel the document being polished?",
        tools_polishIndex_page_method_closeUploadDocumentBtnEvent_message_2:
            "Are you sure to cancel the document being polished? The task has been sent to AI, and the credits will not be refunded if canceled.",
        tools_polishIndex_page_method_stopFilePolishBtnEvent_message_1:
            "Are you sure to terminate the document being polished?",
        tools_polishIndex_page_method_stopFilePolish_message_1:
            "Polishing Terminated",
        tools_polishIndex_page_method_restartFilePolish_message_1:
            "Retry successfully",
        tools_polishIndex_page_method_deleteTask_message_1:
            "Are you sure to delete this task?",
        tools_polishIndex_page_method_deleteTask_cancelButtonName_1: "Cancel",
        tools_polishIndex_page_method_deleteTaskEvent_message_1:
            "Deleted successfully",
        tools_polishIndex_page_method_beforeRouteLeave_message_1:
            "Are you sure to leave? Leaving now will terminate the current polishing task. Please return to the original tab to access other features.",
        tools_polishIndex_page_method_beforeRouteLeave_message_2: "Prompt",
        tools_polishIndex_page_method_beforeRouteLeave_confirmButtonText:
            "Leave",
        tools_polishIndex_page_method_beforeRouteLeave_cancelButtonText:
            "Cancel",
        tools_qaIndex_page_btn_1: "Dual Document",
        tools_qaIndex_page_btn_2: "Single Document",
        tools_qaIndex_page_btn_3: "Refresh",
        tools_qaIndex_page_input_placeholder_1: "Enter a name",
        tools_qaIndex_page_select_placeholder_2: "Sort by",
        tools_qaIndex_page_select_option_label_1: "Sort by time",
        tools_qaIndex_page_tips_1: "There are no tasks ~",
        tools_qaIndex_page_tips_2:
            "More than a rules-based QA, a smarter check based on semantic understanding",
        tools_qaIndex_page_dialog_1_title: "QA Check",
        tools_qaIndex_page_dialog_1_tips_1:
            "Supports pre-aligned documents, {type}, and external review formats (docx/doc)",
        tools_qaIndex_page_dialog_1_tips_2: "View sample format",
        tools_qaIndex_page_dialog_1_tips_3: ", not exceeding {size}MB",
        tools_qaIndex_page_dialog_1_tips_4:
            "Consumes traffic according to original document characters. For uploading double documents, by original document; for uploading segment to a single document, by a single document character.",
        tools_qaIndex_page_dialog_1_tips_5: "Traffic Charge Rules",
        tools_qaIndex_page_dialog_1_tips_6:
            "Supports unaligned documents, {type} format, not exceeding {size}MB",
        tools_qaIndex_page_dialog_1_tips_7: "Upload File",
        tools_qaIndex_page_dialog_1_tips_8: "Upload Source File",
        tools_qaIndex_page_dialog_1_tips_9: "Upload Translation",
        tools_qaIndex_page_dialog_1_tips_10: "Click to Switch",
        tools_qaIndex_page_dialog_1_tips_11:
            "To check for inconsistent terminology, upload a terminology list (supports {type} format)",
        tools_qaIndex_page_dialog_1_tips_12: "QA Settings",
        tools_qaIndex_page_dialog_1_tips_13: "Rule-based QA",
        tools_qaIndex_page_dialog_1_tips_14: "Intelligent QA",
        tools_qaIndex_page_dialog_1_checkbox_1: "Select All",
        tools_qaIndex_page_dialog_1_btn_1: "Upload Terminology",
        tools_qaIndex_page_dialog_1_btn_2: "Cancel",
        tools_qaIndex_page_dialog_1_btn_3: "QA Check",
        tools_qaIndex_page_data_alertInfo_message:
            "Are you sure you want to delete this task?",
        tools_qaIndex_page_data_alertInfo_buttonName: "Confirm Deletion",
        tools_qaIndex_page_data_typeRadioOptions_name_1: "Aligned",
        tools_qaIndex_page_data_typeRadioOptions_name_2: "Not Aligned",
        tools_qaIndex_page_method_startTaskEvent_message_1:
            "Please upload file",
        tools_qaIndex_page_method_startTaskEvent_message_2:
            "Upload Source File",
        tools_qaIndex_page_method_startTaskEvent_message_3:
            "Upload Target File",
        tools_qaIndex_page_method_startTaskEvent_message_4:
            "Please select the items to check",
        tools_qaIndex_page_method_startTaskEvent_message_5: "Task has started",
        tools_qaIndex_page_method_deleteTask_message_1: "Task deleted",
        tools_qaDetail_page_form_item_label_1: "Lang Direction",
        tools_qaDetail_page_form_item_label_2: "Entries",
        tools_qaDetail_page_form_item_label_3: "Created: ",
        tools_qaDetail_page_tips_1: "Entries",
        tools_qaDetail_page_tips_2: "Found a total of",
        tools_qaDetail_page_tips_3: "suspected errors",
        tools_qaDetail_page_tips_4:
            "The QA report only shows sentence segments with quality issues",
        tools_qaDetail_page_input_placeholder_1: "Enter keywords",
        tools_qaDetail_page_btn_1: "Download",
        tools_qaDetail_page_table_column_label_1: "No.",
        tools_qaDetail_page_table_column_label_2: "Source Text ({lang})",
        tools_qaDetail_page_table_column_label_3: "Target Text ({lang})",
        tools_qaDetail_page_table_column_label_4: "QA results",
        tools_qaDetailNew_page_form_item_label_1: "Lang Direction",
        tools_qaDetailNew_page_form_item_label_2: "Number of issues",
        tools_qaDetailNew_page_form_item_label_3: "Created: ",
        tools_qaDetailNew_page_tips_1: "found",
        tools_qaDetailNew_page_tips_2: "Export All",
        tools_qaDetailNew_page_tips_3: "Marked only",
        tools_qaDetailNew_page_tips_4: "Unmarked only",
        tools_qaDetailNew_page_tips_5: "Found a total of",
        tools_qaDetailNew_page_tips_6:
            "suspected errors, the QA report only shows sentence segments with quality issues",
        tools_qaDetailNew_page_tips_7: "Rule Check Failed",
        tools_qaDetailNew_page_tips_8: "Smart Check Failed",
        tools_qaDetailNew_page_tips_9: "Mark All",
        tools_qaDetailNew_page_tips_10: "Unmark All",
        tools_qaDetailNew_page_tips_11: "No error",
        tools_qaDetailNew_page_table_column_label_1:
            "Original segment position",
        tools_qaDetailNew_page_table_column_label_2: "Source Text ({lang})",
        tools_qaDetailNew_page_table_column_label_3: "Target Text ({lang})",
        tools_qaDetailNew_page_table_column_label_4: "QA",
        tools_qaDetailNew_page_table_column_label_5: "Mark",
        tools_qaDetailNew_page_table_column_label_6:
            "Original segment position",
        tools_qaDetailNew_page_table_column_label_7: "Original (Chinese)",
        tools_qaDetailNew_page_table_column_label_8: "Translation (English)",
        tools_qaDetailNew_page_table_column_label_9: "QA",
        tools_qaDetailNew_page_table_column_label_10: "Mark",
        tools_qaDetailNew_page_select_placeholder_1: "Select filter conditions",
        tools_qaDetailNew_page_select_option_lable_1:
            "Show Only Marked Sentences",
        tools_qaDetailNew_page_select_option_lable_2:
            "Show Only Unmarked Sentences",
        tools_qaDetailNew_page_btn_1: "Export Report",
        tools_termExtractionIndex_page_btn_1: "Bilingual Document",
        tools_termExtractionIndex_page_btn_2: "Monolingual Document",
        tools_termExtractionIndex_page_btn_3: "Refresh",
        tools_termExtractionIndex_page_input_placeholder_1: "Enter a name",
        tools_termExtractionIndex_page_select_placeholder_1: "Sort by",
        tools_termExtractionIndex_page_select_option_1: "Sort by time",
        tools_termExtractionIndex_page_tips_1: "There are no tasks ~",
        tools_termExtractionIndex_page_tips_2:
            "One-click Smart Term Extraction with Initial Translation",
        tools_termExtractionIndex_page_dialog_1_title: "{type} Term Extraction",
        tools_termExtractionIndex_page_dialog_1_tips_1:
            "Supports {type} format, with a maximum file size of {size} MB",
        tools_termExtractionIndex_page_dialog_1_tips_2:
            "Consumes traffic according to original document characters. For uploading double documents, by original document; for uploading segment to a single document, by a single document character.",
        tools_termExtractionIndex_page_dialog_1_tips_3: "Traffic Charge Rules",
        tools_termExtractionIndex_page_dialog_1_tips_4: "Upload Source File",
        tools_termExtractionIndex_page_dialog_1_tips_5: "Upload File",
        tools_termExtractionIndex_page_dialog_1_tips_6: "Upload Translation",
        tools_termExtractionIndex_page_dialog_1_btn_1: "Cancel",
        tools_termExtractionIndex_page_dialog_1_btn_2: "Terminology Extraction",
        tools_termExtractionIndex_page_data_alertInfo_message:
            "Are you sure you want to delete this task?",
        tools_termExtractionIndex_page_data_alertInfo_buttonName:
            "Confirm Deletion",
        tools_termExtractionIndex_page_data_typeRadioOptions_name_1:
            "Dual Document",
        tools_termExtractionIndex_page_data_typeRadioOptions_name_2:
            "Single Document",
        tools_termExtractionIndex_page_method_startTaskEvent_message_1:
            "Upload Source File",
        tools_termExtractionIndex_page_method_startTaskEvent_message_2:
            "Please upload file",
        tools_termExtractionIndex_page_method_startTaskEvent_message_3:
            "Upload Target File",
        tools_termExtractionIndex_page_method_startTaskEvent_message_4:
            "Task has started",
        tools_termExtractionIndex_page_method_deleteTask_message_1:
            "Task deleted",
        tools_termExtractionDetail_page_form_item_label_1: "Lang Direction",
        tools_termExtractionDetail_page_form_item_label_2: "Entries",
        tools_termExtractionDetail_page_form_item_label_3: "Created: ",
        tools_termExtractionDetail_page_input_placeholder_1: "Enter keywords",
        tools_termExtractionDetail_page_input_placeholder_2:
            "Enter Source Text",
        tools_termExtractionDetail_page_input_placeholder_3:
            "Enter Target Text",
        tools_termExtractionDetail_page_input_placeholder_4: "Enter remarks",
        tools_termExtractionDetail_page_tips_1: "Entries",
        tools_termExtractionDetail_page_tips_2: "Download Excel",
        tools_termExtractionDetail_page_tips_3: "Download TBX",
        tools_termExtractionDetail_page_tips_4:
            "{count} terms extracted, please modify and confirm",
        tools_termExtractionDetail_page_tips_5:
            "Frequency of term occurrence in the original text",
        tools_termExtractionDetail_page_tips_6: "Confirmation",
        tools_termExtractionDetail_page_tips_7: "Delete",
        tools_termExtractionDetail_page_tips_8: "Edit",
        tools_termExtractionDetail_page_tips_9: "Save",
        tools_termExtractionDetail_page_btn_1: "Batch Confirmation",
        tools_termExtractionDetail_page_btn_2: "Delete",
        tools_termExtractionDetail_page_btn_3: "Save to Termbase",
        tools_termExtractionDetail_page_btn_4: "Download",
        tools_termExtractionDetail_page_table_column_label_1: "No.",
        tools_termExtractionDetail_page_table_column_label_2: "Freq",
        tools_termExtractionDetail_page_table_column_label_3:
            "Source Text ({lang})",
        tools_termExtractionDetail_page_table_column_label_4:
            "Target Text ({lang})",
        tools_termExtractionDetail_page_table_column_label_5: "Remarks",
        tools_termExtractionDetail_page_table_column_label_6: "Action",
        tools_termExtractionDetail_page_dialog_1_title: "Save to Termbase",
        tools_termExtractionDetail_page_dialog_1_tips_1:
            "This action saves confirmed terms",
        tools_termExtractionDetail_page_dialog_1_form_item_label_1:
            "Termbase Name",
        tools_termExtractionDetail_page_dialog_1_form_item_label_2:
            "Select Team",
        tools_termExtractionDetail_page_dialog_1_input_placeholder_1:
            "Enter new glossary name or select existing",
        tools_termExtractionDetail_page_dialog_1_input_placeholder_2:
            "Select Team",
        tools_termExtractionDetail_page_dialog_1_btn_1: "Cancel",
        tools_termExtractionDetail_page_dialog_1_btn_2: "Save",
        tools_termExtractionDetail_page_data_alertInfo_message:
            "Delete selected term?",
        tools_termExtractionDetail_page_data_alertInfo_buttonName:
            "Confirm Deletion",
        tools_termExtractionDetail_page_data_batchAlertInfo_message:
            "Confirm all terms on this page? (Individual edits remain available)",
        tools_termExtractionDetail_page_data_batchAlertInfo_buttonName:
            "Confirmation",
        tools_termExtractionDetail_page_method_saveEditEvent_message_1:
            "Original text cannot be empty",
        tools_termExtractionDetail_page_method_saveEditEvent_message_2:
            "Translated text cannot be empty",
        tools_termExtractionDetail_page_method_saveEditEvent_message_3:
            "Saved successfully",
        tools_termExtractionDetail_page_method_saveAddEvent_message_1:
            "Original text cannot be empty",
        tools_termExtractionDetail_page_method_saveAddEvent_message_2:
            "Translated text cannot be empty",
        tools_termExtractionDetail_page_method_saveAddEvent_message_3:
            "Saved successfully",
        tools_termExtractionDetail_page_method_bathSaveEvent_message_1:
            "Batch confirmation completed\t",
        tools_termExtractionDetail_page_method_deleteConfirmEvent_message_1:
            "Deleted",
        tools_termExtractionDetail_page_method_saveToTermEvent_message_1:
            "Enter or select glossary name",
        tools_termExtractionDetail_page_method_saveToTermEvent_message_2:
            "Saved to glossary",
        tools_translationScoreIndex_page_tips_1: "Term Customization",
        tools_translationScoreIndex_page_tips_2: "Configure preferred models",
        tools_translationScoreIndex_page_tips_3: "Batch translate",
        tools_translationScoreIndex_page_tips_4: "View Model Details",
        tools_translationScoreIndex_page_tips_5:
            "Paste a paragraph and compare translations across different engines quickly. Max 5,000 chars",
        tools_translationScoreIndex_page_tips_6: "Switch",
        tools_translationScoreIndex_page_tips_7: "Try the sample",
        tools_translationScoreIndex_page_tips_8: "AI Quality Check",
        tools_translationScoreIndex_page_tips_9: "Show differences",
        tools_translationScoreIndex_page_tips_10: "Clear history",
        tools_translationScoreIndex_page_tips_11: "Score: {score}",
        tools_translationScoreIndex_page_tips_12: "Polish Again",
        tools_translationScoreIndex_page_tips_13: "Polish",
        tools_translationScoreIndex_page_tips_14:
            "Translation in progress. Please wait.",
        tools_translationScoreIndex_page_tips_15: "Polish",
        tools_translationScoreIndex_page_btn_1: "Close",
        tools_translationScoreIndex_page_btn_2: "Start configuration",
        tools_translationScoreIndex_page_btn_3: "Configure Model",
        tools_translationScoreIndex_page_btn_4: "Copy",
        tools_translationScoreIndex_page_data_domainList_name_1:
            "Frequently Used Model",
        tools_translationScoreIndex_page_data_domainList_name_2: "LLM",
        tools_translationScoreIndex_page_data_domainList_name_3: "GENERAL",
        tools_translationScoreIndex_page_data_domainList_name_4: "PERSONAL",
        tools_translationScoreIndex_page_method_startTranslateText_message_1:
            "Please select a translation model",
        tools_translationScoreIndex_page_method_startTranslateText_message_2:
            '</a>: Insufficient Traffic, <a href="/account/vip?view=char" target="_blank">Purchase More</a>',
        tools_translationScoreIndex_page_method_showTermSettingEvent_message_1:
            "Select Source Language",
        tools_translationScoreIndex_page_method_setUserConfig_message_1:
            "Terminology customization is on",
        tools_translationScoreIndex_page_method_setUserConfig_message_2:
            "Terminology customization is off",
        tools_translationScoreIndex_page_method_engineClickEvent_message_1:
            "Personalized model has been taken down due to expiration of membership, service will be restored after renewal.",
        tools_translationScoreIndex_page_method_engineClickEvent_message_2:
            'Pro-exclusive models available <a href="/account/vip">Upgrade to Pro</a>',
        tools_translationScoreIndex_page_method_polishHistoryItem_message_1:
            "Polish up to {count} times",
        tools_translationScoreIndex_page_method_copyHistoryItem_message_1:
            "Copied to clipboard",
        tools_translationScoreIndex_page_method_copyHistoryItem_message_2:
            "Failed to copy to clipboard, please try again",
        tools_videoTranslateIndex_page_tips_1: "Duration: {duration}",
        tools_videoTranslateIndex_page_tips_2:
            "Upload video for auto-translation & dubbing (Credits remaining: {size}",
        tools_videoTranslateIndex_page_tips_3:
            "Ensure the video does not violate portrait rights. Users are legally responsible for compliance.",
        tools_videoTranslateIndex_page_tips_4: "Enter Proofreading",
        tools_videoTranslateIndex_page_tips_5: "Lip-Sync: ON",
        tools_videoTranslateIndex_page_tips_6: " Lip-Sync: OFF",
        tools_videoTranslateIndex_page_tips_7: "Translation Completed",
        tools_videoTranslateIndex_page_tips_8: "TRANS_ERROR",
        tools_videoTranslateIndex_page_tips_9: "Awaiting Review",
        tools_videoTranslateIndex_page_tips_10: "Download",
        tools_videoTranslateIndex_page_tips_11: "Delete",
        tools_videoTranslateIndex_page_btn_1: "Start translating",
        tools_videoTranslateIndex_page_btn_2: "Upload Video",
        tools_videoTranslateIndex_page_btn_3: "Collapse List",
        tools_videoTranslateIndex_page_btn_4: "Expand List",
        tools_videoTranslateIndex_page_dialog_1_title: "AI Video Translation",
        tools_videoTranslateIndex_page_dialog_1_tips_1:
            "Compare with source text and polish translations using multilingual AI models for higher accuracy!",
        tools_videoTranslateIndex_page_dialog_1_tips_2:
            "*Consumes 1 extra credit",
        tools_videoTranslateIndex_page_dialog_1_tips_3: "Upload Video",
        tools_videoTranslateIndex_page_dialog_1_tips_4:
            "Supports MP4 • Max {minute} mins/{size}MB",
        tools_videoTranslateIndex_page_dialog_1_tips_5: "Source",
        tools_videoTranslateIndex_page_dialog_1_tips_6: "Target",
        tools_videoTranslateIndex_page_dialog_1_tips_7: "Lip-Sync Technology",
        tools_videoTranslateIndex_page_dialog_1_tips_8:
            "When enabled, lip movements will match target language. Recommended for close-up shots. Processing time doubles",
        tools_videoTranslateIndex_page_dialog_1_tips_9:
            "*Consumes 1 additional credit",
        tools_videoTranslateIndex_page_dialog_1_tips_10: "Translated Subtitles",
        tools_videoTranslateIndex_page_dialog_1_tips_11: "Model Selection",
        tools_videoTranslateIndex_page_dialog_1_tips_12: "Total Credits Used:",
        tools_videoTranslateIndex_page_dialog_1_tips_13:
            "Remaining Credits: {size}",
        tools_videoTranslateIndex_page_dialog_1_select_placeholder_1:
            "Select Polishing Language",
        tools_videoTranslateIndex_page_dialog_1_btn_1: "Cancel",
        tools_videoTranslateIndex_page_dialog_1_btn_2: "Start translating",
        tools_videoTranslateIndex_page_dialog_2_btn_1: "Download",
        tools_videoTranslateIndex_page_data_alertInfo_cancelButtonName:
            "Cancel",
        tools_videoTranslateIndex_page_data_typeRadioOptions_name_1:
            "AI One-Click Translation",
        tools_videoTranslateIndex_page_data_typeRadioOptions_name_2:
            "Human-Proofread Translation",
        tools_videoTranslateIndex_page_method_createTask_message_1:
            "Upload Video File",
        tools_videoTranslateIndex_page_method_uploadFileSuccess_message_1:
            "Video exceeds duration limit",
        tools_videoTranslateIndex_page_method_deleteTask_message_1:
            "Are you sure to delete this task?",
        tools_videoTranslateIndex_page_method_deleteTaskEvent_message_1:
            "Deleted successfully",
        tools_videoEditer_page_tips_1: "Auto-saving...",
        tools_videoEditer_page_tips_2: "Saved",
        tools_videoEditer_page_tips_3: "No.",
        tools_videoEditer_page_tips_4: "Source Text ({lang})",
        tools_videoEditer_page_tips_5: "Target Text ({lang})",
        tools_videoEditer_page_tips_6:
            "Editable translations must fit timeframe.\nToo long/short causes mismatched voice speed.",
        tools_videoEditer_page_tips_7: "Original Video",
        tools_videoEditer_page_tips_8:
            "Confirm final proofreading to start audio dubbing & video synthesis?",
        tools_videoEditer_page_tips_9: "Synthesize Video",
        tools_videoEditer_page_method_startTranslation_message_1:
            "Success! Returning to list in 1s...",
        tools_videoEditer_page_method_cancelTranslation_message_1:
            "Cancel Translation",
        tools_videoEditer_page_btn_1: "Synthesize Video",
        component_AccountTypes_tips_1: "Enterprise",
        component_Tabs_tab_name_1: "Alignment",
        component_Tabs_tab_name_2: "Terminology Extraction",
        component_Tabs_tab_name_3: "QA Check",
        component_Tabs_tab_name_4: "Machine Translation Detection",
        component_EngineConfig_dialog_title: "Add Frequently Used Model",
        component_EngineConfig_dialog_tips_1:
            "A maximum of {size} frequently used models can be supported",
        component_EngineConfig_dialog_btn_1: "Cancel",
        component_EngineConfig_dialog_btn_2: "Confirm",
        component_EngineConfig_method_selectEngine_message_1:
            "A maximum of {size} frequently used models can be supported",
        component_EngineConfig_method_submitBtnEvent_message_1:
            "Please select a frequently used model",
        component_EngineConfig_method_submitBtnEvent_message_2:
            "A maximum of {size} frequently used models can be supported",
        component_EngineConfig_method_submitBtnEvent_message_3:
            "Saved successfully",
        component_CardList_tips_1: "View",
        component_CardList_tips_2: "Download Excel",
        component_CardList_tips_3: "Download TMX",
        component_CardList_tips_4: "Rename",
        component_CardList_tips_5: "Delete",
        component_CardList_tips_6: "Download TBX",
        component_CardList_tips_7: "Task failed: Insufficient traffic detected",
        component_CardList_tips_8:
            "The source text and translation differ significantly",
        component_CardList_tips_9: "Please check the document before aligning",
        component_CardList_tips_10: "Task aborted",
        component_CardList_tips_11: "Delete",
        component_CardList_tips_12: "Continue",
        component_CardList_tips_13: "Purchase Character Pack",
        component_CardList_tips_14: "Retry",
        component_CardList_tips_15:
            "Each file should have no more than {size1} sentences. The original file has {size2} sentences. Please split it into {size3} parts before uploading",
        component_CardList_tips_16:
            "Click retry on this page after a successful purchase",
        component_CardList_tips_17: "Details",
        component_CardList_tips_18: "Task failed",
        component_CardList_dialog_1_title: "Rename",
        component_CardList_dialog_1_form_item_1: "Name",
        component_CardList_dialog_1_input_placeholder_1: "Enter a name",
        component_CardList_dialog_1_btn_1: "Cancel",
        component_CardList_dialog_1_btn_2: "Save",
        component_CardList_method_restartBtnEvent_message_1:
            "Retry successfully",
        component_CardList_method_saveRenameBtnEvent_message_1:
            "Please enter a name",
        component_CardList_method_saveRenameBtnEvent_message_2:
            "Rename successfully",
    },
    system: {
        slogan: "New Generation of AI Translation Platform",
        basic_left_tagline_1:
            "35 Global Translation Models for Ultimate AI Personalization",
        basic_left_tagline_2:
            "Powerful, User-Friendly AI Tools Built on Large Language Models",
        basic_left_tagline_3:
            "Streamlined Translation Management and Multi-User Collaboration",
        login_page_service_terms: "Service Agreement",
        login_page_privacy_policy: "Privacy Policy",
        login_page_title: "Login",
        login_page_form_title: "LOGIN",
        login_page_tab_phone: "Phone",
        login_page_tab_account: "Email or username",
        login_page_form_phone_placeholder: "Phone number",
        login_page_form_account_placeholder: "Email or username",
        login_page_form_password_placeholder: "Password",
        login_page_form_button: "Log in",
        login_page_link_forgot: "Forgot password",
        login_page_link_signup: "Sign up",
        login_page_link_password: "Use password",
        login_page_link_login: "Log in",
        login_page_wechat: "Use Wechat",
        login_page_wechat_title: "Log in with WeChat",
        login_page_wechat_subtitle: "Open WeChat and scan to log in",
        login_page_wechat_reload: "Refresh",
        login_page_wechat_qrcode_overdue: "QR Code Expired",
        login_page_bindphone_title: "Bind mobile number",
        login_page_bindphone_form_phone_placeholder: "Phone number",
        login_page_bindphone_form_captcha_placeholder: "Verification code",
        login_page_bindphone_form_send_captcha: "Send",
        login_page_bindphone_form_send_captcha_seconds: "s",
        login_page_form_verification_message_1:
            "Username and password cannot be empty",
        login_page_form_verification_message_2: "Phone number",
        login_page_form_verification_message_3: "Invalid phone number",
        login_page_form_verification_message_4:
            "Phone number and password cannot be empty",
        login_page_form_sent_captcha_message:
            "The verification code has been sent",
        login_page_bindphone_form_verification_message_1: "Phone number",
        login_page_bindphone_form_verification_message_2:
            "Invalid phone number",
        login_page_bindphone_form_verification_message_3: "Verification code",
        forget_page_title: "Forgot password",
        forget_page_form_title: "Forgot password",
        forget_page_form_phone_placeholder: "Phone number",
        forget_page_form_captcha_placeholder: "Verification code",
        forget_page_form_password_placeholder: "Enter new password",
        forget_page_form_button: "Confirm",
        forget_page_form_verification_message_1: "Phone number",
        forget_page_form_verification_message_2: "Invalid phone number",
        forget_page_form_verification_message_3: "Verification code",
        forget_page_form_verification_message_4: "Password",
        forget_page_form_verification_message_5:
            "The password must be between 6 to 20 characters and must contain lowercase letters and numbers",
        forget_page_form_submit_success:
            "Password changed successfully. Redirect to login page after 1s.",
        forget_page_form_sent_captcha_message:
            "The verification code has been sent",
        signup_page_title: "Sign up",
        signup_page_form_title: "Sign up with phone",
        signup_page_form_title_2: "Email registration",
        signup_page_form_phone_placeholder: "Phone number",
        signup_page_form_email_placeholder: "Please enter your email",
        signup_page_form_captcha_placeholder: "Verification code",
        signup_page_form_password_placeholder: "Password",
        signup_page_form_invite_code_placeholder: "Invitation code (optional)",
        signup_page_form_send_captcha: "Send",
        signup_page_form_send_captcha_seconds: "s",
        signup_page_form_send_captcha_tip_1:
            "Couldn't receive the verification code?",
        signup_page_form_clause_prefix: "By continuing, you agree to",
        signup_page_form_button: "Sign up",
        signup_page_form_verification_message_1: "Phone number",
        signup_page_form_verification_message_2: "Invalid phone number",
        signup_page_form_verification_message_3: "Verification code",
        signup_page_form_verification_message_4: "Password",
        signup_page_form_verification_message_5:
            "The password must be between 6 to 20 characters and must contain lowercase letters and numbers",
        signup_page_form_verification_message_6: "Please enter your email",
        signup_page_form_verification_message_7: "Invalid email address",
        signup_page_form_submit_success:
            "Successful signup, entering the system automatically after 2s.",
        signup_page_form_sent_captcha_message:
            "The verification code has been sent",
        check_page_title: "Switch to Enterprise/Education version",
        check_page_switch_header: "Switch to Enterprise/Education version",
        check_page_switch_message_1: "You are currently logging in,",
        check_page_switch_message_2: "are you sure you want to switch to",
        check_page_switch_message_3: "Enterprise/Education version?",
        check_page_switch_button_1: "Cancel",
        check_page_switch_button_2: "Confirm",
        project_index_page_title: "My Project",
        project_list_page_title: "Project details",
        project_template_page_title: "Project template",
        project_templateDetail_page_title: "Project Template Details",
        project_templateNew_page_title: "New Project Template",
        project_taskStatistics_page_title: "Project Task Stats",
        project_create_page_title: "Create New Project",
        task_list_index_page_title: "My Task",
        task_statistics_index_page_title: "Total Tasks",
        workbench_editer_page_title: "Editor",
        asset_term_index_page_title: "Termbase",
        asset_term_detail_page_title: "TB Details",
        asset_memory_index_page_title: "Translation Memory",
        asset_memory_detail_page_title: "TM Details",
        tools_page_title: "AI Toolkit",
        tools_align_index_page_title: "Alignment",
        tools_align_detail_page_title: "Alignment Details (AI)",
        tools_align_tiled_page_title: "Alignment details (Based-rule)",
        tools_termExtraction_index_page_title: "Terminology Extraction",
        tools_termExtraction_detail_page_title: "Terms extracted details",
        tools_qa_index_page_title: "QA Check",
        tools_qa_detail_page_title: "QA check details",
        tools_detector_index_page_title: "Machine Translation Detection",
        tools_detector_detail_page_title: "MT detection result",
        tools_polish_index_page_title: "AI Polish",
        tools_videoTranslate_index_page_title: "AI Video Translation",
        tools_videoTranslate_editer_page_title:
            "AI Translation & Dubbing - Subtitle Editing",
        tools_gptTranslate_index_page_title: "Document Intelligent Agent",
        tools_gptTranslate_history_page_title: "History",
        tools_translationScore_index_page_title: "AI Translation Rating",
        engine_index_page_title: "My Translation Model",
        engine_quickCreate_page_title: "Quick Training",
        engine_configNew_page_title: "Translation Model",
        engine_detail_page_title: "Model Details",
        engine_share_page_title: "Model Sharing",
        team_index_page_title: "Team Management",
        team_invite_page_title: "Invite to team",
        account_page_title: "User Center",
        account_index_page_title: "My Account",
        account_vip_page_title: "My Members",
        account_orders_page_title: "My Orders",
        account_invite_page_title: "Invite Friend",
        account_chars_page_title: "Traffic List",
        account_charHistory_page_title: "Traffic Monitor",
        account_orgInfo_page_title: "Enterprise Info",
        account_agentToken_page_title: "Agent Token",
    },
    account: {
        component_ChangeEmail_dialog_title: "Link / Change Email",
        component_ChangeEmail_dialog_placeholder_1: "Enter Email",
        component_ChangeEmail_dialog_placeholder_2:
            "Enter the verification code",
        component_ChangeEmail_dialog_tips_1: "Will be sent after {second}",
        component_ChangeEmail_dialog_tips_2: "Send verification code",
        component_ChangeEmail_dialog_btn_1: "Cancel",
        component_ChangeEmail_dialog_btn_2: "Confirm Changes",
        component_ChangeEmail_data_message_1: "Please enter email",
        component_ChangeEmail_data_message_2: "Invalid email address",
        component_ChangeEmail_data_formRules_captcha_message:
            "Please enter verification code",
        component_ChangeEmail_method_getCaptcha_message_1: "Please enter email",
        component_ChangeEmail_method_getCaptcha_message_2:
            "Invalid email address",
        component_ChangeEmail_method_getCaptcha_message_3:
            "The verification code has been sent, please check in time",
        component_ChangeEmail_method_submitChangeEmail_message_1:
            "Link / Change Email Successfully",
        component_ChangeNickname_dialog_title: "Change Nickname",
        component_ChangeNickname_dialog_placeholder_1: "Enter Nickname",
        component_ChangeNickname_dialog_btn_1: "Confirm Changes",
        component_ChangeNickname_data_formRules_message:
            "Please enter a nickname",
        component_ChangeNickname_method_submitChangeNickname_message:
            "Nickname changed successfully",
        component_ChangePassword_dialog_title: "Change Password",
        component_ChangePassword_dialog_placeholder_1: "Enter old password",
        component_ChangePassword_dialog_placeholder_2: "Enter new password",
        component_ChangePassword_dialog_placeholder_3:
            "Enter new password again",
        component_ChangePassword_dialog_btn_1: "Cancel",
        component_ChangePassword_dialog_btn_2: "Confirm",
        component_ChangePassword_data_message_1: "Please enter new password",
        component_ChangePassword_data_message_2:
            "The new password must be 6-20 digits in English letters and numbers",
        component_ChangePassword_data_message_3: "Please enter new password",
        component_ChangePassword_data_message_4:
            "The passwords entered do not match",
        component_ChangePassword_data_formRules_message:
            "Please enter the old password",
        component_ChangePassword_method_submitChangePassword_message_1:
            "Password changed",
        component_ChangePhone_dialog_title: "Link / Change phone number",
        component_ChangePhone_dialog_placeholder_1: "Enter new phone number",
        component_ChangePhone_dialog_placeholder_2:
            "Enter the verification code",
        component_ChangePhone_dialog_tips_1: "Will be sent after {second}",
        component_ChangePhone_dialog_tips_2: "Send verification code",
        component_ChangePhone_dialog_btn_1: "Cancel",
        component_ChangePhone_dialog_btn_2: "Confirm Changes",
        component_ChangePhone_data_message_1: "Enter new phone number",
        component_ChangePhone_data_formRules_message_1:
            "Please enter the verification code",
        component_ChangePhone_method_getCaptcha_message_1:
            "Please enter phone number",
        component_ChangePhone_method_getCaptcha_message_2:
            "The verification code has been sent, please check in time",
        component_ChangePhone_method_submitChangePhone_message_1:
            "Link / Change phone number Successfully",
        AccountRouter_page_created_navList_1_name: "Membership",
        AccountRouter_page_created_navList_2_name: "My Account",
        AccountRouter_page_created_navList_3_name: "Enterprise Info",
        AccountRouter_page_created_navList_4_name: "Agent Token",
        AccountRouter_page_created_navList_5_name: "My Orders",
        AccountRouter_page_created_navList_6_name: "Traffic Monitor",
        AccountRouter_page_created_navList_7_name: "Invite Friends",
        AgentToken_page_tips_1: "Agent Token",
        AgentToken_page_tips_2: "Token:",
        AgentToken_page_tips_3:
            "Intelligent agent service unavailable for character packs / membership usage. Please recharge Token credits to continue",
        AgentToken_page_tips_4: "Remaining",
        AgentToken_page_tips_5: "1 token ≈ 1 Chinese / foreign word",
        AgentToken_page_tips_6: "￥{price} RMB",
        AgentToken_page_tips_7: "Buy Now",
        AgentToken_page_tips_8: "More Tokens",
        AgentToken_page_tips_9: "Contact Us",
        CharHistory_page_tips_1: "Traffic Monitor",
        CharHistory_page_table_column_1: "Members",
        CharHistory_page_table_column_2: "Roles",
        CharHistory_page_table_column_3: "Modules",
        CharHistory_page_table_column_4: "Character Count",
        CharHistory_page_table_column_5: "Date",
        Chars_page_tips_1: "My Traffic",
        Chars_page_tips_2:
            "{remain} characters remaining / total {total} characters",
        Chars_page_btn_1: "Character Packs",
        Chars_page_table_column_1: "Effective Time",
        Chars_page_table_column_2: "Expiration Time",
        Chars_page_table_column_3: "Remaining Amount",
        Index_page_tips_1: "Basic Info",
        Index_page_tips_2: "Avatar",
        Index_page_tips_3: "Nickname",
        Index_page_tips_4: "No Nickname",
        Index_page_tips_5: "Account Management",
        Index_page_tips_6: "Mobile",
        Index_page_tips_7: "Unlinked, get better experience after linking",
        Index_page_tips_8: "Edit",
        Index_page_tips_9: "Link",
        Index_page_tips_10: "Linked, login via WeChat QR Code",
        Index_page_tips_11: "WeChat",
        Index_page_tips_12: "Unlink",
        Index_page_tips_13: "Email",
        Index_page_tips_14: "Account Password",
        Index_page_tips_15: "Set up and can log in with username and password",
        Index_page_alertDialog_message: "Are you sure you want to unlink?",
        Index_page_alertDialog_buttonName: "Confirm",
        Index_page_method_changeBindEvent_message_1:
            "Please link mobile number first",
        Index_page_method_unbindWechatConfirmEvent_message_1:
            "Unlink Successfully",
        Invite_page_tips_1: "Invite Friends, Win Character Packages",
        Invite_page_tips_2:
            "After your friend successfully registered, both of you can get 10,000 characters",
        Invite_page_tips_3: "My Invitation Record",
        Invite_page_tips_4: "You can get a maximum 200000 characters bonus",
        Invite_page_tips_5:
            "Successfully invited {person}, have got {traffics} characters bonus",
        Invite_page_tips_6:
            "Successfully registered using the invitation code {code}",
        Invite_page_tips_7: "No Invitation History",
        Invite_page_tips_8:
            "{name} invites you to register LanguageX account, click my exclusive link to register and you can get 10,000 characters: {link}; invitation code: {code}",
        Invite_page_tips_9: "Copied to clipboard",
        Invite_page_tips_10: "Failed to copy to clipboard, please try again",
        Invite_page_btn_1: "Copy Invitation Link",
        Invite_page_btn_2: "Invite Now",
        Orders_page_tips_1: "My Orders",
        Orders_page_btn_1: "Request for Invoice",
        Orders_page_table_column_1: "Order Number",
        Orders_page_table_column_2: "Order Generation Date",
        Orders_page_table_column_3: "Purchase Product",
        Orders_page_table_column_4: "Payment Type",
        Orders_page_table_column_5: "Payment Amount",
        Orders_page_table_column_6: "Order Status",
        OrgInfo_page_tips_1: "Basic Info",
        OrgInfo_page_tips_2: "Version Info",
        OrgInfo_page_tips_3: "AI Translation System MT V1.7",
        OrgInfo_page_tips_4:
            "AI Assisted Translation Project Management System TMS V1.3",
        OrgInfo_page_tips_5: "AI Independence Tool Agen V1.5",
        OrgInfo_page_tips_6: "Avatar",
        OrgInfo_page_tips_7: "Company Name",
        OrgInfo_page_tips_8: "Company Email",
        OrgInfo_page_tips_9: "Contacts",
        OrgInfo_page_tips_10: "Contact Number",
        OrgInfo_page_tips_11: "About Company",
        OrgInfo_page_tips_12: "Company profile has not been added",
        OrgInfo_page_btn_1: "Edit Info",
        OrgInfo_page_dialog_1_title: "Edit Info",
        OrgInfo_page_dialog_1_form_item_1_label: "Avatar",
        OrgInfo_page_dialog_1_form_item_2_label: "Company Name",
        OrgInfo_page_dialog_1_form_item_3_label: "Company Email",
        OrgInfo_page_dialog_1_form_item_4_label: "Contacts",
        OrgInfo_page_dialog_1_form_item_5_label: "Contact Mobile",
        OrgInfo_page_dialog_1_form_item_6_label: "About Company",
        OrgInfo_page_dialog_1_placeholder_1: "Please enter the company name",
        OrgInfo_page_dialog_1_placeholder_2: "Please enter the company email",
        OrgInfo_page_dialog_1_placeholder_3: "Please enter contact",
        OrgInfo_page_dialog_1_placeholder_4: "Please enter contact mobile",
        OrgInfo_page_dialog_1_placeholder_5: "Please enter a company profile",
        OrgInfo_page_dialog_1_btn_1: "Cancel",
        OrgInfo_page_dialog_1_btn_2: "Confirm",
        OrgInfo_page_method_submitForm_message_1:
            "Please enter the company name",
        OrgInfo_page_method_submitForm_message_2: "Please enter the contacts",
        OrgInfo_page_method_submitForm_message_3:
            "Please enter the correct phone number",
        OrgInfo_page_method_submitForm_message_4: "Please enter contact mobile",
        OrgInfo_page_method_submitForm_message_5:
            "Please enter the correct email",
        OrgInfo_page_method_submitForm_message_6: "Update Successful",
        Vip_page_tips_1: "Expires on {date}",
        Vip_page_tips_2: "Expired",
        Vip_page_tips_3: "Upgrade account for more benefits",
        Vip_page_tips_4: "Total Traffic Characters",
        Vip_page_tips_5: "{type} traffic characters + purchased character pack",
        Vip_page_tips_6: "View Details",
        Vip_page_tips_7: "No character limit",
        Vip_page_tips_8: "{surplus} characters remaining",
        Vip_page_tips_9: "Total {total} characters",
        Vip_page_tips_10: "Character Packs",
        Vip_page_tips_11: "Membership",
        Vip_page_tips_12: "Character Packs",
        Vip_page_tips_13: "Request demo",
        Vip_page_tips_14: "Under Review",
        Vip_page_tips_15: "Buy Now",
        Vip_page_tips_16: "Renew Now",
        Vip_page_tips_17: "Contact Us",
        Vip_page_tips_18: "{number}00K Characters",
        Vip_page_tips_19: "￥{price} RMB",
        Vip_page_tips_20: "Equivalent to {price} RMB/ 10K characters",
        Vip_page_tips_21: "Buy Now",
        Vip_page_tips_22: "Contact Us",
        Vip_page_tips_23: "More than 100 million words",
        Vip_page_tips_24:
            "*Documents translation, text translation, AI toolbox consumes traffic according to the number of original characters. Membership service: takes effect during a natural month (year) from the date of purchase. The traffic characters given by the system to the user are updated monthly, without passing the character package purchased by the individual user is valid for one year (",
        Vip_page_tips_25: "Learn about character usage",
        Vip_page_tips_26:
            "). LanguageX reserves the right of final interpretation.",
        Vip_page_tips_27:
            "Your current account is not linked to your phone number. Please link to continue the operation",
        Vip_page_tips_28: "Link",
        Vip_page_tips_29: "See detailed plan comparison",
        Vip_page_dialog_1_title: "Try Pro Version",
        Vip_page_dialog_1_tips_1:
            "You can have free trial for 7 days, renew it at any time during or after the trial period, If not you will return to Free version.",
        Vip_page_dialog_1_btn_1: "Cancel",
        Vip_page_dialog_1_btn_2: "Free trial",
        Vip_page_dialog_2_title: "Application Info",
        Vip_page_dialog_2_tips_1: "Application submitted successfully",
        Vip_page_dialog_2_tips_2:
            "Organizations will be created for you after approval",
        Vip_page_dialog_2_tips_3:
            "Please scan the QR code to add us on WeChat, and include your name, company/university name, and phone number in the note.",
        Vip_page_dialog_2_tips_4:
            "This information is for contact purposes only, please be sure to fill!",
        Vip_page_dialog_2_tips_5: "Please upload the application form",
        Vip_page_dialog_2_tips_6: "Download sample application form",
        Vip_page_dialog_2_tips_7: "Click to upload attachment",
        Vip_page_dialog_2_form_item_1_label: "Contacts",
        Vip_page_dialog_2_form_item_2_label: "Title",
        Vip_page_dialog_2_form_item_3_label: "Contact Mobile",
        Vip_page_dialog_2_form_item_4_label: "Email",
        Vip_page_dialog_2_form_item_5_label_1: "Organization Name",
        Vip_page_dialog_2_form_item_5_label_2: "University Name",
        Vip_page_dialog_2_form_item_6_label: "Courses",
        Vip_page_dialog_2_form_item_7_label: "Member Amount",
        Vip_page_dialog_2_form_item_8_label: "Primary Scene Using LanguageX",
        Vip_page_dialog_2_placeholder_1: "Please enter the contact",
        Vip_page_dialog_2_placeholder_2: "Please enter the title",
        Vip_page_dialog_2_placeholder_3: "Please enter the contact mobile",
        Vip_page_dialog_2_placeholder_4_1: "Please enter the company email",
        Vip_page_dialog_2_placeholder_4_2: "Please enter the university email",
        Vip_page_dialog_2_placeholder_5_1: "Please enter the organization name",
        Vip_page_dialog_2_placeholder_5_2: "Please enter the university name",
        Vip_page_dialog_2_placeholder_6: "Please enter the courses",
        Vip_page_dialog_2_placeholder_7: "Please enter the member amounts",
        Vip_page_dialog_2_placeholder_8:
            "Please enter the main scene using LanguageX",
        Vip_page_dialog_2_btn_1: "Confirm",
        Vip_page_dialog_2_btn_2: "Cancel",
        Vip_page_dialog_3_title: "Application Info",
        Vip_page_dialog_3_tips_1:
            "A trial application for the enterprise version has been successfully submitted",
        Vip_page_dialog_3_tips_2: "Contact us for urgent processing",
        Vip_page_dialog_3_btn_1: "Confirm",
        Vip_page_method_submitTrialBtnEvent_message_1: "Application Successful",
        Vip_page_method_submitContactsForm_message_1:
            "Please enter the contacts",
        Vip_page_method_submitContactsForm_message_2:
            "Please enter the contact mobile",
        Vip_page_method_submitContactsForm_message_3:
            "Please enter the correct phone number",
        Vip_page_method_submitContactsForm_message_4: "Please enter email",
        Vip_page_method_submitContactsForm_message_5:
            "Please enter the correct email",
        Vip_page_method_submitContactsForm_message_6:
            "Please enter the organization name",
        Vip_page_method_submitContactsForm_message_7:
            "Please enter the member counts",
        Vip_page_method_submitContactsForm_message_8:
            "Please enter the main scene using LanguageX",
        Vip_page_method_submitContactsForm_message_9: "Please enter the title",
        Vip_page_method_submitContactsForm_message_10:
            "Please enter the course",
        Vip_page_method_submitContactsForm_message_11:
            "Please upload the application form",
    },
    workbench: {
        editer_page_dialog_1_title: "Filter Segments",
        editer_page_dialog_1_search_input_label: "Keywords",
        editer_page_dialog_1_search_input_placeholder: "Enter keywords",
        editer_page_dialog_1_group_1_title: "Confirmation",
        editer_page_dialog_1_group_1_item_1_label: "All",
        editer_page_dialog_1_group_1_item_2_label: "Unconfirmed",
        editer_page_dialog_1_group_1_item_3_label: "Confirmed",
        editer_page_dialog_1_group_2_title: "Lock",
        editer_page_dialog_1_group_2_item_1_label: "All",
        editer_page_dialog_1_group_2_item_2_label: "Unlocked",
        editer_page_dialog_1_group_2_item_3_label: "Locked",
        editer_page_dialog_1_group_3_title: "Translation Source",
        editer_page_dialog_1_group_3_item_1_label: "All",
        editer_page_dialog_1_group_3_item_2_label: "TM",
        editer_page_dialog_1_group_3_item_3_label: "MT",
        editer_page_dialog_1_group_4_title: "QA",
        editer_page_dialog_1_group_4_item_1_label: "All",
        editer_page_dialog_1_group_4_item_2_label: "No QA Issues",
        editer_page_dialog_1_group_4_item_3_label: "with QA Issues",
        editer_page_dialog_1_group_5_title: "Comments",
        editer_page_dialog_1_group_5_item_1_label: "All",
        editer_page_dialog_1_group_5_item_2_label: "No Comments",
        editer_page_dialog_1_group_5_item_3_label: "Comments",
        editer_page_dialog_1_group_6_title: "Auto-scored",
        editer_page_dialog_1_group_6_item_1_label: "All",
        editer_page_dialog_1_group_6_item_2_label: "Low Risk",
        editer_page_dialog_1_group_6_item_3_label: "High Risk",
        editer_page_dialog_1_group_7_title: "Segment Attribute",
        editer_page_dialog_1_group_7_item_1_label: "Auto-replace",
        editer_page_dialog_1_group_7_item_2_label: "Cross-file Dupes",
        editer_page_dialog_1_group_7_item_3_label: "Untranslated elements",
        editer_page_dialog_1_group_7_item_4_label: "All",
        editer_page_dialog_1_btn_1_label: "Reset",
        editer_page_dialog_1_btn_2_label: "Confirm",
        editer_page_dialog_2_title: "Prompt",
        editer_page_dialog_2_btn_1_label: "Cancel",
        editer_page_dialog_2_btn_2_label: "Return",
        editer_page_data_loadingText: "Loading...",
        editer_page_methods_initPage_editorPermissionMessage_message:
            "No editing permissions at the moment",
        editer_page_methods_saveDocuments_success_message: "Saved successfully",
        editer_page_methods_applyJargon_error_message:
            "The current segment is locked and cannot apply terminology",
        editer_page_methods_applyTranslate_error_message:
            "The current segment is locked and cannot apply machine translation",
        editer_page_methods_applyMemory_error_message:
            "The current segment is locked and cannot apply translation memory",
        editer_page_methods_reTranslate_loadingText:
            "Retranslating all segments containing the term...",
        editer_page_methods_reTranslate_success_message_1:
            "Retranslated {size} segments where the term is located",
        editer_page_methods_reTranslate_success_message_2:
            "No terms found that require retranslation",
        editer_page_methods_setQAProblemFlag_message_1:
            "Current segment is locked, please unlock it first",
        editer_page_methods_repealOrRecoverBtnEvent_success_message_1:
            "Revoked",
        editer_page_methods_repealOrRecoverBtnEvent_success_message_2:
            "Recovered",
        editer_page_methods_setSentencesStyle_error_message:
            "Only support {types} format for setting styles",
        editer_page_methods_setSplitMode_error_message:
            "Please select a segment",
        editer_page_methods_setSplitMode_info_message:
            "The segment has entered split mode, determine the cursor position to split",
        editer_page_methods_submitSplit_error_message:
            "Splitting is not supported at the beginning or end of a sentence",
        editer_page_methods_submitSplit_success_message:
            "Segment split successfully",
        editer_page_methods_submitMarge_error_message:
            "It is already the last segment on this page, cannot merge with the next",
        editer_page_methods_submitMarge_error_message_1:
            "Please select a segment",
        editer_page_methods_submitMarge_success_message: "Segments merged",
        editer_page_methods_saveEditSource_success_message: "Source text saved",
        editer_page_methods_qaApplyReferenceEvent_error_message:
            "No editing permissions at the moment",
        editer_page_methods_startFillTags_success_message:
            "Filled {size} tags for all translated segments",
        editer_page_methods_startFillTags_loadingText_1:
            "AI tag filling in progress, please wait",
        editer_page_methods_startFillSentenceTags_error_message:
            "Translation cannot be empty",
        editer_page_methods_startFillSentenceTags_info_message:
            "Extracting original text tags and inserting them into the corresponding position in the translation",
        editer_page_methods_setTaskStatus_success_message:
            "Submitted successfully",
        editer_page_methods_setTaskStatus_loadingText:
            "Submitting, please wait",
        editer_page_methods_quickSubmit_success_message:
            "Quick confirmation successful",
        editer_page_methods_quickSubmit_loadingText:
            "Quick confirming, please wait",
        editer_page_methods_downloadStyleGuide_file_title: "Style Guide",
        editer_page_methods_getMTScoreEvent_message_1:
            "Automatic scoring is in progress. Please refresh the page later to check",
        editer_page_methods_executeAction_message_1:
            "Select a segment before editing the source text",
        editer_page_methods_executeAction_message_2:
            "The segment is in source text mode, click on the source text to edit",
        editer_page_methods_executeAction_message_3:
            "Exclusive feature of Pro version, upgrade to Pro to use.",
        editer_page_methods_executeAction_message_3_1: "Upgrade now",
        editer_page_methods_executeAction_message_4:
            "Tags cannot be filled for file types such as csv, txt, srt, etc.",
        editer_page_methods_beforeRouteLeave_warning_message:
            "Auto-saving, please wait",
        component_Tools_pageTitle_form_item_label_1: "Lang Direction",
        component_Tools_pageTitle_engine_name_1:
            "{name} provides basic translation",
        component_Tools_pageTitle_engine_name_2:
            "LanguageX provides interactive translation",
        component_Tools_pageTitle_save_tips_1: "Saving...",
        component_Tools_pageTitle_save_tips_2: "Saved",
        component_Tools_pageTitle_progress_tips: "{type} Progress: {value}%",
        component_Tools_pageTitle_changeInteractiveMode_select_placeholder:
            "Switch editing mode",
        component_Tools_pageTitle_changeInteractiveMode_select_option_1:
            "Interactive",
        component_Tools_pageTitle_changeInteractiveMode_select_option_2:
            "Post-editing",
        component_Tools_pageTitle_submitTask_btn_label: "Submit",
        component_Tools_pageTitle_rollbackTask_btn_label: "Return",
        component_Tools_pageTitle_download_btn_label_1: "Download",
        component_Tools_pageTitle_download_btn_label_2: "Target Text",
        component_Tools_pageTitle_download_btn_label_3:
            "Bilingual (Source First)",
        component_Tools_pageTitle_download_btn_label_4: "Source Text",
        component_Tools_pageTitle_download_btn_label_5: "TMX",
        component_Tools_pageTitle_download_btn_label_6:
            "Bilingual (Target First)",
        component_Tools_actionContent_btn_label_1: "Save",
        component_Tools_actionContent_btn_label_2: "Undo",
        component_Tools_actionContent_btn_label_3: "Redo",
        component_Tools_actionContent_btn_label_4: "Find/Replace",
        component_Tools_actionContent_btn_label_5: "Search Translation Memory",
        component_Tools_actionContent_btn_label_6: "Term Customization",
        component_Tools_actionContent_btn_label_7: "Fill tags",
        component_Tools_actionContent_btn_label_8: "Confirm",
        component_Tools_actionContent_btn_label_9: "Split",
        component_Tools_actionContent_btn_label_10: "Merge",
        component_Tools_actionContent_btn_label_10_title:
            "Merge next sentence into current",
        component_Tools_actionContent_btn_label_11: "Edit",
        component_Tools_actionContent_btn_label_12: "Copy Text",
        component_Tools_actionContent_btn_label_12_title:
            "Fill the current segment source text into the target text",
        component_Tools_actionContent_btn_label_13: "Copy Tag",
        component_Tools_actionContent_btn_label_13_title:
            "Fill the current segment source tags into the target text",
        component_Tools_actionContent_btn_label_14: "Get MT",
        component_Tools_actionContent_btn_label_15: "Lock",
        component_Tools_actionContent_btn_label_16: "Bold",
        component_Tools_actionContent_btn_label_17: "Italic",
        component_Tools_actionContent_btn_label_18: "Underline",
        component_Tools_actionContent_btn_label_19: "Superscript",
        component_Tools_actionContent_btn_label_20: "Subscript",
        component_Tools_actionContent_btn_label_21: "Comment",
        component_Tools_actionContent_btn_label_22: "Filter",
        component_Tools_actionContent_btn_label_23: "QA",
        component_Tools_actionContent_btn_label_24: "Style Guide",
        component_Tools_actionContent_btn_label_24_title:
            "Download Style Guide",
        component_Tools_actionContent_btn_label_25: "More Settings",
        component_Tools_actionContent_btn_label_26: "Font Size",
        component_Tools_actionContent_btn_label_27: "Shortcut Keys",
        component_Tools_actionContent_btn_label_28: "Edit History",
        component_Tools_actionContent_btn_label_29: "Click to collapse right panel",
        component_Tools_actionContent_btn_label_30: "Click to expand right panel",
        component_Tools_actionContent_btn_label_31: "Show spaces",
        component_Tools_actionContent_btn_label_32: "Hide spaces",
        component_Tools_actionContent_btn_label_33: "Auto-scored",
        component_Tools_actionContent_btn_label_34: "points",
        component_Tools_actionContent_btn_label_35: "Toggle case",
        component_Tools_actionContent_btn_label_36: "Insert non-breaking space",
        component_Tools_actionContent_case_sentence: "Sentence case",
        component_Tools_actionContent_case_upper: "UPPERCASE",
        component_Tools_actionContent_case_lower: "lowercase",
        component_Tools_actionContent_case_title: "Title Case",
        component_Tools_actionContent_case_camel: "camelCase",
        component_Tools_actionContent_case_capitalize_first: "Capitalize first",
        component_Tools_actionContent_case_lowercase_first: "lowercase first",
        editer_page_methods_toggleCase_warning_select_segment:
            "Please select the segment to edit first",
        editer_page_methods_toggleCase_warning_editable:
            "Current segment is not editable",
        editer_page_methods_toggleCase_warning_select_text:
            "Please select the text you want to convert first",
        editer_page_methods_toggleCase_warning_english_text:
            "Please select text containing English",
        component_Tools_dialog_1_title: "Task List",
        component_Tools_dialog_1_table_column_1: "Person in Charge",
        component_Tools_dialog_1_table_column_2: "Task Type",
        component_Tools_dialog_1_table_column_3: "Progress",
        component_Tools_dialog_1_table_column_4: "Status",
        component_Tools_dialog_1_table_column_5: "Return Records",
        component_Tools_dialog_1_table_message_1: "Returned {size} times",
        component_Tools_dialog_2_title: "Return Task",
        component_Tools_dialog_2_message_1: "The task will be returned to",
        component_Tools_dialog_2_message_2: "stage",
        component_Tools_dialog_2_form_item_label_1: "Reason for Return",
        component_Tools_dialog_2_form_item_placeholder_1:
            "Please fill in the reason for return",
        component_Tools_dialog_2_btn_1: "Cancel",
        component_Tools_dialog_2_btn_2: "Confirm",
        component_Tools_dialog_3_title: "Font Size",
        component_Tools_dialog_3_message_1: "Text Size",
        component_Tools_dialog_3_message_2: "Small",
        component_Tools_dialog_3_message_3: "Large",
        component_Tools_dialog_4_title: "Shortcut Keys",
        component_Tools_dialog_4_table_column_1: "Function",
        component_Tools_dialog_4_table_column_2: "Shortcut Key",
        component_Tools_data_alertInfo_message_1:
            "Switching back to interactive translation mode will retain confirmed segments and clear unconfirmed segments, continue?",
        component_Tools_data_alertInfo_message_2:
            "Switching back to interactive translation mode will retain confirmed segments and clear unconfirmed segments, continue?",
        component_Tools_data_alertInfo_message_3: "Confirm submission?",
        component_Tools_data_alertInfo_message_4:
            "Shall all segments be marked as confirmed? Empty segments will be automatically filled with machine-translated text.",
        component_Tools_data_alertInfo_buttonName_1: "Confirm",
        component_Tools_data_hotkeyList_name_1: "Select Candidate Fragments",
        component_Tools_data_hotkeyList_name_2: "Apply MT to Entire Sentence",
        component_Tools_data_hotkeyList_name_3: "Confirm Translation",
        component_Tools_data_hotkeyList_name_4: "Quick Add Term",
        component_Tools_data_hotkeyList_name_5: "Translation Memory",
        component_Tools_data_hotkeyList_name_6: "Insert Non-breaking Space",
        component_Tools_method_progressFormat_message:
            "Translator progress: {percentage}%",
        component_Tools_method_jargonSettingEvent_message_1:
            "Exclusive feature of Pro version, upgrade to Pro to use.",
        component_Tools_method_jargonSettingEvent_message_2: "Upgrade now",
        component_Tools_method_addEditFontSize_message:
            "Already at maximum size",
        component_Tools_method_shrinkEditFontSize_message:
            "Already at minimum size",
        component_Tools_method_getMTResult_message_1:
            "Manual translation, cannot obtain Machine Translation",
        component_Tools_method_getMTResult_message_2: "Please select a segment",
        component_Tools_method_rejectBtnEvent_message:
            "Cannot return at the current stage",
        component_Tools_method_submitRejectEvent_message_1:
            "Please fill in the reason for return",
        component_Tools_method_submitRejectEvent_message_2:
            "Returned successfully",
        component_BasicEditerV3_tips_1: "Click to unlock",
        component_BasicEditerV3_tips_2: "Click to lock",
        component_BasicEditerV3_tips_3: "Comment",
        component_BasicEditerV3_tips_4: "Confirm split",
        component_BasicEditerV3_tips_5: "Exit",
        component_BasicEditerV3_tips_6: "Save",
        component_BasicEditerV3_tips_7: "Exit",
        component_BasicEditerV3_tips_8: "View QA results",
        component_BasicEditerV3_tips_9: "Confirm (Enter)",
        component_BasicEditerV3_tips_10: "Confirm",
        component_BasicEditerV3_tips_11: "Machine translation may have risks",
        component_BasicEditerV3_tips_12:
            "LanguageX provides interactive translation",
        component_BasicEditerV3_tips_13: "{name} translation",
        component_BasicEditerV3_dialog_1_title: "Quick Add Term",
        component_BasicEditerV3_dialog_1_form_item_label_1: "Source Text",
        component_BasicEditerV3_dialog_1_form_item_placeholder_1:
            "Please select or enter source text",
        component_BasicEditerV3_dialog_1_form_item_label_2: "Target Text",
        component_BasicEditerV3_dialog_1_form_item_placeholder_2:
            "Please select or enter target text",
        component_BasicEditerV3_dialog_1_form_item_label_3: "Remarks",
        component_BasicEditerV3_dialog_1_form_item_placeholder_3:
            "Please enter remarks",
        component_BasicEditerV3_dialog_1_btn_1: "Cancel",
        component_BasicEditerV3_dialog_1_btn_2: "Confirm",
        component_BasicEditerV3_data_previewTypeList_name_1: "Target",
        component_BasicEditerV3_data_previewTypeList_name_2: "Bilingual",
        component_BasicEditerV3_data_previewTypeList_name_3: "Source",
        component_BasicEditerV3_data_previewTypeList_name_4: "Preview",
        component_BasicEditerV3_method_sourceTagEvent_message_1:
            "Cursor must be in the target text box",
        component_BasicEditerV3_method_sourceTagEvent_message_2:
            "The copied source text tags do not match the target text box",
        component_BasicEditerV3_method_sourceTagEvent_message_3:
            "Target text cannot be empty",
        component_BasicEditerV3_method_saveQuicklyAddTermEvent_message_1:
            "Term source text cannot be empty",
        component_BasicEditerV3_method_saveQuicklyAddTermEvent_message_2:
            "Term target text cannot be empty",
        component_BasicEditerV3_method_saveQuicklyAddTermEvent_message_3:
            "Term saved successfully",
        component_BasicEditerV3_method_getSentSourceText_message_1:
            "Repeated Segment",
        component_BasicEditerV3_method_getSentSourceText_message_2:
            "Translation Memory",
        component_BasicEditerV3_method_getSentSourceText_message_3:
            "MT Score: {score}",
        component_BasicEditerV3_method_getSentSourceText_message_4:
            "Non-translatable element",
        component_BasicEditerV3_method_getSentSourceText_message_5:
            "From {names}",
        component_BasicEditerV3_method_getSentSourceText_message_6: "points",
        component_BasicEditerV3_method_previewHtmlBtnEvent_message_1:
            "Failed to get download address",
        component_BasicEditerV3_toggle_preview_title_hide: "Click to hide preview",
        component_BasicEditerV3_toggle_preview_title_show: "Click to show preview",
        component_BasicEditerV3_method_showQAPanel_message_1:
            "No editing permissions at the moment",
        component_CommentRight_title: "Comments",
        component_CommentRight_tips_1: "Close",
        component_CommentRight_empty_message: "No comments yet",
        component_CommentRight_input_placeholder: "Enter comment",
        component_CommentRight_btn_1: "Cancel",
        component_CommentRight_btn_2: "Submit",
        component_CommentRight_tips_2: "Press Enter to send",
        component_CommentRight_data_alertInfo_message:
            "Are you sure you want to delete this comment?",
        component_CommentRight_data_alertInfo_buttonName: "Confirm",
        component_CommentRight_method_sendNewMessageEvent_message_1:
            "Please select a segment before submitting a comment",
        component_CommentRight_method_sendNewMessageEvent_message_2:
            "Please enter comment content",
        component_CommentRight_method_submitDeleteBtnEvent_message_1:
            "Comment deleted",
        component_EditerRight_tips_1: "Search in all my memories/termbases",
        component_EditerRight_tips_2: "Searching...",
        component_EditerRight_tips_3:
            "Click to insert at the target text cursor position",
        component_EditerRight_tips_4: "Remarks: ",
        component_EditerRight_tips_5: "TM Name: ",
        component_EditerRight_tips_6: "Creator: ",
        component_EditerRight_tips_7: "Created: ",
        component_EditerRight_tips_8: "{name} translation",
        component_EditerRight_tips_9: "Translating...",
        component_EditerRight_tips_10: "Last Updated: ",
        component_EditerRight_tips_11: "Last Updated by: ",
        component_EditerRight_tips_12: "Termbase Name:",
        component_EditerRight_tips_13: "Creator: ",
        component_EditerRight_tips_14: "Created: ",
        component_EditerRight_tips_15: "Last Updated: ",
        component_EditerRight_tips_16: "Last Updated by: ",
        component_EditerRight_tips_17: "Source File Name: ",
        component_EditerRight_tips_18: "Source project name: ",
        component_EditerRight_tips_19: "Source File Name: ",
        component_EditerRight_tips_20: "Updated by: ",
        component_EditerRight_btn_1: "Apply",
        component_EditerRight_chunk_title_1: "Termbase",
        component_EditerRight_chunk_title_2: "Translation Memory",
        component_EditerRight_chunk_title_3: "Machine Translation",
        component_EditerRight_chunk_title_4: "Reference Model",
        component_EditerRight_chunk_title_5: "Auto-scored",
        component_EditerRight_chunk_title_6: "Translation notes",
        component_EditerRight_chunk_title_7: "Character limit",
        component_EditerRight_chunk_title_8: "Tag Information",
        component_EditerRight_tag_expand: "Show more",
        component_EditerRight_tag_collapse: "Collapse",
        component_EditerRight_chunk_empty_message_1: "No related terms found",
        component_EditerRight_chunk_empty_message_2:
            "Paragraph splitting mode does not support translation memory queries",
        component_EditerRight_chunk_empty_message_3:
            "No related translation memory found",
        component_EditerRight_chunk_empty_message_4:
            "Paragraph splitting mode does not support machine translation queries",
        component_EditerRight_chunk_empty_message_5:
            "No other machine translation results found",
        component_EditerRight_chunk_empty_message_6: "No auto-score available",
        component_EditerRight_chunk_empty_message_7:
            "AI Quality Score (reference only)",
        component_EditerRight_chunk_empty_message_11: "No translation notes available",
        component_EditerRight_chunk_empty_message_12: "No character limit available",
        component_EditerRight_chunk_empty_message_8: "{score}; Reasons:",
        component_EditerRight_chunk_empty_message_9: "Null",
        component_EditerRight_chunk_empty_message_10:
            "{type}: {reason} (-{score})",
        component_EditRecordRight_title: "Edit History",
        component_EditRecordRight_tips_1: "Refresh",
        component_EditRecordRight_tips_2: "Close",
        component_EditRecordRight_empty_message: "No edit history yet~",
        component_FindMTRight_search_input_placeholder:
            "Search in all my memories/termbases",
        component_FindMTRight_tabs_item_1: "Translation Memory",
        component_FindMTRight_tabs_item_2: "Termbase",
        component_FindMTRight_tips_1: "Copy translation",
        component_FindMTRight_empty_message_1: "No content at the moment",
        component_FindMTRight_method_copyEvent_message_1: "Copied to clipboard",
        component_FindMTRight_method_copyEvent_message_2:
            "Failed to copy to clipboard, please try again",
        component_FindReplaceRight_title: "Find/Replace",
        component_FindReplaceRight_tips_1: "Close",
        component_FindReplaceRight_tips_2: "Click to locate",
        component_FindReplaceRight_tips_3: "Segment",
        component_FindReplaceRight_tips_4: "Click to replace",
        component_FindReplaceRight_form_item_1_label: "Find",
        component_FindReplaceRight_form_item_1_input_placeholder:
            "Enter the original text or translation to find",
        component_FindReplaceRight_form_item_2_label: "Replace with",
        component_FindReplaceRight_form_item_2_input_placeholder:
            "Enter the content to replace, can only replace translations",
        component_FindReplaceRight_form_checkbox_label: "Case sensitive",
        component_FindReplaceRight_btn_1: "Find",
        component_FindReplaceRight_btn_2: "Replace All",
        component_FindReplaceRight_btn_3: "Undo Replace",
        component_FindReplaceRight_empty_message: "No content at the moment",
        component_MenuActions_data_actionList_tip_1: "Add Term",
        component_MenuActions_data_actionList_tip_2: "Translation Memory",
        component_MenuActions_data_actionList_tip_3: "Comment",
        component_MenuActions_data_actionList_tip_4: "Bold",
        component_MenuActions_data_actionList_tip_5: "Italic",
        component_MenuActions_data_actionList_tip_6: "Underline",
        component_MenuActions_data_actionList_tip_7: "Strikethrough",
        component_MenuActions_data_actionList_tip_8: "Superscript",
        component_MenuActions_data_actionList_tip_9: "Subscript",
        component_PreviewExcel_tips_1:
            "*Preview format may differ from the final format after download",
        component_PreviewPPT_tips_1: "PPT preview is not supported",
        component_PreviewWord_tips_1:
            "*Preview format may differ from the final format after download",
        component_QARight_title: "QA Check",
        component_QARight_tips_1: "Close",
        component_QARight_tips_2: "QA Settings",
        component_QARight_tips_3: "Download Check Results",
        component_QARight_tips_4: "Ignore",
        component_QARight_tips_5: "Operator:",
        component_QARight_tips_6: "Cancel Ignore",
        component_QARight_tips_7: "Duplicate Suggestions",
        component_QARight_tips_8: "Refresh",
        component_QARight_tabs_item_1: "All",
        component_QARight_tabs_item_2: "View QA Ignore History",
        component_QARight_empty_message_1:
            "Keep up the good work~ No quality issues found in confirmed segments",
        component_QARight_empty_message_2:
            "No ignored quality issues at the moment",
        component_QARight_method_downloadQAResult_title: "{name} QA Report",
        component_QARight_method_copyQASuggestBtnEvent_message_1:
            "Copied to clipboard",
        component_QARight_method_copyQASuggestBtnEvent_message_2:
            "Failed to copy to clipboard, please try again",
        component_ReferenceEngine_dialog_title: "Change Reference Model",
        component_ReferenceEngine_dialog_btn_1: "Cancel",
        component_ReferenceEngine_dialog_btn_2: "Confirm",
    },
    config: {
        DOC_SETTING_OPTS_1_name: "Word Settings",
        DOC_SETTING_OPTS_1_options_1_label: "Translate hidden content",
        DOC_SETTING_OPTS_1_options_2_label: "Translate header and footer",
        DOC_SETTING_OPTS_1_options_3_label: "Translate annotations",
        DOC_SETTING_OPTS_1_options_4_label: "Split sentences by Tab",
        DOC_SETTING_OPTS_2_name: "Excel Settings",
        DOC_SETTING_OPTS_2_options_1_label: "Translate hidden content",
        DOC_SETTING_OPTS_2_options_2_label: "Split by paragraph",
        DOC_SETTING_OPTS_2_options_3_label: "Multi-column parsing",
        DOC_SETTING_OPTS_3_name: "PPT Settings",
        DOC_SETTING_OPTS_3_options_1_label: "Translate hidden content",
        FILE_ANALYSIS_SETTING_OPTS_1_name: "Cross-file repetitions",
        FILE_ANALYSIS_SETTING_OPTS_2_name: "Repetitions",
        FILE_ANALYSIS_SETTING_OPTS_3_name: "Non-translated elements",
        FILE_ANALYSIS_SETTING_OPTS_4_name: "100%",
        FILE_ANALYSIS_SETTING_OPTS_5_name: "101%",
        FILE_ANALYSIS_SETTING_OPTS_6_name: "102%",
        FILE_ANALYSIS_SETTING_OPTS_7_name: "Auto-replace",
        FILE_ANALYSIS_SETTING_OPTS_8_name: "Low-risk segment",
        AUTO_REPLACE_OPTS_1_name: "Number",
        AUTO_REPLACE_OPTS_2_name: "Time",
        AUTO_REPLACE_OPTS_3_name: "Date",
        AUTO_REPLACE_OPTS_4_name: "Units of measure",
        AUTO_REPLACE_OPTS_5_name: "String",
        TASK_IMPORT_ERROR_OPTS_TASK_NOT_EXIST: "Task does not exist",
        TASK_IMPORT_ERROR_OPTS_TASK_STATUS_ABNORMAL: "Task status exception",
        TASK_IMPORT_ERROR_OPTS_IMPORT_FILE_NON_EMPTY:
            "Import file parse data cannot be empty",
        TASK_IMPORT_ERROR_OPTS_FILE_TYPE_NOT_SUPPORTS: "Unsupported file type",
        TASK_IMPORT_ERROR_OPTS_FILE_UPLOAD_FAILURE: "File upload failed",
        TASK_IMPORT_ERROR_OPTS_FILE_DOES_NOT_EXIST:
            "Extract file does not exist",
        TASK_IMPORT_ERROR_OPTS_NO_AVAILABLE_DATA:
            "No valid import data performed",
        TASK_IMPORT_ERROR_OPTS_PARSE_TERM_FILE_HAS_ERROR: "Error parsing file",
        TASK_IMPORT_ERROR_OPTS_OPERATION_FAILURE: "Operation failed",
    },
    team: {
        IndexInside_page_btn_1: "Refresh",
        IndexInside_page_btn_2: "View Contact",
        IndexInside_page_placeholder_1: "Enter Name/Mobile Number/Email",
        IndexInside_page_placeholder_2: "Source",
        IndexInside_page_placeholder_3: "Target",
        IndexInside_page_placeholder_4: "Filter by Team",
        IndexInside_page_placeholder_5: "Filter by Role",
        IndexInside_page_table_column_1: "Serial number",
        IndexInside_page_table_column_2: "Name",
        IndexInside_page_table_column_3: "Role",
        IndexInside_page_table_column_4: "Language",
        IndexInside_page_table_column_5: "Team",
        IndexInside_page_table_column_6: "System Code",
        IndexInside_page_table_column_7: "Operation",
        IndexInside_page_dialog_1_title: "Contact Info",
        IndexInside_page_tips_1: "Copy",
        IndexInside_page_method_copyText_message_1: "Copied to clipboard",
        IndexInside_page_method_copyText_message_2:
            "Failed to copy to clipboard, please try again",
        IndexNew_page_tab_1: "Team",
        IndexNew_page_tab_2: "Members",
        IndexNew_page_tab_3: "Member Quote",
        IndexNew_page_tab_4: "Member Review",
        IndexNew_page_btn_1: "New Team",
        IndexNew_page_btn_2: "Refresh",
        IndexNew_page_btn_3: "New Quote",
        IndexNew_page_btn_4: "Batch Import",
        IndexNew_page_btn_5: "Invite Members",
        IndexNew_page_placeholder_1: "Enter Keywords",
        IndexNew_page_placeholder_2: "Search Teams",
        IndexNew_page_placeholder_3: "Search Roles",
        IndexNew_page_placeholder_4: "Role",
        IndexNew_page_placeholder_5: "Task Type",
        IndexNew_page_placeholder_6: "Source",
        IndexNew_page_placeholder_7: "Target",
        IndexNew_page_placeholder_8: "Price Range",
        IndexNew_page_table_column_1: "Name",
        IndexNew_page_table_column_2: "Role",
        IndexNew_page_table_column_3: "Lang Direction",
        IndexNew_page_table_column_4: "Task Type",
        IndexNew_page_table_column_5: "Task Unit Price",
        IndexNew_page_table_column_6: "Currency",
        IndexNew_page_table_column_7: "Pricing Unit",
        IndexNew_page_table_column_8: "Add Time",
        IndexNew_page_table_column_9: "Operation",
        IndexNew_page_tips_1: "Edit",
        IndexNew_page_tips_2: "Contact Info",
        IndexNew_page_tips_3: "Delete",
        IndexNew_page_tips_4: "Team Size:",
        IndexNew_page_tips_5: "Created Time:",
        IndexNew_page_tips_6: "Review",
        IndexNew_page_tips_7: "View Contact",
        IndexNew_page_tips_8: "Edit Info",
        IndexNew_page_tips_9: "Transfer",
        IndexNew_page_tips_10: "View",
        IndexNew_page_tips_11: "Edit",
        IndexNew_page_tips_12: "There are no contents ~",
        IndexNew_page_tips_13: "No content available ~",
        IndexNew_page_tips_14: "Do you really want to delete it?",
        IndexNew_page_tips_15: "Confirm Deletion",
        IndexNew_page_dialog_1_title: "Edit Members",
        IndexNew_page_dialog_1_form_label_1: "Name",
        IndexNew_page_dialog_1_form_placeholder_1: "Please enter your name",
        IndexNew_page_dialog_1_form_label_2: "Role",
        IndexNew_page_dialog_1_form_placeholder_2: "Please select a role",
        IndexNew_page_dialog_1_form_label_3: "Phone",
        IndexNew_page_dialog_1_form_placeholder_3:
            "Please enter a phone number",
        IndexNew_page_dialog_1_form_label_4: "Email",
        IndexNew_page_dialog_1_form_placeholder_4: "Please enter your email",
        IndexNew_page_dialog_1_form_label_5: "Team Owner",
        IndexNew_page_dialog_1_form_placeholder_5: "Please select a team",
        IndexNew_page_dialog_1_btn_1: "Cancel",
        IndexNew_page_dialog_1_btn_2: "Save",
        IndexNew_page_dialog_2_title: "Invite Members",
        IndexNew_page_dialog_2_tips_1:
            "Other users can request to join the team via invitation link",
        IndexNew_page_dialog_2_tips_2:
            "Become an official member after approval",
        IndexNew_page_dialog_2_placeholder_1: "Please enter contents",
        IndexNew_page_dialog_2_btn_1: "Copy Link",
        IndexNew_page_dialog_3_title: "Identity Transfer",
        IndexNew_page_dialog_3_tips_1: "Permissions changed successfully",
        IndexNew_page_dialog_3_tips_2:
            "There is only one super administrator in an organization. Please be careful",
        IndexNew_page_dialog_3_form_item_1: "Administrator transfer to",
        IndexNew_page_dialog_3_form_item_2: "Your role was changed to",
        IndexNew_page_dialog_3_placeholder_1: "Please enter keyword search",
        IndexNew_page_dialog_3_placeholder_2: "Please select your role",
        IndexNew_page_dialog_3_btn_1: "Confirm",
        IndexNew_page_dialog_3_btn_2: "Cancel",
        IndexNew_page_dialog_1_btn_3: "Transfer",
        IndexNew_page_dialog_4_title: "Reviewer",
        IndexNew_page_dialog_4_form_item_1: "Role",
        IndexNew_page_dialog_4_form_item_2: "Name",
        IndexNew_page_dialog_4_form_item_3: "Phone",
        IndexNew_page_dialog_4_form_item_4: "Email",
        IndexNew_page_dialog_4_form_item_5: "Team Owner",
        IndexNew_page_dialog_4_placeholder_1: "Select Role",
        IndexNew_page_dialog_4_placeholder_2: "Please enter your name",
        IndexNew_page_dialog_4_placeholder_3: "Please enter a phone number",
        IndexNew_page_dialog_4_placeholder_4: "Please enter your email",
        IndexNew_page_dialog_4_placeholder_5: "Select Team",
        IndexNew_page_dialog_4_btn_1: "Reject",
        IndexNew_page_dialog_4_btn_2: "Approve",
        IndexNew_page_dialog_5_title: "Contact Info",
        IndexNew_page_dialog_5_tips_1: "Copy",
        IndexNew_page_dialog_6_title_1: "Edit Team",
        IndexNew_page_dialog_6_title_2: "New Team",
        IndexNew_page_dialog_6_form_item_1: "Team Name",
        IndexNew_page_dialog_6_placeholder_1: "Please enter the team name",
        IndexNew_page_dialog_6_btn_1: "Cancel",
        IndexNew_page_dialog_6_btn_2: "Save",
        IndexNew_page_dialog_7_title_1: "Edit Member Quote",
        IndexNew_page_dialog_7_title_2: "Add Member Quote",
        IndexNew_page_dialog_7_form_item_1: "Select Member",
        IndexNew_page_dialog_7_form_item_2: "Phone",
        IndexNew_page_dialog_7_form_item_3: "Email",
        IndexNew_page_dialog_7_form_item_4: "Role",
        IndexNew_page_dialog_7_form_item_5: "Task Type",
        IndexNew_page_dialog_7_form_item_6: "Language Direction",
        IndexNew_page_dialog_7_form_item_7: "Task Unit Price",
        IndexNew_page_dialog_7_form_item_8: "Currency",
        IndexNew_page_dialog_7_form_item_9: "Pricing Unit",
        IndexNew_page_dialog_7_placeholder_1: "Autofill after member selection",
        IndexNew_page_dialog_7_placeholder_2: "Task Type",
        IndexNew_page_dialog_7_placeholder_3: "Source",
        IndexNew_page_dialog_7_placeholder_4: "Target",
        IndexNew_page_dialog_7_placeholder_5: "Enter Unit Price",
        IndexNew_page_dialog_7_placeholder_6: "Currency",
        IndexNew_page_dialog_7_placeholder_7: "Pricing Unit",
        IndexNew_page_dialog_7_btn_1: "Cancel",
        IndexNew_page_dialog_7_btn_2: "Confirm",
        IndexNew_page_dialog_8_title: "Batch Import",
        IndexNew_page_dialog_8_tips_1:
            "Quote data must be submitted in template format, please import it before",
        IndexNew_page_dialog_8_tips_2: "Download Template",
        IndexNew_page_dialog_8_btn_1: "Cancel",
        IndexNew_page_dialog_8_btn_2: "Confirm",
        IndexNew_page_method_submitEditDialogForm_message_1:
            "Please enter your name",
        IndexNew_page_method_submitEditDialogForm_message_2:
            "Please select your role",
        IndexNew_page_method_submitEditDialogForm_message_3:
            "Please enter a phone number",
        IndexNew_page_method_submitEditDialogForm_message_4:
            "Please enter a valid phone number",
        IndexNew_page_method_submitEditDialogForm_message_5:
            "Please enter an email",
        IndexNew_page_method_submitEditDialogForm_message_6:
            "Please enter a valid email",
        IndexNew_page_method_submitEditDialogForm_message_7:
            "Please select the team you belong to",
        IndexNew_page_method_submitEditDialogForm_message_8:
            "Updated Successfully",
        IndexNew_page_method_submitTransferDialogForm_message_1:
            "Please select the administrator",
        IndexNew_page_method_submitTransferDialogForm_message_2:
            "Please select the changed role",
        IndexNew_page_method_submitDeleteEvent_message_1:
            "Deleted successfully",
        IndexNew_page_method_copyText_message_1: "Copied to clipboard",
        IndexNew_page_method_copyText_message_2:
            "Failed to copy to clipboard, please try again",
        IndexNew_page_method_createTeamDialogForm_message_1:
            "Please enter the team name",
        IndexNew_page_method_createTeamDialogForm_message_2:
            "Created Successfully",
        IndexNew_page_method_copyShareLink_message_1:
            "{name} invites you to join the enterprise collaboration, click the link to log in to the LanguageX platform and apply to join the organization!\n{url}",
        IndexNew_page_method_copyShareLink_message_2: "Copied to clipboard",
        IndexNew_page_method_copyShareLink_message_3:
            "Failed to copy to clipboard, please try again",
        IndexNew_page_method_acceptApplyEvent_message_1:
            "Please select your role",
        IndexNew_page_method_acceptApplyEvent_message_2: "Please select a team",
        IndexNew_page_method_acceptApplyEvent_message_3: "Approved",
        IndexNew_page_method_refuseApplyEvent_message_1: "Rejected",
        IndexNew_page_method_deleteMemberOfferBtnEvent_message_1:
            "Deleted successfully",
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_1:
            "Please select members",
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_2:
            "Please select the task type",
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_3:
            "Please select source and target language",
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_4:
            "Please select currency",
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_5:
            "Please select a pricing unit",
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_6:
            "Updated Successfully",
        IndexNew_page_method_submitCreateMemberOfferDialogForm_message_7:
            "Created Successfully",
        IndexNew_page_method_submitImportDialogEvent_message_1:
            "Please confirm file upload is complete and successful",
        IndexNew_page_method_submitImportDialogEvent_message_2:
            "Imported Successfully",
        Invite_page_tips_1: "Personal Information",
        Invite_page_tips_2:
            "{name} invites you to join the enterprise team, Please enter the personal information and submit the application",
        Invite_page_form_item_label_1: "Name",
        Invite_page_form_item_label_2: "Phone",
        Invite_page_form_item_label_3: "Email",
        Invite_page_placeholder_1: "Enter Name",
        Invite_page_placeholder_2: "Enter Phone Number",
        Invite_page_placeholder_3: "Enter Email",
        Invite_page_btn_1: "Cancel",
        Invite_page_btn_2: "Apply to Join",
        Invite_page_dialog_1_title: "Note",
        Invite_page_dialog_1_tips_1: "Application Successful",
        Invite_page_dialog_1_tips_2: "You have applied to join {name}",
        Invite_page_dialog_1_tips_3:
            "Go to notify the company administrator for review!",
        Invite_page_dialog_1_btn_1: "OK",
        Invite_page_method_applyEvent_message_1: "Please enter your name",
        Invite_page_method_applyEvent_message_2: "Please enter your email",
        Invite_page_method_applyEvent_message_3: "Invalid email address",
    },
};
